import { openBlock, createElementBlock, createElementVNode, inject, defineComponent, useCssVars, createBlock, Transition, withCtx, renderSlot, ref, watch, computed, onUnmounted, normalizeClass, unref, Fragment, createTextVNode, toDisplayString, createVNode, withDirectives, vShow, provide, shallowRef, watchSyncEffect, resolveDynamicComponent, createCommentVNode, pushScopeId, popScopeId, reactive, markRaw, onScopeDispose, readonly, Teleport, normalizeStyle, mergeProps, toHandlers, normalizeProps, guardReactiveProps, toRefs, h, TransitionGroup, renderList, effectScope, isReactive, shallowReactive, cloneVNode, isRef, withModifiers, useSlots, useAttrs, onMounted, withKeys, createSlots, vModelCheckbox, toRef, toRaw, watchEffect } from 'vue';
import { useVModel, eagerComputed, onKeyStroke, whenever, unrefElement, templateRef, useTimeoutFn, useRafFn, useResizeObserver, debouncedWatch, onClickOutside, useToggle, useFocus, watchOnce } from '@vueuse/core';
import { not, or, and } from '@vueuse/math';
import { createFocusTrap } from 'focus-trap';
import { createPopper, placements } from '@popperjs/core';
import { get, findLast } from 'lodash-es';

const Status = {
  Info: "info",
  Success: "success",
  Warning: "warning",
  Error: "error"
};

const _hoisted_1$16 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$U = /*#__PURE__*/createElementVNode("title", null, "basic-close-24", -1);
const _hoisted_3$L = /*#__PURE__*/createElementVNode("path", { d: "M18.364 4.222l1.414 1.414-14.142 14.142-1.414-1.414 14.142-14.142z" }, null, -1);
const _hoisted_4$v = /*#__PURE__*/createElementVNode("path", { d: "M4.222 5.636l1.414-1.414 14.142 14.142-1.414 1.414-14.142-14.142z" }, null, -1);
const _hoisted_5$a = [
  _hoisted_2$U,
  _hoisted_3$L,
  _hoisted_4$v
];

function render$q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$16, _hoisted_5$a))
}

const IconClose = { render: render$q };

const _hoisted_1$15 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$T = /*#__PURE__*/createElementVNode("title", null, "basic-circle-checked-24", -1);
const _hoisted_3$K = /*#__PURE__*/createElementVNode("path", { d: "M12 23c-6.075 0-11-4.925-11-11s4.925-11 11-11c6.075 0 11 4.925 11 11s-4.925 11-11 11zM12 21c4.971 0 9-4.029 9-9s-4.029-9-9-9c-4.971 0-9 4.029-9 9s4.029 9 9 9zM15.293 8.293l-5.293 5.293-2.293-2.293-1.414 1.414 3.707 3.707 6.707-6.707-1.414-1.414z" }, null, -1);
const _hoisted_4$u = [
  _hoisted_2$T,
  _hoisted_3$K
];

function render$p(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$15, _hoisted_4$u))
}

const IconStatusSuccess = { render: render$p };

const _hoisted_1$14 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$S = /*#__PURE__*/createElementVNode("title", null, "notifications-info-24", -1);
const _hoisted_3$J = /*#__PURE__*/createElementVNode("path", { d: "M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11c0-6.075-4.925-11-11-11s-11 4.925-11 11zM21 12c0 4.971-4.029 9-9 9s-9-4.029-9-9c0-4.971 4.029-9 9-9s9 4.029 9 9zM13.004 13.998h0.999v2h-4v-2h1v-2h-1v-2h3.001v4zM13.001 7.998c0 0.552-0.448 1-1 1s-1-0.448-1-1 0.448-1 1-1c0.552 0 1 0.448 1 1z" }, null, -1);
const _hoisted_4$t = [
  _hoisted_2$S,
  _hoisted_3$J
];

function render$o(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$14, _hoisted_4$t))
}

const IconStatusInfo = { render: render$o };

const _hoisted_1$13 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$R = /*#__PURE__*/createElementVNode("title", null, "notifications-alert-triangle-24", -1);
const _hoisted_3$I = /*#__PURE__*/createElementVNode("path", { d: "M22.442 15.953l-7.005-11.976c-0.703-1.219-2.014-1.976-3.432-1.978s-2.729 0.752-3.441 1.978l-7.008 11.98c-0.727 1.222-0.743 2.753-0.039 4.002 0.704 1.25 2.023 2.027 3.458 2.039h14.038c1.45-0.014 2.766-0.789 3.471-2.038 0.703-1.247 0.688-2.775-0.041-4.007zM3.278 16.974l7.013-11.989c0.355-0.611 1.007-0.986 1.711-0.985s1.356 0.377 1.705 0.982l7.011 11.985c0.367 0.621 0.375 1.386 0.023 2.010s-1.012 1.014-1.738 1.021l-14.020-0c-0.711-0.006-1.371-0.395-1.724-1.021s-0.344-1.392 0.020-2.003zM12 17.998c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1s0.448 1 1 1zM13.004 7.998h-2.001v7h2.001v-7z" }, null, -1);
const _hoisted_4$s = [
  _hoisted_2$R,
  _hoisted_3$I
];

function render$n(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$13, _hoisted_4$s))
}

const IconStatusWarning = { render: render$n };

const _hoisted_1$12 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$Q = /*#__PURE__*/createElementVNode("title", null, "notifications-x-octagon-24", -1);
const _hoisted_3$H = /*#__PURE__*/createElementVNode("path", { d: "M16.556 1l6.444 6.444v9.113l-6.444 6.444h-9.113l-6.444-6.444v-9.113l6.444-6.444h9.113zM15.728 3h-7.456l-5.272 5.272v7.456l5.272 5.272h7.456l5.272-5.272v-7.456l-5.272-5.272zM8.707 16.707l3.293-3.293 3.293 3.293 1.414-1.414-3.293-3.293 3.293-3.293-1.414-1.414-3.293 3.293-3.293-3.293-1.414 1.414 3.293 3.293-3.293 3.293 1.414 1.414z" }, null, -1);
const _hoisted_4$r = [
  _hoisted_2$Q,
  _hoisted_3$H
];

function render$m(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$12, _hoisted_4$r))
}

const IconStatusError = { render: render$m };

const _hoisted_1$11 = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$P = /*#__PURE__*/createElementVNode("path", {
  d: "M12.866 3l9.526 16.5a1 1 0 0 1-.866 1.5H2.474a1 1 0 0 1-.866-1.5L11.134 3a1 1 0 0 1 1.732 0zM11 16v2h2v-2h-2zm0-7v5h2V9h-2z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$G = [
  _hoisted_2$P
];

function render$l(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$11, _hoisted_3$G))
}

const IconStatusWarning16 = { name: 'ri-alert-fill', render: render$l };
/* vite-plugin-components disabled */

const _hoisted_1$10 = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$O = /*#__PURE__*/createElementVNode("title", null, "status-success-clr-16", -1);
const _hoisted_3$F = /*#__PURE__*/createElementVNode("path", {
  fill: "#090",
  d: "M15 8c0 3.866-3.134 7-7 7s-7-3.134-7-7c0-3.866 3.134-7 7-7s7 3.134 7 7z"
}, null, -1);
const _hoisted_4$q = /*#__PURE__*/createElementVNode("path", {
  fill: "#fff",
  d: "M11.98 6.207l-5.207 5.207-2.753-2.753 1.414-1.414 1.338 1.338 3.793-3.793 1.414 1.414z"
}, null, -1);
const _hoisted_5$9 = [
  _hoisted_2$O,
  _hoisted_3$F,
  _hoisted_4$q
];

function render$k(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$10, _hoisted_5$9))
}

const IconStatusSuccess16 = { render: render$k };

const _hoisted_1$$ = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$N = /*#__PURE__*/createElementVNode("title", null, "status-error-ic-16", -1);
const _hoisted_3$E = /*#__PURE__*/createElementVNode("path", { d: "M8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7c3.866 0 7 3.134 7 7s-3.134 7-7 7zM9.414 8l2.293-2.293-1.414-1.414-2.293 2.293-2.293-2.293-1.414 1.414 2.293 2.293-2.293 2.293 1.414 1.414 2.293-2.293 2.293 2.293 1.414-1.414-2.293-2.293z" }, null, -1);
const _hoisted_4$p = [
  _hoisted_2$N,
  _hoisted_3$E
];

function render$j(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$$, _hoisted_4$p))
}

const IconStatusError16 = { render: render$j };

const _hoisted_1$_ = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$M = /*#__PURE__*/createElementVNode("title", null, "arrow-top-16", -1);
const _hoisted_3$D = /*#__PURE__*/createElementVNode("path", { d: "M9 5.414v8.586h-2v-8.586l-3.293 3.293-1.414-1.414 5.707-5.707 5.707 5.707-1.414 1.414-3.293-3.293z" }, null, -1);
const _hoisted_4$o = [
  _hoisted_2$M,
  _hoisted_3$D
];

function render$i(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$_, _hoisted_4$o))
}

const IconArrowTop16 = { render: render$i };

const _hoisted_1$Z = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$L = /*#__PURE__*/createElementVNode("title", null, "arrow-right-16", -1);
const _hoisted_3$C = /*#__PURE__*/createElementVNode("path", { d: "M10.586 9h-8.586v-2h8.586l-3.293-3.293 1.414-1.414 5.707 5.707-5.707 5.707-1.414-1.414 3.293-3.293z" }, null, -1);
const _hoisted_4$n = [
  _hoisted_2$L,
  _hoisted_3$C
];

function render$h(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Z, _hoisted_4$n))
}

const IconArrowRight16 = { render: render$h };

const _hoisted_1$Y = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$K = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-right-xs-24", -1);
const _hoisted_3$B = /*#__PURE__*/createElementVNode("path", { d: "M12.586 12l-3.293-3.293 1.414-1.414 4.707 4.707-4.707 4.707-1.414-1.414 3.293-3.293z" }, null, -1);
const _hoisted_4$m = [
  _hoisted_2$K,
  _hoisted_3$B
];

function render$g(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Y, _hoisted_4$m))
}

const IconArrowsChevronRightXs24 = { render: render$g };

const _hoisted_1$X = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$J = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-left-xs-24", -1);
const _hoisted_3$A = /*#__PURE__*/createElementVNode("path", { d: "M11.414 12l3.293 3.293-1.414 1.414-4.707-4.707 4.707-4.707 1.414 1.414-3.293 3.293z" }, null, -1);
const _hoisted_4$l = [
  _hoisted_2$J,
  _hoisted_3$A
];

function render$f(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$X, _hoisted_4$l))
}

const IconArrowsChevronLeftXs24 = { render: render$f };

const _hoisted_1$W = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$I = /*#__PURE__*/createElementVNode("title", null, "chevrons-right-16", -1);
const _hoisted_3$z = /*#__PURE__*/createElementVNode("path", { d: "M2.293 4.707l3.293 3.293-3.293 3.293 1.414 1.414 4.707-4.707-4.707-4.707-1.414 1.414zM7.293 4.707l3.293 3.293-3.293 3.293 1.414 1.414 4.707-4.707-4.707-4.707-1.414 1.414z" }, null, -1);
const _hoisted_4$k = [
  _hoisted_2$I,
  _hoisted_3$z
];

function render$e(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$W, _hoisted_4$k))
}

const IconChevronsRight16 = { render: render$e };

const _hoisted_1$V = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$H = /*#__PURE__*/createElementVNode("title", null, "chevrons-left-16", -1);
const _hoisted_3$y = /*#__PURE__*/createElementVNode("path", { d: "M8.707 11.293l-3.293-3.293 3.293-3.293-1.414-1.414-4.707 4.707 4.707 4.707 1.414-1.414zM13.707 11.293l-3.293-3.293 3.293-3.293-1.414-1.414-4.707 4.707 4.707 4.707 1.414-1.414z" }, null, -1);
const _hoisted_4$j = [
  _hoisted_2$H,
  _hoisted_3$y
];

function render$d(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$V, _hoisted_4$j))
}

const IconChevronsLeft16 = { render: render$d };

const _hoisted_1$U = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$G = /*#__PURE__*/createElementVNode("g", { fill: "none" }, [
  /*#__PURE__*/createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 5c-6.307 0-9.367 5.683-9.91 6.808a.435.435 0 0 0 0 .384C2.632 13.317 5.692 19 12 19s9.367-5.683 9.91-6.808a.435.435 0 0 0 0-.384C21.368 10.683 18.308 5 12 5z"
  }),
  /*#__PURE__*/createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "3",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1);
const _hoisted_3$x = [
  _hoisted_2$G
];

function render$c(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$U, _hoisted_3$x))
}

const IconEye = { name: 'majesticons-eye-line', render: render$c };
/* vite-plugin-components disabled */

const _hoisted_1$T = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$F = /*#__PURE__*/createElementVNode("g", { fill: "none" }, [
  /*#__PURE__*/createElementVNode("path", {
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M7 6.362A9.707 9.707 0 0 1 12 5c6.307 0 9.367 5.683 9.91 6.808c.06.123.06.261 0 .385c-.352.728-1.756 3.362-4.41 5.131M14 18.8a9.93 9.93 0 0 1-2 .2c-6.307 0-9.367-5.683-9.91-6.808a.44.44 0 0 1 0-.386c.219-.452.84-1.632 1.91-2.885m6 .843A3 3 0 0 1 14.236 14M3 3l18 18"
  })
], -1);
const _hoisted_3$w = [
  _hoisted_2$F
];

function render$b(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$T, _hoisted_3$w))
}

const IconEyeOff = { name: 'majesticons-eye-off-line', render: render$b };
/* vite-plugin-components disabled */

const _hoisted_1$S = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$E = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-down-rounded-24", -1);
const _hoisted_3$v = /*#__PURE__*/createElementVNode("path", { d: "M7.293 9.293c0.391-0.391 1.024-0.391 1.414 0l3.293 3.293 3.293-3.293c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-4 4c-0.39 0.39-1.024 0.39-1.414 0l-4-4c-0.391-0.39-0.391-1.024 0-1.414z" }, null, -1);
const _hoisted_4$i = [
  _hoisted_2$E,
  _hoisted_3$v
];

function render$a(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$S, _hoisted_4$i))
}

const IconArrowsChevronDownRounded24 = { render: render$a };

const _hoisted_1$R = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$D = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-right-24", -1);
const _hoisted_3$u = /*#__PURE__*/createElementVNode("path", { d: "M14.586 12l-7.293-7.293 1.414-1.414 8.707 8.707-8.707 8.707-1.414-1.414 7.293-7.293z" }, null, -1);
const _hoisted_4$h = [
  _hoisted_2$D,
  _hoisted_3$u
];

function render$9(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$R, _hoisted_4$h))
}

const IconArrowsChevronRight24 = { render: render$9 };

const _hoisted_1$Q = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$C = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-left-24", -1);
const _hoisted_3$t = /*#__PURE__*/createElementVNode("path", { d: "M9.414 12l7.293 7.293-1.414 1.414-8.707-8.707 8.707-8.707 1.414 1.414-7.293 7.293z" }, null, -1);
const _hoisted_4$g = [
  _hoisted_2$C,
  _hoisted_3$t
];

function render$8(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Q, _hoisted_4$g))
}

const IconArrowsChevronLeft24 = { render: render$8 };

const _hoisted_1$P = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$B = /*#__PURE__*/createElementVNode("title", null, "arrows-chevron-bottom-24", -1);
const _hoisted_3$s = /*#__PURE__*/createElementVNode("path", { d: "M19.293 7.293l1.414 1.414-8.707 8.707-8.707-8.707 1.414-1.414 7.293 7.293 7.293-7.293z" }, null, -1);
const _hoisted_4$f = [
  _hoisted_2$B,
  _hoisted_3$s
];

function render$7(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$P, _hoisted_4$f))
}

const IconArrowsChevronBottom24 = { render: render$7 };

const _hoisted_1$O = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$A = /*#__PURE__*/createElementVNode("title", null, "basic-check-mark-24", -1);
const _hoisted_3$r = /*#__PURE__*/createElementVNode("path", { d: "M9.707 14.293l9.293-9.293 1.414 1.414-10.707 10.707-5.707-5.707 1.414-1.414 4.293 4.293z" }, null, -1);
const _hoisted_4$e = [
  _hoisted_2$A,
  _hoisted_3$r
];

function render$6(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$O, _hoisted_4$e))
}

const IconBasicCheckMark24 = { render: render$6 };

const _hoisted_1$N = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
};
const _hoisted_2$z = /*#__PURE__*/createElementVNode("title", null, "chevron-bottom-16", -1);
const _hoisted_3$q = /*#__PURE__*/createElementVNode("path", { d: "M13.293 4.293l1.414 1.414-6.707 6.707-6.707-6.707 1.414-1.414 5.293 5.293 5.293-5.293z" }, null, -1);
const _hoisted_4$d = [
  _hoisted_2$z,
  _hoisted_3$q
];

function render$5(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$N, _hoisted_4$d))
}

const IconChevronBottom16 = { render: render$5 };

const _hoisted_1$M = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$y = /*#__PURE__*/createElementVNode("title", null, "basic-external-link-24", -1);
const _hoisted_3$p = /*#__PURE__*/createElementVNode("path", { d: "M11.704 13.707l7.293-7.293v4.586h2v-8h-8v2h4.586l-7.293 7.293 1.414 1.414zM19 19v-5h-2v5h-12v-12h5v-2h-5c-1.105 0-2 0.895-2 2v12c0 1.105 0.895 2 2 2h12c1.105 0 2-0.895 2-2z" }, null, -1);
const _hoisted_4$c = [
  _hoisted_2$y,
  _hoisted_3$p
];

function render$4(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$M, _hoisted_4$c))
}

const IconBasicExternalLink24 = { render: render$4 };

const _hoisted_1$L = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};
const _hoisted_2$x = /*#__PURE__*/createElementVNode("title", null, "basic-search-24", -1);
const _hoisted_3$o = /*#__PURE__*/createElementVNode("path", { d: "M10 18c1.849 0 3.551-0.627 4.906-1.68l5.387 5.387 1.414-1.414-5.387-5.387c1.053-1.355 1.68-3.057 1.68-4.906 0-4.418-3.582-8-8-8s-8 3.582-8 8c0 4.418 3.582 8 8 8zM16 10c0 3.314-2.686 6-6 6s-6-2.686-6-6c0-3.314 2.686-6 6-6s6 2.686 6 6z" }, null, -1);
const _hoisted_4$b = [
  _hoisted_2$x,
  _hoisted_3$o
];

function render$3(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$L, _hoisted_4$b))
}

const IconBasicSearch24 = { render: render$3 };

const STATUS_ICONS_MAP = {
  [Status.Info]: IconStatusInfo,
  [Status.Warning]: IconStatusWarning,
  [Status.Error]: IconStatusError,
  [Status.Success]: IconStatusSuccess
};
const STATUS_ICONS_MAP_16 = {
  [Status.Warning]: IconStatusWarning16,
  [Status.Error]: IconStatusError16,
  [Status.Success]: IconStatusSuccess16
};

function forceInject(key) {
  const something = inject(key);
  if (!something)
    throw new Error(`Injection of "${String(key)}" failed`);
  return something;
}
function getComponentName(comp) {
  if (typeof comp === "function") {
    const funcComponent = comp;
    return funcComponent.displayName || funcComponent.name;
  }
  return comp.name || comp.__name;
}
let incrementalCounter = 0;
function nextIncrementalCounter() {
  return incrementalCounter++;
}
function uniqueElementId() {
  return `soraui-uid-${nextIncrementalCounter()}`;
}

const ACCORDION_API_KEY = Symbol("AccordionAPI");
const useAccordionApi = () => inject(ACCORDION_API_KEY, void 0);

const __default__$3 = { name: "SCollapseTransition" };
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  ...__default__$3,
  props: {
    duration: { default: "150ms" }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "013aa2e0": _ctx.duration
    }));
    function setContentClosed(el) {
      if (el instanceof HTMLElement) {
        el.style.height = "0";
      }
    }
    function setContentOpened(el) {
      if (el instanceof HTMLElement) {
        el.style.height = el.scrollHeight + "px";
      }
    }
    function handleContentToggleEnd(el) {
      if (el instanceof HTMLElement) {
        el.style.height = "";
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, {
        name: "collapse",
        onBeforeEnter: setContentClosed,
        onEnter: setContentOpened,
        onAfterEnter: handleContentToggleEnd,
        onBeforeLeave: setContentOpened,
        onLeave: setContentClosed,
        onAfterLeave: handleContentToggleEnd
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      });
    };
  }
});

const SCollapseTransition_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$K = ["aria-expanded", "aria-controls"];
const _hoisted_2$w = { class: "s-accordion-item__head" };
const _hoisted_3$n = { class: "sora-tpg-p2" };
const _hoisted_4$a = { class: "s-accordion-item__subtitle sora-tpg-p4" };
const _hoisted_5$8 = ["id"];
const _hoisted_6$6 = { class: "s-accordion-item__body" };
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "SAccordionItem",
  props: {
    modelValue: { type: Boolean, default: false },
    title: { default: "" },
    subtitle: { default: "" },
    name: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = ref(props.modelValue);
    watch(
      () => props.modelValue,
      (origin) => {
        model.value = origin;
      }
    );
    watch(model, (dep) => {
      if (dep !== props.modelValue) {
        emit("update:modelValue", dep);
      }
    });
    const contentId = uniqueElementId();
    function toggle(expand) {
      model.value = expand ?? !model.value;
    }
    function handleTriggerClick() {
      toggle();
    }
    const groupApi = useAccordionApi();
    if (groupApi) {
      const { register, unregister } = groupApi;
      const api = computed(() => ({
        name: props.name,
        isActive: model.value,
        toggle
      }));
      register(api);
      onUnmounted(() => {
        unregister(api);
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["s-accordion-item", {
          "s-accordion-item_expanded": unref(model)
        }])
      }, [
        createElementVNode("button", {
          class: "s-accordion-item__trigger",
          "aria-expanded": unref(model),
          "aria-controls": unref(contentId),
          onClick: handleTriggerClick
        }, [
          createElementVNode("div", _hoisted_2$w, [
            createElementVNode("div", _hoisted_3$n, [
              _ctx.title ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(_ctx.title), 1)
              ], 64)) : renderSlot(_ctx.$slots, "title", { key: 1 })
            ]),
            createElementVNode("div", _hoisted_4$a, [
              _ctx.subtitle ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                createTextVNode(toDisplayString(_ctx.subtitle), 1)
              ], 64)) : renderSlot(_ctx.$slots, "subtitle", { key: 1 })
            ])
          ]),
          createVNode(unref(IconArrowsChevronDownRounded24), {
            class: "s-accordion-item__chevron",
            "aria-hidden": "true"
          })
        ], 8, _hoisted_1$K),
        createVNode(unref(_sfc_main$P), null, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              id: unref(contentId),
              class: "s-accordion-item__body-wrapper"
            }, [
              createElementVNode("div", _hoisted_6$6, [
                renderSlot(_ctx.$slots, "default")
              ])
            ], 8, _hoisted_5$8), [
              [vShow, unref(model)]
            ])
          ]),
          _: 3
        })
      ], 2);
    };
  }
});

const SAccordionItem_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$J = { class: "s-accordion" };
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "SAccordion",
  props: {
    modelValue: { default: () => [] },
    multiple: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit, { passive: true });
    const items = [];
    const itemsToOpen = computed(() => {
      return props.multiple || !model.value.length ? model.value : [model.value[0]];
    });
    watch(
      itemsToOpen,
      () => {
        items.forEach((item) => {
          updateItemState(item.value);
        });
      },
      { immediate: true }
    );
    function updateItemState(item) {
      if (!item.name)
        return;
      const isItemActive = itemsToOpen.value.includes(item.name);
      item.toggle(isItemActive);
    }
    function handleSelection(item) {
      if (!props.multiple && item.isActive) {
        items.forEach((x) => {
          if (x.value !== item)
            x.value.toggle(false);
        });
      }
    }
    const api = {
      register(item) {
        items.push(item);
        updateItemState(item.value);
        watch(item, handleSelection);
      },
      unregister(item) {
        const itemIndex = items.indexOf(item);
        if (itemIndex === -1)
          return;
        items.splice(itemIndex, 1);
      }
    };
    provide(ACCORDION_API_KEY, api);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$J, [
        renderSlot(_ctx.$slots, "default")
      ]);
    };
  }
});

const SAccordion_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$I = ["data-status"];
const _hoisted_2$v = { class: "s-alert__icon-wrapper" };
const _hoisted_3$m = { class: "flex-1" };
const _hoisted_4$9 = { class: "sora-tpg-h5" };
const _hoisted_5$7 = { class: "sora-tpg-p3" };
const _hoisted_6$5 = {
  key: 0,
  class: "s-alert__close-wrapper"
};
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "SAlert",
  props: {
    inline: { type: Boolean },
    status: { default: Status.Info },
    showCloseBtn: { type: Boolean, default: false },
    title: {},
    description: {}
  },
  emits: ["click:close"],
  setup(__props, { emit }) {
    const props = __props;
    const StatusIcon = shallowRef();
    watchSyncEffect(() => {
      StatusIcon.value = STATUS_ICONS_MAP[props.status];
    });
    function onClickClose() {
      emit("click:close");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["s-alert", { "s-alert_inline": _ctx.inline }]),
        "data-status": _ctx.status
      }, [
        createElementVNode("div", _hoisted_2$v, [
          (openBlock(), createBlock(resolveDynamicComponent(unref(StatusIcon))))
        ]),
        createElementVNode("div", _hoisted_3$m, [
          createElementVNode("div", _hoisted_4$9, [
            renderSlot(_ctx.$slots, "title", {}, () => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ])
          ]),
          createElementVNode("div", _hoisted_5$7, [
            renderSlot(_ctx.$slots, "description", {}, () => [
              createTextVNode(toDisplayString(_ctx.description), 1)
            ])
          ])
        ]),
        _ctx.showCloseBtn ? (openBlock(), createElementBlock("div", _hoisted_6$5, [
          createElementVNode("button", { onClick: onClickClose }, [
            createVNode(unref(IconClose))
          ])
        ])) : createCommentVNode("", true)
      ], 10, _hoisted_1$I);
    };
  }
});

const SAlert_vue_vue_type_style_index_0_lang = '';

const _withScopeId = (n) => (pushScopeId("data-v-b244ad8e"), n = n(), popScopeId(), n);
const _hoisted_1$H = { viewBox: "0 0 50 50" };
const _hoisted_2$u = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("circle", {
  cx: "25",
  cy: "25",
  r: "20",
  fill: "none",
  "stroke-width": "5"
}, null, -1));
const _hoisted_3$l = [
  _hoisted_2$u
];
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "SSpinner",
  props: {
    size: { default: "1em" },
    width: { default: 5 }
  },
  setup(__props) {
    const props = __props;
    useCssVars((_ctx) => ({
      "44120f1a": unref(sizeNorm),
      "0d455870": _ctx.width
    }));
    const sizeNorm = eagerComputed(() => {
      if (typeof props.size === "number" || !Number.isNaN(Number(props.size))) {
        return `${props.size}px`;
      }
      return props.size;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("svg", _hoisted_1$H, _hoisted_3$l);
    };
  }
});

const SSpinner_vue_vue_type_style_index_0_scoped_b244ad8e_lang = '';

const _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};

const SSpinner = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["__scopeId", "data-v-b244ad8e"]]);

const formatToLog = (value) => typeof value === "string" ? `'${value}'` : JSON.stringify(value);
function usePropTypeFilter(props) {
  return function(name, validValues, defaultValue) {
    return computed(() => {
      if (validValues.includes(props[name])) {
        return props[name];
      }
      const formattedList = validValues.map(formatToLog).join(" | ");
      const formattedValue = formatToLog(props[name]);
      console.warn(
        `[soramitsu-ui warn]: Invalid prop: type check failed for prop "${String(
          name
        )}". Expected: ${formattedList}, got ${formattedValue}`
      );
      return defaultValue;
    });
  };
}

const BUTTON_TYPE_VALUES = ["primary", "secondary", "outline", "action"];
const BUTTON_SIZE_VALUES = ["xs", "sm", "md", "lg"];
const BUTTON_ICON_POSITION_VALUES = ["left", "right"];
const SPINNER_SIZE = {
  xs: "12",
  sm: "18",
  md: "24",
  lg: "24"
};
const SPINNER_WIDTH = {
  xs: "3",
  sm: "4",
  md: "4",
  lg: "4"
};
const FONT_SIZE = {
  xs: "sora-tpg-p4",
  sm: "sora-tpg-h7",
  md: "sora-tpg-h6",
  lg: "sora-tpg-h5"
};

const _hoisted_1$G = ["type", "disabled"];
const _hoisted_2$t = { class: "s-button__icon" };
const _hoisted_3$k = { class: "s-button__text" };
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "SButton",
  props: {
    type: { default: "secondary" },
    size: { default: "md" },
    nativeType: { default: "button" },
    icon: { default: "" },
    iconPosition: { default: "left" },
    rounded: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    uppercase: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const filterProp = usePropTypeFilter(props);
    const definitelyType = filterProp("type", BUTTON_TYPE_VALUES, "primary");
    const definitelySize = filterProp("size", BUTTON_SIZE_VALUES, "md");
    const definitelyIconPosition = filterProp("iconPosition", BUTTON_ICON_POSITION_VALUES, "left");
    const isAction = computed(() => definitelyType.value === "action");
    const font = computed(() => {
      if (definitelySize.value === "xs" && props.uppercase) {
        return "sora-tpg-ch3";
      }
      return FONT_SIZE[definitelySize.value];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        type: _ctx.nativeType,
        class: normalizeClass([
          "s-button",
          `s-button_type_${unref(definitelyType)}`,
          `s-button_size_${unref(definitelySize)}`,
          `s-button_icon-position_${unref(definitelyIconPosition)}`,
          unref(font),
          {
            "s-button_disabled": _ctx.loading || _ctx.disabled,
            "s-button_rounded": unref(isAction) && _ctx.rounded,
            "s-button_loading": _ctx.loading
          }
        ]),
        disabled: _ctx.loading || _ctx.disabled
      }, [
        _ctx.loading ? (openBlock(), createBlock(unref(SSpinner), {
          key: 0,
          class: "flex-grow absolute",
          size: unref(SPINNER_SIZE)[unref(definitelySize)],
          width: unref(SPINNER_WIDTH)[unref(definitelySize)]
        }, null, 8, ["size", "width"])) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_2$t, [
          _ctx.icon ? (openBlock(), createElementBlock("i", {
            key: 0,
            class: normalizeClass(_ctx.icon)
          }, null, 2)) : renderSlot(_ctx.$slots, "icon", { key: 1 })
        ]),
        createElementVNode("span", _hoisted_3$k, [
          !unref(isAction) ? renderSlot(_ctx.$slots, "default", { key: 0 }) : createCommentVNode("", true)
        ])
      ], 10, _hoisted_1$G);
    };
  }
});

const SButton_vue_vue_type_style_index_0_lang = '';

const LINK_UNDERLINE_TYPE_VALUES = ["solid", "dotted"];
const LINK_ICON_POSITION_VALUES = ["left", "right"];

const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "SLink",
  props: {
    underline: { default: "solid" },
    iconPosition: { default: "right" },
    icon: { type: Boolean, default: true },
    tag: { default: "a" }
  },
  setup(__props) {
    const props = __props;
    const propFilter = usePropTypeFilter(props);
    const definitelyUnderlineType = propFilter("underline", LINK_UNDERLINE_TYPE_VALUES, "solid");
    const definitelyIconPosition = propFilter("iconPosition", LINK_ICON_POSITION_VALUES, "right");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        class: normalizeClass([
          "s-link",
          `s-link_type_${unref(definitelyUnderlineType)}`,
          `s-link_icon-position_${unref(definitelyIconPosition)}`,
          "sora-tpg-p3"
        ])
      }, {
        default: withCtx(() => [
          createElementVNode("span", null, [
            renderSlot(_ctx.$slots, "default")
          ]),
          _ctx.icon ? renderSlot(_ctx.$slots, "icon", {
            key: 0,
            class: normalizeClass("s-link__icon")
          }, () => [
            createVNode(unref(IconBasicExternalLink24), { class: "s-link__icon" })
          ]) : createCommentVNode("", true)
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});

const SLink_vue_vue_type_style_index_0_lang = '';

function normalizeTransitionAttrs(something) {
  if (!something)
    return null;
  if (typeof something === "string")
    return { name: something };
  return something;
}
function useCloseOnEsc(active, closeCb) {
  onKeyStroke("Escape", () => {
    if (active.value) {
      closeCb();
    }
  });
}
const VisibilityState = {
  Hidden: "hidden",
  Entering: "entering",
  Visible: "visible",
  Leaving: "leaving"
};
function createVisibilityReactiveState(keys) {
  return reactive(Object.fromEntries(keys.map((key) => [key, VisibilityState.Hidden])));
}
function useVisibilityState(keys) {
  const state = createVisibilityReactiveState(keys);
  function toggle(key, value) {
    state[key] = value;
  }
  return { state, toggle };
}
function createTransitionVisibilityListeners(key, toggle) {
  return {
    beforeEnter: () => toggle(key, VisibilityState.Entering),
    afterEnter: () => toggle(key, VisibilityState.Visible),
    beforeLeave: () => toggle(key, VisibilityState.Leaving),
    afterLeave: () => toggle(key, VisibilityState.Hidden)
  };
}
function useModalVisibility({
  show,
  eager,
  emit,
  overlayEnabled
}) {
  const { toggle, state } = useVisibilityState(["modal", "overlay"]);
  const allHidden = computed(() => state.modal === VisibilityState.Hidden && state.overlay === VisibilityState.Hidden);
  const allVisible = computed(
    () => state.modal === VisibilityState.Visible && state.overlay === VisibilityState.Visible
  );
  const notAllHidden = not(allHidden);
  watch(
    show,
    (value) => {
      if (value)
        emit("before-open");
      else
        emit("before-close");
    },
    { flush: "pre" }
  );
  whenever(allVisible, () => emit("after-open"));
  whenever(allHidden, () => emit("after-close"));
  const rootIf = or(eager, show, notAllHidden);
  const rootShow = or(show, notAllHidden);
  const modalIf = or(eager, show);
  const modalShow = show;
  const modalTransitionAppear = !(eager.value && !show.value);
  const overlayIf = and(show, overlayEnabled);
  return {
    toggleFragmentVisibility: toggle,
    rootIf,
    rootShow,
    modalIf,
    modalShow,
    modalTransitionAppear,
    overlayIf,
    overlayTransitionListeners: createTransitionVisibilityListeners("overlay", toggle),
    modalTransitionListeners: createTransitionVisibilityListeners("modal", toggle)
  };
}

const MODAL_API_KEY = Symbol("ModalAPI");
function useModalApi() {
  return forceInject(MODAL_API_KEY);
}

function useFocusTrap(params) {
  const trap = shallowRef(null);
  const elem = computed(() => unrefElement(params.elem));
  watch(
    elem,
    (el) => {
      const tr = trap.value;
      if (el) {
        if (tr) {
          tr.updateContainerElements(el);
        } else {
          const newTrap = markRaw(createFocusTrap(el, params.options));
          trap.value = newTrap;
        }
      } else if (tr) {
        tr.deactivate();
        trap.value = null;
      }
    },
    { immediate: true }
  );
  onScopeDispose(() => {
    trap.value?.deactivate();
  });
  return { trap };
}

const BODY_SCROLL_LOCK_API_KEY = Symbol("SBodyScrollLockApi");
const SBodyScrollLockProvider = /* @__PURE__ */ defineComponent({
  name: "SBodyScrollLockProvider",
  props: {
    api: {
      type: Object,
      required: true
    }
  },
  setup(props, { slots }) {
    provide(BODY_SCROLL_LOCK_API_KEY, props.api);
    return () => slots.default?.();
  }
});
function useBodyScrollLockIfPossible(target) {
  const api = inject(BODY_SCROLL_LOCK_API_KEY, void 0);
  if (!api)
    return;
  const targetNormalized = computed(() => unrefElement(target));
  watch(
    targetNormalized,
    (elem, prevElem) => {
      if (prevElem) {
        api.unlock(prevElem);
      }
      if (elem) {
        api.lock(elem);
      }
    },
    { immediate: true }
  );
  onScopeDispose(() => {
    const elem = targetNormalized.value;
    elem && api.unlock(elem);
  });
}

const _hoisted_1$F = ["data-absolute"];
const _hoisted_2$s = ["aria-labelledby", "aria-describedby"];
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "SModal",
  props: {
    show: { type: Boolean },
    teleportTo: { default: "body" },
    absolute: { type: Boolean },
    rootClass: {},
    modalClass: {},
    overlayClass: {},
    rootStyle: {},
    modalStyle: {},
    overlayStyle: {},
    modalTransition: { default: "s-modal__modal-transition" },
    overlayTransition: { default: "s-modal__overlay-transition" },
    lockScroll: { type: Boolean, default: true },
    showOverlay: { type: Boolean, default: true },
    closeOnOverlayClick: { type: Boolean, default: true },
    closeOnEsc: { type: Boolean, default: true },
    focusTrap: { type: [Boolean, Object], default: true },
    eager: { type: Boolean, default: false },
    labelledBy: { default: uniqueElementId },
    describedBy: { default: null }
  },
  emits: ["update:show", "click:overlay", "before-open", "after-open", "before-close", "after-close"],
  setup(__props, { emit }) {
    const props = __props;
    const showModel = useVModel(props, "show", emit);
    const eager = computed(() => props.eager);
    const showOverlay = computed(() => props.showOverlay);
    function close() {
      showModel.value = false;
    }
    const modalRef = templateRef("modal");
    const rootRef = templateRef("root");
    const overlayTransitionAttrs = computed(() => normalizeTransitionAttrs(props.overlayTransition));
    const modalTransitionAttrs = computed(() => normalizeTransitionAttrs(props.modalTransition));
    const {
      rootIf,
      rootShow,
      modalIf,
      modalShow,
      overlayIf,
      overlayTransitionListeners,
      modalTransitionListeners,
      modalTransitionAppear
    } = useModalVisibility({
      show: showModel,
      overlayEnabled: showOverlay,
      eager,
      emit
    });
    let focusTrapRef = null;
    if (props.focusTrap) {
      const options = props.focusTrap === true ? {} : props.focusTrap;
      const focusTrapTarget = shallowRef(null);
      watch(
        [modalShow, rootRef],
        ([val, el]) => {
          focusTrapTarget.value = val ? el ?? null : null;
        },
        {
          // edge case: eager rendering, modal is "display: none". `tabbable` throws an error
          // because contents are hidden yet. Post flush fixes it.
          flush: "post"
        }
      );
      ({ trap: focusTrapRef } = useFocusTrap({
        elem: focusTrapTarget,
        options: {
          ...options,
          escapeDeactivates(event) {
            if (typeof options.escapeDeactivates === "function") {
              return options.escapeDeactivates(event);
            }
            return props.closeOnEsc ? true : false;
          }
        }
      }));
      watch(
        focusTrapRef,
        (trap) => {
          try {
            trap?.activate();
          } catch (err) {
            console.warn(
              "[SModal] focus-trap activation is failed. Does your modal contain any tabbable node?\nTip: you can disable focus-trap completely by setting `focus-trap` prop to `false`\n\nOriginal error:\n\n%o",
              err
            );
            throw err;
          }
        },
        { immediate: true }
      );
    }
    useBodyScrollLockIfPossible(computed(() => props.lockScroll ? unref(modalRef) : null));
    const api = readonly({
      close,
      focusTrap: focusTrapRef,
      labelledBy: computed(() => props.labelledBy),
      describedBy: computed(() => props.describedBy)
    });
    provide(MODAL_API_KEY, api);
    function onOverlayClick() {
      emit("click:overlay");
      if (props.closeOnOverlayClick) {
        showModel.value = false;
      }
    }
    useCloseOnEsc(
      computed(() => showModel.value && props.closeOnEsc),
      close
    );
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, {
        to: _ctx.teleportTo,
        disabled: _ctx.teleportTo === null
      }, [
        unref(rootIf) ? withDirectives((openBlock(), createElementBlock("div", {
          key: 0,
          ref: "root",
          class: normalizeClass(["s-modal__root", _ctx.rootClass]),
          style: normalizeStyle(_ctx.rootStyle),
          "data-absolute": _ctx.absolute
        }, [
          createVNode(Transition, mergeProps({ appear: "" }, unref(overlayTransitionAttrs), toHandlers(unref(overlayTransitionListeners))), {
            default: withCtx(() => [
              unref(overlayIf) ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(["s-modal__overlay", _ctx.overlayClass]),
                style: normalizeStyle(_ctx.overlayStyle),
                onClick: onOverlayClick
              }, null, 6)) : createCommentVNode("", true)
            ]),
            _: 1
          }, 16),
          createVNode(Transition, mergeProps({ appear: unref(modalTransitionAppear) }, unref(modalTransitionAttrs), toHandlers(unref(modalTransitionListeners))), {
            default: withCtx(() => [
              unref(modalIf) ? withDirectives((openBlock(), createElementBlock("div", {
                key: 0,
                ref: "modal",
                style: normalizeStyle(_ctx.modalStyle),
                class: normalizeClass(["s-modal__modal", _ctx.modalClass]),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": _ctx.labelledBy,
                "aria-describedby": _ctx.describedBy || ""
              }, [
                renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps(unref(api))))
              ], 14, _hoisted_2$s)), [
                [vShow, unref(modalShow)]
              ]) : createCommentVNode("", true)
            ]),
            _: 3
          }, 16, ["appear"])
        ], 14, _hoisted_1$F)), [
          [vShow, unref(rootShow)]
        ]) : createCommentVNode("", true)
      ], 8, ["to", "disabled"]);
    };
  }
});

const SModal_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$E = { class: "s-modal-card" };
const _hoisted_2$r = { class: "s-modal-card__header flex items-center" };
const _hoisted_3$j = ["id"];
const _hoisted_4$8 = { class: "s-modal-card__content px-6 py-8 flex flex-col flex-grow min-h-0" };
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "SModalCard",
  props: {
    title: {},
    close: { type: Boolean, default: true }
  },
  setup(__props) {
    const api = useModalApi();
    function closeClick() {
      api.close();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$E, [
        createElementVNode("div", _hoisted_2$r, [
          createElementVNode("h2", {
            id: unref(api).labelledBy,
            class: "sora-tpg-h4-bold flex-1"
          }, [
            renderSlot(_ctx.$slots, "title", {}, () => [
              createTextVNode(toDisplayString(_ctx.title), 1)
            ])
          ], 8, _hoisted_3$j),
          _ctx.close ? (openBlock(), createBlock(unref(_sfc_main$K), {
            key: 0,
            type: "action",
            size: "sm",
            onClick: closeClick
          }, {
            icon: withCtx(() => [
              createVNode(unref(IconClose))
            ]),
            _: 1
          })) : createCommentVNode("", true)
        ]),
        createElementVNode("div", _hoisted_4$8, [
          renderSlot(_ctx.$slots, "default")
        ])
      ]);
    };
  }
});

const SModalCard_vue_vue_type_style_index_0_lang = '';

const NOTIFICATIONS_API_KEY = Symbol("NotificationsToastsAPI");

const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "SNotificationBodyTimeline",
  props: {
    timeout: {}
  },
  emits: ["timeout"],
  setup(__props, { emit }) {
    const props = __props;
    const { timeout } = toRefs(props);
    let timestamps = null;
    const timeoutProgress = ref(0);
    const {
      start: startTimeout,
      stop: stopTimeout,
      isPending
    } = useTimeoutFn(
      () => {
        timestamps = null;
        emit("timeout");
      },
      timeout,
      { immediate: false }
    );
    const { pause: pauseUpdate, resume: resumeUpdate } = useRafFn(
      () => {
        if (timestamps) {
          const [begin, end] = timestamps;
          const now = performance.now();
          timeoutProgress.value = Math.max(0, Math.min(1, (now - begin) / (end - begin)));
        } else {
          timeoutProgress.value = 0;
          pauseUpdate();
        }
      },
      { immediate: false }
    );
    watch(
      timeout,
      (val) => {
        stopTimeout();
        timestamps = null;
        if (val) {
          const now = performance.now();
          timestamps = [now, now + val];
          startTimeout();
          resumeUpdate();
        }
      },
      { immediate: true }
    );
    const styleRight = computed(() => `${timeoutProgress.value * 100}%`);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, { name: "s-notification-body-timeline__transition" }, {
        default: withCtx(() => [
          unref(isPending) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "s-notification-body-timeline",
            style: normalizeStyle({ "right": unref(styleRight) })
          }, null, 4)) : createCommentVNode("", true)
        ]),
        _: 1
      });
    };
  }
});

const SNotificationBodyTimeline_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$D = ["data-status"];
const _hoisted_2$q = { class: "flex space-x-4" };
const _hoisted_3$i = { class: "s-notification-body__icon-wrapper" };
const _hoisted_4$7 = { class: "flex-1" };
const _hoisted_5$6 = { class: "sora-tpg-p2" };
const _hoisted_6$4 = { class: "sora-tpg-p4" };
const _hoisted_7$3 = { class: "s-notification-body__close-wrapper" };
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "SNotificationBody",
  props: {
    title: {},
    description: {},
    status: { default: Status.Info },
    timeout: { default: 0 },
    showCloseBtn: { type: Boolean }
  },
  emits: ["click:close", "timeout"],
  setup(__props, { emit }) {
    const props = __props;
    const StatusIcon = computed(() => STATUS_ICONS_MAP[props.status]);
    function onClickClose() {
      emit("click:close");
    }
    function onTimeout() {
      emit("timeout");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "s-notification-body",
        "data-status": _ctx.status
      }, [
        createElementVNode("div", _hoisted_2$q, [
          createElementVNode("div", _hoisted_3$i, [
            (openBlock(), createBlock(resolveDynamicComponent(unref(StatusIcon))))
          ]),
          createElementVNode("div", _hoisted_4$7, [
            createElementVNode("div", _hoisted_5$6, [
              renderSlot(_ctx.$slots, "title", {}, () => [
                createTextVNode(toDisplayString(_ctx.title), 1)
              ])
            ]),
            createElementVNode("div", _hoisted_6$4, [
              renderSlot(_ctx.$slots, "description", {}, () => [
                createTextVNode(toDisplayString(_ctx.description), 1)
              ])
            ])
          ]),
          createElementVNode("div", _hoisted_7$3, [
            _ctx.showCloseBtn ? (openBlock(), createElementBlock("button", {
              key: 0,
              onClick: onClickClose
            }, [
              createVNode(unref(IconClose))
            ])) : createCommentVNode("", true)
          ])
        ]),
        createVNode(_sfc_main$G, {
          timeout: _ctx.timeout,
          onTimeout
        }, null, 8, ["timeout"])
      ], 8, _hoisted_1$D);
    };
  }
});

const SNotificationBody_vue_vue_type_style_index_0_lang = '';

function useNotifications() {
  const toasts = forceInject(NOTIFICATIONS_API_KEY);
  return {
    show: (params) => {
      function onClickClose() {
        unreg();
      }
      function onTimeout() {
        unreg();
      }
      const unreg = toasts.register({
        slot: () => h(
          _sfc_main$F,
          {
            title: unref(params.title),
            description: unref(params.description),
            status: unref(params.status),
            timeout: unref(params.timeout) ?? 5e3,
            showCloseBtn: unref(params.showCloseBtn),
            "onClick:close": onClickClose,
            onTimeout
          },
          {
            title: params.titleSlot,
            description: params.descriptionSlot
          }
        )
      });
      return {
        close: unreg
      };
    }
  };
}

const VERTICAL = /* @__PURE__ */ new Set(["bottom", "top"]);
const HORIZONTAL = /* @__PURE__ */ new Set(["left", "right", "center"]);
function validateVerticalPlacement(x) {
  return VERTICAL.has(x);
}
function validateHorizontalPlacement(x) {
  return HORIZONTAL.has(x);
}

const TOASTS_API_KEY = Symbol("ToastsAPI");
function defineToastsApi() {
  const toastsMap = reactive(/* @__PURE__ */ new Map());
  let keysCounter = 0;
  const register = (params) => {
    const key = keysCounter++;
    toastsMap.set(key, params);
    return () => {
      toastsMap.delete(key);
    };
  };
  const toasts = computed(() => [...toastsMap]);
  return readonly({
    register,
    toasts
  });
}

const _hoisted_1$C = ["data-placement-v", "data-placement-h", "data-absolute"];
const _hoisted_2$p = { class: "s-toasts-display__stack" };
const _hoisted_3$h = /* @__PURE__ */ createElementVNode("div", { class: "s-toasts-display__item-spacer" }, null, -1);
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "SToastsDisplay",
  props: {
    vertical: {
      type: String,
      default: "bottom",
      validate: validateVerticalPlacement
    },
    horizontal: {
      type: String,
      default: "left",
      validate: validateHorizontalPlacement
    },
    absolute: Boolean,
    /**
     * Where to teleport it
     */
    to: {
      type: String,
      default: "body"
    },
    apiKey: {
      type: [String, Symbol],
      default: TOASTS_API_KEY
    }
  },
  setup(__props) {
    const props = __props;
    const api = forceInject(props.apiKey);
    function leave(element) {
      const height = getComputedStyle(element).height;
      element.style.height = height;
      getComputedStyle(element).height;
      requestAnimationFrame(() => {
        element.style.height = "0";
      });
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, {
        to: __props.to,
        disabled: !__props.to
      }, [
        createElementVNode("div", {
          class: "s-toasts-display",
          "data-placement-v": __props.vertical,
          "data-placement-h": __props.horizontal,
          "data-absolute": __props.absolute
        }, [
          createElementVNode("div", _hoisted_2$p, [
            createVNode(TransitionGroup, {
              name: "s-toasts-display__grow-transition",
              onLeave: leave
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(api).toasts, ([key, toast]) => {
                  return openBlock(), createElementBlock("div", {
                    key,
                    class: "s-toasts-display__item"
                  }, [
                    _hoisted_3$h,
                    (openBlock(), createBlock(resolveDynamicComponent(toast.slot)))
                  ]);
                }), 128))
              ]),
              _: 1
            }, 8, ["onLeave"])
          ])
        ], 8, _hoisted_1$C)
      ], 8, ["to", "disabled"]);
    };
  }
});

const SToastsDisplay_vue_vue_type_style_index_0_lang = '';

function* iterKeys(baseKey, additional) {
  yield baseKey;
  if (Array.isArray(additional)) {
    for (const x of additional)
      yield x;
  } else {
    yield additional;
  }
}
const SToastsProvider = /* @__PURE__ */ defineComponent({
  name: "SToastsProvider",
  props: {
    /**
     * Non-reactive key(s) to use to provide the API (additional to the base `TOASTS_API_KEY`)
     */
    apiKey: {
      type: [String, Symbol, Array],
      default: null
    }
  },
  setup(props, { slots }) {
    const api = defineToastsApi();
    for (const key of iterKeys(TOASTS_API_KEY, props.apiKey)) {
      provide(key, api);
    }
    return () => slots.default?.();
  }
});

const component$1 = (props, { slots }) => h(
  SToastsProvider,
  {
    apiKey: NOTIFICATIONS_API_KEY
  },
  {
    default: () => [
      h(_sfc_main$E, {
        // reactivity is lost if props are not spreaded
        ...props
      }),
      slots.default?.()
    ]
  }
);
component$1.props = {
  // no need in validators - placements will be validates in the display component
  vertical: { type: String },
  horizontal: { type: String },
  absolute: Boolean,
  to: String
};
component$1.displayName = "SNotificationsProvider";

function useConditionalScope(enabled, scopeSetupFn) {
  let scope = null;
  function setupScope() {
    scope = effectScope();
    scope.run(scopeSetupFn);
  }
  function stopScope() {
    scope?.stop();
  }
  watch(
    enabled,
    (flag) => {
      if (flag) {
        setupScope();
      } else {
        stopScope();
      }
    },
    { immediate: true }
  );
  onScopeDispose(stopScope);
}

const SUseNotification = /* @__PURE__ */ defineComponent({
  name: "SUseNotification",
  props: {
    show: Boolean,
    title: String,
    status: {
      type: String,
      default: Status.Info
    },
    timeout: {
      type: Number,
      default: 5e3
    },
    showCloseBtn: Boolean,
    description: String
  },
  emits: ["update:show", "click:close", "timeout"],
  setup(props, { emit, slots }) {
    const show = useVModel(props, "show", emit);
    const toasts = forceInject(NOTIFICATIONS_API_KEY);
    function onTimeout() {
      show.value = false;
      emit("timeout");
    }
    function onClickClose() {
      show.value = false;
      emit("click:close");
    }
    useConditionalScope(show, () => {
      const unreg = toasts.register({
        slot: () => {
          const { show: _show, ...rest } = props;
          return h(
            _sfc_main$F,
            {
              ...rest,
              "onClick:close": onClickClose,
              onTimeout
            },
            slots
          );
        }
      });
      onScopeDispose(unreg);
    });
    return () => null;
  }
});

function usePopper(params) {
  const elemReference = computed(() => unref(params.referenceElem));
  const elemPopper = computed(() => unref(params.popperElem));
  const opts = params.options || {};
  const instance = shallowRef(null);
  function init(reference, popper) {
    instance.value = markRaw(params.callbackInit?.(reference, popper) ?? createPopper(reference, popper, unref(opts)));
  }
  function destroy() {
    instance.value && (params.callbackDestroy ? params.callbackDestroy(instance.value) : instance.value.destroy());
  }
  watch(
    [elemReference, elemPopper],
    ([a, b]) => {
      destroy();
      a && b && init(a, b);
    },
    { immediate: true }
  );
  onScopeDispose(destroy);
  if (isReactive(opts)) {
    watch(
      opts,
      (updated) => {
        if (instance.value) {
          instance.value.setOptions(unref(updated));
        }
      },
      { deep: true }
    );
  }
  return { instance };
}

const POPOVER_API_KEY = Symbol("PopoverAPI");
const usePopoverApi = () => forceInject(POPOVER_API_KEY);

function useDelayNumberGreaterThanOrEqualToZero(reactiveGetter) {
  return computed(() => {
    const val = reactiveGetter();
    const num = typeof val === "number" ? val : Number(val);
    return Math.max(0, num);
  });
}
function useNumberCast(reactiveGetter) {
  return computed(() => Number(reactiveGetter()));
}
function useDelayedShow(show, delays) {
  const delayed = ref(show.value);
  debouncedWatch(
    show,
    (flag) => {
      if (flag) {
        delayed.value = true;
      }
    },
    { debounce: delays.show }
  );
  debouncedWatch(
    not(show),
    (flag) => {
      if (flag) {
        delayed.value = false;
      }
    },
    { debounce: delays.hide }
  );
  return delayed;
}
function createSanitizedTemplateRef() {
  const rawRef = ref(null);
  const sanitizedRef = eagerComputed(() => {
    const el = unrefElement(rawRef);
    if (el && el instanceof HTMLElement)
      return el;
    return null;
  });
  return { rawRef, sanitizedRef };
}
function useElHover(elemRef) {
  const hover = ref(false);
  watch(elemRef, (el, oldEl) => {
    if (oldEl)
      hover.value = false;
  });
  return {
    hover,
    listeners: {
      onMouseenter: () => {
        hover.value = true;
      },
      onMouseleave: () => {
        hover.value = false;
      }
    }
  };
}
function defineReadonlyApi(raw) {
  const api = reactive(raw);
  return readonly(api);
}
const SPopover = /* @__PURE__ */ defineComponent({
  name: "SPopover",
  props: {
    show: Boolean,
    trigger: {
      type: String,
      default: "hover",
      validator: (v) => v === "manual" || v === "hover" || v === "click"
    },
    placement: {
      type: String,
      default: "auto",
      validator: (v) => placements.includes(v)
    },
    skidding: {
      type: [Number, String],
      default: 0
    },
    distance: {
      type: [Number, String],
      default: 0
    },
    showDelay: {
      type: [Number, String],
      default: 0
    },
    hideDelay: {
      type: [Number, String],
      default: 0
    },
    sameWidth: Boolean
  },
  emits: ["update:show", "click-outside"],
  setup(props, { slots, emit }) {
    const showDelay = useDelayNumberGreaterThanOrEqualToZero(() => props.showDelay);
    const hideDelay = useDelayNumberGreaterThanOrEqualToZero(() => props.hideDelay);
    const skidding = useNumberCast(() => props.skidding);
    const distance = useNumberCast(() => props.distance);
    const { rawRef: triggerRawRef, sanitizedRef: triggerRef } = createSanitizedTemplateRef();
    const { rawRef: popperRawRef, sanitizedRef: popperNativeRef } = createSanitizedTemplateRef();
    const popperRefOverrides = reactive(/* @__PURE__ */ new Set());
    const somePopperRefOverride = computed(() => {
      if (popperRefOverrides.size) {
        for (const i of popperRefOverrides)
          return i;
      }
      return null;
    });
    const popperRef = eagerComputed(() => somePopperRefOverride.value || popperNativeRef.value);
    const { instance } = usePopper({
      referenceElem: triggerRef,
      popperElem: popperRef,
      options: reactive({
        placement: computed(() => props.placement),
        modifiers: [
          {
            name: "offset",
            options: { offset: computed(() => [skidding.value, distance.value]) }
          },
          shallowReactive({
            name: "sameWidth",
            enabled: props.sameWidth,
            phase: "beforeWrite",
            requires: ["computeStyles"],
            fn: ({ state }) => {
              state.styles.popper.width = `${state.rects.reference.width}px`;
            },
            effect: ({ state }) => {
              if (state.elements.reference instanceof HTMLElement) {
                state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
              }
            }
          })
        ]
      })
    });
    const show = useVModel(props, "show", emit, { passive: true });
    const showDelayed = useDelayedShow(show, { show: showDelay, hide: hideDelay });
    const showFinal = showDelayed;
    const { hover: triggerHover, listeners: triggerHoverListeners } = useElHover(triggerRef);
    const { hover: popperHover, listeners: popperHoverListeners } = useElHover(popperRef);
    const sharedHover = or(triggerHover, popperHover);
    useResizeObserver(triggerRef, () => {
      instance.value?.update();
    });
    debouncedWatch(
      () => props.trigger === "hover" && [sharedHover.value],
      (maybeHover) => {
        if (maybeHover) {
          const [val] = maybeHover;
          show.value = val;
        }
      },
      { debounce: 50 }
    );
    function onTriggerClick() {
      if (props.trigger === "click") {
        show.value = !show.value;
      }
    }
    onClickOutside(popperRef, (ev) => {
      const doesPathIncludeTrigger = ev.composedPath().includes(unrefElement(triggerRef));
      if (!doesPathIncludeTrigger) {
        emit("click-outside");
        if (props.trigger === "click") {
          show.value = false;
        }
      }
    });
    const api = defineReadonlyApi({
      show: showFinal,
      popper: instance,
      addPopperRefOverride: (el) => popperRefOverrides.add(el),
      deletePopperRefOverride: (el) => popperRefOverrides.delete(el)
    });
    provide(POPOVER_API_KEY, api);
    return () => {
      let trigger;
      {
        if (!slots.trigger) {
          throw new Error('"trigger" slot is required');
        }
        const nodes = slots.trigger();
        if (nodes.length !== 1) {
          throw new Error('"trigger" slot should render exact 1 element');
        }
        [trigger] = nodes;
      }
      let popper;
      if (!slots.popper) {
        popper = null;
      } else {
        const nodes = slots.popper(api);
        if (!nodes.length) {
          popper = null;
        } else if (nodes.length === 1) {
          [popper] = nodes;
        } else {
          throw new Error('"popper" slot should return either nothing or the only 1 element');
        }
      }
      return [
        cloneVNode(
          trigger,
          {
            ref: triggerRawRef,
            ...triggerHoverListeners,
            onClick: onTriggerClick
          },
          true
        ),
        popper && cloneVNode(
          popper,
          {
            ref: popperRawRef,
            ...popperHoverListeners
          },
          true
        )
      ];
    };
  }
});

function useWrappedTransitionVisibility({ show, eager }) {
  const isContentMounted = ref(false);
  const wrapperIf = eagerComputed(() => eager.value || show.value || isContentMounted.value);
  const wrapperShow = eagerComputed(() => !eager.value || isContentMounted.value || show.value);
  const contentIf = eagerComputed(() => eager.value || show.value);
  const contentShow = eagerComputed(() => !eager.value || show.value);
  const transitionAppear = !(eager.value && !show.value);
  const onContentBeforeEnter = () => {
    isContentMounted.value = true;
  };
  const onContentAfterLeave = () => {
    isContentMounted.value = false;
  };
  return {
    wrapperIf,
    wrapperShow,
    contentIf,
    contentShow,
    transitionProps: {
      appear: transitionAppear,
      onBeforeEnter: onContentBeforeEnter,
      onAfterLeave: onContentAfterLeave
    }
  };
}

const __default__$2 = {
  inheritAttrs: false
};
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  ...__default__$2,
  __name: "SPopoverWrappedTransition",
  props: {
    eager: Boolean,
    wrapperAttrs: {
      type: Object,
      default: null
    },
    innerWrapperAttrs: {
      type: Object,
      default: null
    }
  },
  setup(__props) {
    const props = __props;
    const api = usePopoverApi();
    const { wrapperIf, wrapperShow, contentIf, contentShow, transitionProps } = useWrappedTransitionVisibility({
      show: computed(() => api.show),
      eager: computed(() => props.eager)
    });
    function onEnter() {
      api.popper?.update();
    }
    const wrapper = templateRef("wrapper");
    const wrapperNormalized = eagerComputed(() => unrefElement(wrapper));
    watch(wrapperNormalized, (el, oldEl) => {
      if (oldEl)
        api.deletePopperRefOverride(oldEl);
      if (el)
        api.addPopperRefOverride(el);
    });
    onScopeDispose(() => {
      const el = wrapperNormalized.value;
      el && api.deletePopperRefOverride(el);
    });
    return (_ctx, _cache) => {
      return unref(wrapperIf) ? withDirectives((openBlock(), createElementBlock("div", mergeProps({
        key: 0,
        ref_key: "wrapper",
        ref: wrapper
      }, __props.wrapperAttrs), [
        createVNode(Transition, mergeProps(mergeProps(_ctx.$attrs, unref(transitionProps)), { onEnter }), {
          default: withCtx(() => [
            unref(contentIf) ? withDirectives((openBlock(), createElementBlock("span", normalizeProps(mergeProps({ key: 0 }, __props.innerWrapperAttrs)), [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ], 16)), [
              [vShow, unref(contentShow)]
            ]) : createCommentVNode("", true)
          ]),
          _: 3
        }, 16)
      ], 16)), [
        [vShow, unref(wrapperShow)]
      ]) : createCommentVNode("", true);
    };
  }
});

const SPopoverWrappedTransition_vue_vue_type_style_index_0_scoped_8d257694_lang = '';

const SPopoverWrappedTransition = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["__scopeId", "data-v-8d257694"]]);

const SelectSize = {
  Sm: "sm",
  Md: "md",
  Lg: "lg",
  Xl: "xl"
};
const SelectButtonType = {
  Default: "default",
  Inline: "inline"
  // TODO append in future
  // Icon = 'icon'
};
const SelectOptionType = {
  Radio: "radio",
  Checkbox: "checkbox",
  Default: "default"
};

function isSelectOptions(options) {
  return options.length === 0 || "label" in options[0];
}

function useSelectModel({
  multiple,
  model,
  options,
  singleModeAutoClose,
  onAutoClose,
  storeSelectedOptions
}) {
  const triggerAutoClose = () => singleModeAutoClose.value && onAutoClose();
  const modelAsArray = computed(() => {
    const val = model.value;
    if (Array.isArray(val))
      return val;
    if (val !== null)
      return [val];
    return [];
  });
  const selectedSet = computed(() => {
    return new Set(modelAsArray.value);
  });
  const optionItems = computed(() => {
    if (isSelectOptions(options.value)) {
      return options.value;
    }
    return options.value.flatMap((x) => x.items);
  });
  const storedOptions = shallowReactive(/* @__PURE__ */ new Map());
  let modelChangedManually = false;
  watch(
    modelAsArray,
    () => {
      if (modelChangedManually) {
        modelChangedManually = false;
        return;
      }
      if (!storeSelectedOptions.value) {
        return;
      }
      storedOptions.forEach((_, value) => {
        if (!modelAsArray.value.includes(value)) {
          storedOptions.delete(value);
        }
      });
      modelAsArray.value.forEach(rememberOption);
    },
    { immediate: true, flush: "sync" }
  );
  function rememberOption(value) {
    if (storedOptions.has(value)) {
      return;
    }
    const option = optionItems.value.find((x) => x.value === value);
    if (option) {
      storedOptions.set(option.value, option);
      return;
    }
    storedOptions.set(value, { label: "", value });
  }
  function forgetOption(value) {
    storedOptions.delete(value);
  }
  function isValueSelected(value) {
    return selectedSet.value.has(value);
  }
  function isGroupSelected(optionGroup) {
    return optionGroup.items.every((x) => isValueSelected(x.value));
  }
  function select(value) {
    if (multiple.value) {
      modelChangedManually = true;
      model.value = [.../* @__PURE__ */ new Set([...modelAsArray.value, value])];
      if (storeSelectedOptions.value) {
        rememberOption(value);
      }
    } else {
      modelChangedManually = true;
      if (storeSelectedOptions.value) {
        let oldValue = Array.isArray(model.value) ? model.value[0] : model.value;
        if (oldValue) {
          forgetOption(oldValue);
        }
      }
      model.value = value;
      if (storeSelectedOptions.value) {
        rememberOption(value);
      }
      triggerAutoClose();
    }
  }
  function unselect(value) {
    if (multiple.value) {
      modelChangedManually = true;
      model.value = modelAsArray.value.filter((x) => x !== value);
      if (storeSelectedOptions.value) {
        forgetOption(value);
      }
    } else {
      modelChangedManually = true;
      model.value = null;
      if (storeSelectedOptions.value) {
        forgetOption(value);
      }
      triggerAutoClose();
    }
  }
  function toggleSelection(value) {
    isValueSelected(value) ? unselect(value) : select(value);
  }
  function toggleGroupSelection(optionGroup) {
    const optionGroupValues = optionGroup.items.map((x) => x.value);
    if (isGroupSelected(optionGroup)) {
      const optionGroupSet = new Set(optionGroupValues);
      const newModel2 = modelAsArray.value.filter((x) => !optionGroupSet.has(x));
      modelChangedManually = true;
      model.value = newModel2;
      if (storeSelectedOptions.value) {
        newModel2.forEach(forgetOption);
      }
      return;
    }
    const newModel = [.../* @__PURE__ */ new Set([...modelAsArray.value, ...optionGroupValues])];
    modelChangedManually = true;
    model.value = newModel;
    if (storeSelectedOptions.value) {
      newModel.forEach(rememberOption);
    }
  }
  const selectedOptions = computed(() => {
    if (storeSelectedOptions.value) {
      return [...storedOptions.values()];
    }
    return optionItems.value.filter((x) => isValueSelected(x.value));
  });
  const isSomethingSelected = computed(() => !!selectedSet.value.size);
  const isModelAnArray = computed(() => Array.isArray(model.value));
  function modelFromSingleToMultiple() {
    const current = model.value;
    model.value = current === null ? [] : [current];
  }
  function modelFromMultipleToSingle() {
    const current = model.value;
    model.value = current.length ? current[0] : null;
  }
  whenever(and(isModelAnArray, not(multiple)), modelFromMultipleToSingle, { immediate: true });
  whenever(and(not(isModelAnArray), multiple), modelFromSingleToMultiple, { immediate: true });
  return {
    isValueSelected,
    selectedOptions,
    toggleSelection,
    toggleGroupSelection,
    select,
    unselect,
    isSomethingSelected,
    isGroupSelected
  };
}

const SELECT_API_KEY = Symbol("SelectAPI");
function useSelectApi() {
  return forceInject(SELECT_API_KEY);
}

const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "SSelectBase",
  props: {
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    modelValue: { default: null },
    options: { default: () => [] },
    size: { default: SelectSize.Md },
    label: { default: null },
    mandatory: { type: Boolean },
    syncMenuAndInputWidths: { type: Boolean, default: false },
    noAutoClose: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    sameWidthPopper: { type: Boolean, default: false },
    triggerSearch: { type: Boolean, default: false },
    dropdownSearch: { type: Boolean, default: false },
    remoteSearch: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "search"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit);
    const { multiple, disabled, loading, options, size, label, noAutoClose, remoteSearch } = toRefs(props);
    const modeling = useSelectModel({
      model,
      multiple,
      options,
      storeSelectedOptions: remoteSearch,
      singleModeAutoClose: not(noAutoClose),
      onAutoClose: () => togglePopper(false)
    });
    const [showPopper, togglePopper] = useToggle(false);
    whenever(and(disabled, showPopper), () => togglePopper(false), { immediate: true });
    const searchQuery = ref("");
    whenever(not(showPopper), () => {
      updateSearchQuery("");
    });
    function updateSearchQuery(query) {
      searchQuery.value = query;
      emit("search", searchQuery.value);
    }
    const api = reactive({
      ...modeling,
      multiple,
      options,
      disabled,
      loading,
      label,
      isMenuOpened: showPopper,
      menuToggle: togglePopper,
      size,
      noAutoClose,
      searchQuery,
      remoteSearch,
      updateSearchQuery
    });
    provide(SELECT_API_KEY, api);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [
        createVNode(unref(SPopover), {
          show: unref(showPopper),
          "onUpdate:show": _cache[0] || (_cache[0] = ($event) => isRef(showPopper) ? showPopper.value = $event : null),
          "same-width": _ctx.sameWidthPopper,
          placement: "bottom-start",
          trigger: "manual",
          distance: "4",
          onClickOutside: _cache[1] || (_cache[1] = ($event) => unref(togglePopper)(false))
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", null, [
              renderSlot(_ctx.$slots, "control", normalizeProps(guardReactiveProps({ "search": _ctx.triggerSearch })))
            ])
          ]),
          popper: withCtx(() => [
            createVNode(unref(SPopoverWrappedTransition), {
              name: "s-select-dropdown-transition",
              eager: "",
              "wrapper-attrs": { "class": "z-10" },
              "inner-wrapper-attrs": { "class": { "w-full": _ctx.sameWidthPopper } }
            }, {
              default: withCtx(() => [
                renderSlot(_ctx.$slots, "dropdown", normalizeProps(guardReactiveProps({ "search": _ctx.dropdownSearch })))
              ]),
              _: 3
            }, 8, ["inner-wrapper-attrs"])
          ]),
          _: 3
        }, 8, ["show", "same-width"])
      ]);
    };
  }
});

const SSelectBase_vue_vue_type_style_index_0_lang = '';

const SSelectChevron = '';

const component = ({ rotate, variant }) => h(variant === 24 ? IconArrowsChevronBottom24 : IconChevronBottom16, {
  class: [
    "s-select-chevron",
    {
      "s-select-chevron_rotate": rotate
    }
  ],
  width: "1em",
  height: "1em"
});
component.props = {
  rotate: Boolean,
  variant: Number
};
component.displayName = "SSelectChevron";

const _hoisted_1$B = { class: "s-select-chip inline-flex items-center px-6px" };
const _hoisted_2$o = { class: "truncate" };
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "SSelectChip",
  props: {
    label: { default: "" }
  },
  emits: ["click:delete"],
  setup(__props, { emit }) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", _hoisted_1$B, [
        createElementVNode("span", _hoisted_2$o, toDisplayString(_ctx.label), 1),
        createElementVNode("button", {
          class: "flex-shrink-0 ml-4px",
          tabindex: "-1",
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => emit("click:delete"), ["stop"]))
        }, [
          createVNode(unref(IconClose), {
            width: "16",
            height: "16"
          })
        ])
      ]);
    };
  }
});

const SSelectChip_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$A = ["data-status"];
const _hoisted_2$n = ["for"];
const _hoisted_3$g = { class: "s-text-field__input-line" };
const _hoisted_4$6 = ["id", "value", "type", "disabled"];
const _hoisted_5$5 = {
  key: 0,
  class: "s-text-field__append"
};
const _hoisted_6$3 = {
  key: 0,
  class: "s-text-field__counter sora-tpg-p4"
};
const _hoisted_7$2 = {
  key: 0,
  class: "s-text-field__message sora-tpg-p4"
};
const __default__$1 = {
  inheritAttrs: false
};
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  ...__default__$1,
  __name: "STextField",
  props: {
    modelValue: {},
    noModelValueStrictSync: { type: Boolean, default: false },
    label: {},
    id: {},
    password: { type: Boolean, default: false },
    noEye: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: [Boolean, Number, String], default: false },
    status: {},
    success: { type: Boolean },
    warning: { type: Boolean },
    error: { type: Boolean },
    message: {},
    filledState: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "click:input-wrapper"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const status = computed(() => {
      if (props.status)
        return props.status;
      if (props.success)
        return Status.Success;
      if (props.warning)
        return Status.Warning;
      if (props.error)
        return Status.Error;
      return null;
    });
    const model = useVModel(props, "modelValue", emit);
    function onInput(e) {
      const el = e.target;
      model.value = el.value;
      if (!props.noModelValueStrictSync) {
        el.value = model.value ?? "";
      }
    }
    const isValueEmpty = computed(() => !model.value);
    const isFocused = ref(false);
    const labelTypographyClass = computed(
      () => !(props.filledState || isFocused.value) && isValueEmpty.value ? "sora-tpg-p3" : "sora-tpg-p4"
    );
    const inputRef = ref(null);
    function handleInputWrapperClick(event) {
      if (event.target !== document.activeElement) {
        event.preventDefault();
      }
      if (inputRef.value instanceof HTMLInputElement && !isFocused.value) {
        inputRef.value.focus();
        isFocused.value = true;
      }
      emit("click:input-wrapper", event);
    }
    function handleInputWrapperMouseDown(event) {
      if (event.target === inputRef.value)
        return;
      event.preventDefault();
    }
    const isMessageSlotDefined = () => !!slots.message;
    const shouldRenderMessage = () => !!props.message || isMessageSlotDefined();
    const messageIcon = computed(() => {
      if (status.value === null)
        return null;
      return STATUS_ICONS_MAP_16[status.value];
    });
    const counterConfig = computed(() => {
      const val = props.counter;
      const ty = typeof val;
      if (ty === "boolean" && val) {
        return { limit: null };
      }
      if (ty === "number" || ty === "string") {
        const num = Number(val);
        return { limit: num >= 0 ? num : null };
      }
      return null;
    });
    const counterText = computed(() => {
      const config = counterConfig.value;
      if (!config)
        return null;
      const { limit } = config;
      const currentCount = model.value?.length ?? 0;
      return limit === null ? String(currentCount) : `${currentCount}/${limit}`;
    });
    const attrs = useAttrs();
    const rootClass = () => attrs.class;
    const rootStyle = () => attrs.style;
    const inputAttrs = () => {
      const { style, class: clazz, ...rest } = attrs;
      return rest;
    };
    const showEye = computed(() => props.password && !props.noEye);
    const isAppendSlotDefined = () => !!slots.append;
    const shouldRenderAppend = () => !!counterText.value || isAppendSlotDefined() || showEye.value;
    const [forceRevealPassword, toggleForceReveal] = useToggle();
    const inputType = computed(
      () => props.password && (!showEye.value || !forceRevealPassword.value) ? "password" : "text"
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "s-text-field",
          {
            "s-text-field_empty": unref(isValueEmpty) && !_ctx.filledState,
            "s-text-field_filled-state": _ctx.filledState,
            "s-text-field_disabled": _ctx.disabled
          },
          rootClass()
        ]),
        style: normalizeStyle(rootStyle()),
        "data-status": unref(status)
      }, [
        createElementVNode("div", {
          class: "s-text-field__input-wrapper",
          onClick: handleInputWrapperClick,
          onMousedown: handleInputWrapperMouseDown
        }, [
          createElementVNode("label", {
            for: _ctx.id,
            class: normalizeClass(unref(labelTypographyClass))
          }, [
            renderSlot(_ctx.$slots, "label", {}, () => [
              createTextVNode(toDisplayString(_ctx.label), 1)
            ])
          ], 10, _hoisted_2$n),
          createElementVNode("div", _hoisted_3$g, [
            renderSlot(_ctx.$slots, "prefix"),
            createElementVNode("input", mergeProps({
              id: _ctx.id,
              ref_key: "inputRef",
              ref: inputRef,
              class: "sora-tpg-p3",
              value: unref(model),
              type: unref(inputType),
              disabled: _ctx.disabled
            }, inputAttrs(), {
              onInput,
              onFocus: _cache[0] || (_cache[0] = ($event) => isFocused.value = true),
              onBlur: _cache[1] || (_cache[1] = ($event) => isFocused.value = false)
            }), null, 16, _hoisted_4$6)
          ]),
          shouldRenderAppend() ? (openBlock(), createElementBlock("div", _hoisted_5$5, [
            unref(counterText) ? (openBlock(), createElementBlock("div", _hoisted_6$3, toDisplayString(unref(counterText)), 1)) : createCommentVNode("", true),
            renderSlot(_ctx.$slots, "append"),
            unref(showEye) ? (openBlock(), createElementBlock("button", {
              key: 1,
              class: "s-text-field__eye",
              type: "button",
              onClick: _cache[2] || (_cache[2] = withModifiers(($event) => unref(toggleForceReveal)(), ["stop"]))
            }, [
              !unref(forceRevealPassword) ? (openBlock(), createBlock(unref(IconEye), { key: 0 })) : (openBlock(), createBlock(unref(IconEyeOff), { key: 1 }))
            ])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ], 32),
        createVNode(Transition, { name: "s-text-field__message-transition" }, {
          default: withCtx(() => [
            shouldRenderMessage() ? (openBlock(), createElementBlock("div", _hoisted_7$2, [
              unref(messageIcon) ? (openBlock(), createBlock(resolveDynamicComponent(unref(messageIcon)), {
                key: 0,
                class: "s-text-field__message-icon"
              })) : createCommentVNode("", true),
              createElementVNode("span", null, [
                renderSlot(_ctx.$slots, "message", {}, () => [
                  createTextVNode(toDisplayString(_ctx.message), 1)
                ])
              ])
            ])) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 14, _hoisted_1$A);
    };
  }
});

const STextField_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$z = {
  key: 0,
  class: "flex flex-col flex-1 truncate"
};
const _hoisted_2$m = ["value"];
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "SSelectInput",
  props: {
    search: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const api = useSelectApi();
    const selectionsJoined = computed(() => api.selectedOptions.map((x) => x.label).join(", "));
    const SEARCH_ICON_SIZE = {
      [SelectSize.Xl]: 24,
      [SelectSize.Lg]: 20,
      [SelectSize.Md]: 18,
      [SelectSize.Sm]: 15
    };
    const isColumnLayout = computed(() => {
      return api.size === SelectSize.Xl;
    });
    const shouldUseChips = computed(() => api.multiple && props.search);
    function typographyLabel() {
      return !api.isSomethingSelected && api.size === SelectSize.Xl ? "sora-tpg-p3" : "sora-tpg-p4";
    }
    function typographySelection() {
      return api.size === SelectSize.Xl ? "sora-tpg-p3" : "sora-tpg-p4";
    }
    const inputRef = ref(null);
    const isFocused = ref(false);
    const shouldShowLabel = computed(
      () => !(props.search && (api.searchQuery || api.isSomethingSelected || isFocused.value))
    );
    function focusInput() {
      if (!(inputRef.value instanceof HTMLInputElement)) {
        return;
      }
      inputRef.value.focus();
      isFocused.value = true;
    }
    function handleInputBlur() {
      api.menuToggle(false);
      isFocused.value = false;
    }
    function handleInputClick(event) {
      if (!props.search) {
        api.menuToggle();
        return;
      }
      if (event.target !== document.activeElement) {
        event.preventDefault();
      }
      focusInput();
      api.menuToggle(true);
    }
    function handleMouseDown(event) {
      if (event.target === inputRef.value) {
        return;
      }
      event.preventDefault();
    }
    function handleInput(event) {
      if (!(event.target instanceof HTMLInputElement)) {
        return;
      }
      api.updateSearchQuery(event.target.value);
    }
    const FLabel = () => {
      const label = slots.label?.(api) ?? api.label;
      return h(
        "span",
        {
          class: ["s-select-input__label", typographyLabel()]
        },
        !isColumnLayout.value && api.isSomethingSelected ? [label, ":"] : label
      );
    };
    const FSelection = () => api.isSomethingSelected ? h(
      "span",
      {
        class: ["overflow-hidden", "overflow-ellipsis", typographySelection()]
      },
      selectionsJoined.value
    ) : null;
    function handleChevronClick(event) {
      api.menuToggle();
      if (!api.isMenuOpened)
        event.stopImmediatePropagation();
    }
    return (_ctx, _cache) => {
      return _ctx.search && unref(isColumnLayout) ? (openBlock(), createBlock(_sfc_main$A, {
        key: 0,
        "model-value": unref(api).searchQuery,
        label: unref(api).label || "",
        "filled-state": unref(api).isSomethingSelected,
        disabled: unref(api).disabled,
        "onUpdate:modelValue": unref(api).updateSearchQuery,
        "onClick:inputWrapper": _cache[1] || (_cache[1] = ($event) => unref(api).menuToggle(true)),
        onBlur: _cache[2] || (_cache[2] = ($event) => unref(api).menuToggle(false))
      }, {
        label: withCtx(() => [
          renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(unref(api))))
        ]),
        prefix: withCtx(() => [
          unref(shouldUseChips) ? (openBlock(true), createElementBlock(Fragment, { key: 0 }, renderList(unref(api).selectedOptions, (option) => {
            return openBlock(), createBlock(_sfc_main$B, {
              key: option.label,
              label: option.label,
              class: normalizeClass(["min-w-0 mr-8px mt-4px", typographySelection()]),
              "onClick:delete": ($event) => unref(api).unselect(option.value),
              onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {
              }, ["prevent", "stop"]))
            }, null, 8, ["label", "class", "onClick:delete"]);
          }), 128)) : (openBlock(), createBlock(FSelection, {
            key: 1,
            class: "mr-8px"
          }))
        ]),
        append: withCtx(() => [
          createVNode(unref(component), {
            rotate: unref(api).isMenuOpened,
            variant: 24,
            width: "24",
            height: "24",
            onClick: handleChevronClick
          }, null, 8, ["rotate"])
        ]),
        _: 3
      }, 8, ["model-value", "label", "filled-state", "disabled", "onUpdate:modelValue"])) : (openBlock(), createElementBlock("div", {
        key: 1,
        class: normalizeClass([
          "s-select-input",
          `s-select-input_size_${unref(api).size}`,
          {
            "s-select-input_empty": !unref(api).isSomethingSelected,
            "s-select-input_disabled": unref(api).disabled
          }
        ]),
        onClick: handleInputClick,
        onMousedown: handleMouseDown
      }, [
        unref(isColumnLayout) ? (openBlock(), createElementBlock("div", _hoisted_1$z, [
          createVNode(FLabel),
          createVNode(FSelection)
        ])) : (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(["flex items-center flex-1 truncate", {
            "flex-wrap": unref(shouldUseChips),
            "-mt-4px": unref(shouldUseChips)
          }])
        }, [
          _ctx.search && !unref(shouldUseChips) ? (openBlock(), createBlock(unref(IconBasicSearch24), {
            key: 0,
            class: "s-select-input__search-icon flex-shrink-0 mr-8px",
            width: SEARCH_ICON_SIZE[unref(api).size],
            height: SEARCH_ICON_SIZE[unref(api).size]
          }, null, 8, ["width", "height"])) : createCommentVNode("", true),
          unref(shouldShowLabel) ? (openBlock(), createBlock(FLabel, {
            key: 1,
            class: normalizeClass({ "mt-4px": unref(shouldUseChips) })
          }, null, 8, ["class"])) : createCommentVNode("", true),
          unref(shouldUseChips) ? (openBlock(true), createElementBlock(Fragment, { key: 2 }, renderList(unref(api).selectedOptions, (option) => {
            return openBlock(), createBlock(_sfc_main$B, {
              key: option.label,
              class: normalizeClass(["min-w-0 mr-8px mt-4px", typographySelection()]),
              label: option.label,
              "onClick:delete": ($event) => unref(api).unselect(option.value),
              onMousedown: _cache[3] || (_cache[3] = withModifiers(() => {
              }, ["prevent", "stop"]))
            }, null, 8, ["class", "label", "onClick:delete"]);
          }), 128)) : (openBlock(), createBlock(FSelection, {
            key: 3,
            class: "min-w-0 flex-grow-1 ml-4px mr-4px"
          })),
          _ctx.search ? (openBlock(), createElementBlock("input", {
            key: 4,
            ref_key: "inputRef",
            ref: inputRef,
            value: unref(api).searchQuery,
            class: normalizeClass(["min-w-1/4 bg-transparent outline-none flex-grow basis-0", [{ "mt-4px": unref(shouldUseChips) }, typographySelection()]]),
            onInput: handleInput,
            onBlur: handleInputBlur
          }, null, 42, _hoisted_2$m)) : createCommentVNode("", true)
        ], 2)),
        createElementVNode("div", null, [
          createVNode(unref(component), {
            rotate: unref(api).isMenuOpened,
            variant: 24,
            onClick: handleChevronClick
          }, null, 8, ["rotate"])
        ])
      ], 34));
    };
  }
});

const SSelectInput_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$y = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$l = /*#__PURE__*/createElementVNode("path", {
  d: "M21 7L9 19l-5.5-5.5l1.41-1.41L9 16.17L19.59 5.59L21 7z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$f = [
  _hoisted_2$l
];

function render$2(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$y, _hoisted_3$f))
}

const IconCheckMark = { name: 'mdi-check', render: render$2 };
/* vite-plugin-components disabled */

const RADIO_GROUP_API_KEY = Symbol("RadioGroupApi");
function useRadioGroupApi() {
  return forceInject(RADIO_GROUP_API_KEY);
}

const RADIO_SIZE_VALUES = ["md", "lg", "xl"];
const RADIO_TYPE_VALUES = ["default", "bordered", "bordered-with-description"];

const SRadioAtom$1 = '';

const SRadioAtom = (props, { attrs }) => {
  return h(
    "div",
    mergeProps(
      {
        class: [
          "s-radio-atom",
          {
            "s-radio-atom_checked": props.checked ?? false,
            "s-radio-atom_disabled": props.disabled ?? false,
            "s-radio-atom_hover": props.hover ?? false
          }
        ],
        "data-size": props.size
      },
      attrs
    )
  );
};
SRadioAtom.props = {
  size: {
    type: String,
    required: true
  },
  disabled: Boolean,
  hover: Boolean,
  checked: Boolean
};
SRadioAtom.displayName = SRadioAtom.name;

const SRadioBody$1 = '';

const TYPOGRAPHY = {
  xl: {
    label: "sora-tpg-p3",
    description: "sora-tpg-p4"
  },
  lg: {
    label: "sora-tpg-p4",
    description: "sora-tpg-p4"
  },
  md: {
    label: "sora-tpg-p4",
    description: "sora-tpg-p4"
  }
};

const SRadioBody = (props, { attrs, slots }) => {
  const tpg = TYPOGRAPHY[props.size];
  return h(
    "div",
    mergeProps(
      {
        class: "s-radio-body",
        "data-type": props.type,
        "data-size": props.size,
        "aria-labelledby": props.labelId,
        "aria-describedby": props.descriptionId
      },
      attrs
    ),
    [
      h("div", { class: "flex space-x-2 items-center" }, [
        ...slots.atom?.() ?? [],
        h(
          "label",
          {
            id: props.labelId,
            class: tpg.label
          },
          slots.label?.()
        )
      ]),
      props.type === "bordered-with-description" && h(
        "div",
        {
          id: props.descriptionId,
          class: [tpg.description, "s-radio-body__description"]
        },
        slots.description?.()
      )
    ]
  );
};
SRadioBody.displayName = "SRadioBody";
SRadioBody.props = {
  type: {
    type: String,
    required: true
  },
  size: {
    type: String,
    required: true
  },
  labelId: {
    type: String,
    required: true
  },
  descriptionId: {
    type: String,
    required: true
  }
};

const _hoisted_1$x = /* @__PURE__ */ createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  role: "img",
  class: "iconify iconify--ic",
  width: "32",
  height: "32",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ createElementVNode("path", {
    fill: "currentColor",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8.29 13.29a.996.996 0 0 1-1.41 0L5.71 12.7a.996.996 0 1 1 1.41-1.41L10 14.17l6.88-6.88a.996.996 0 1 1 1.41 1.41l-7.58 7.59z"
  })
], -1);
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "SRadio",
  props: {
    value: {},
    disabled: { type: Boolean, default: false },
    type: { default: "default" },
    size: { default: "md" }
  },
  setup(__props) {
    const props = __props;
    const propFilter = usePropTypeFilter(props);
    const definitelyType = propFilter("type", RADIO_TYPE_VALUES, "default");
    const definitelySize = propFilter("size", RADIO_SIZE_VALUES, "md");
    const api = useRadioGroupApi().registerRadio({
      valueRef: computed(() => props.value),
      disabledRef: computed(() => props.disabled),
      elRef: templateRef("root")
    });
    const hover = ref(false);
    const uniqueLabelId = uniqueElementId();
    const uniqueDescriptionId = uniqueElementId();
    const describedBy = computed(() => definitelyType.value === "bordered-with-description" ? uniqueDescriptionId : "");
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(SRadioBody), {
        ref: "root",
        role: "radio",
        tabindex: unref(api).tabindex,
        type: unref(definitelyType),
        size: unref(definitelySize),
        "label-id": unref(uniqueLabelId),
        "description-id": unref(describedBy),
        "aria-checked": unref(api).isChecked,
        "aria-disabled": _ctx.disabled,
        class: "s-radio",
        onClick: _cache[0] || (_cache[0] = ($event) => unref(api).check()),
        onMouseenter: _cache[1] || (_cache[1] = ($event) => hover.value = true),
        onMouseleave: _cache[2] || (_cache[2] = ($event) => hover.value = false)
      }, {
        atom: withCtx(() => [
          createVNode(unref(SRadioAtom), {
            size: unref(definitelySize),
            checked: unref(api).isChecked,
            disabled: _ctx.disabled,
            hover: unref(hover)
          }, null, 8, ["size", "checked", "disabled", "hover"])
        ]),
        label: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        description: withCtx(() => [
          renderSlot(_ctx.$slots, "description")
        ]),
        default: withCtx(() => [
          _hoisted_1$x
        ]),
        _: 3
      }, 8, ["tabindex", "type", "size", "label-id", "description-id", "aria-checked", "aria-disabled"]);
    };
  }
});

function useRadiosSelector(target, selector) {
  const elems = shallowRef([]);
  const selectorRef = computed(() => unref(selector));
  const targetRef = computed(() => unrefElement(target));
  function doUpdate() {
    const root = targetRef.value;
    if (!root)
      throw new Error("Element is not defined; unable to update");
    elems.value = Array.from(root.querySelectorAll(selectorRef.value));
  }
  const updateTriggerCounter = ref(0);
  let lastUpdateTriggeredCounter = 0;
  watch(updateTriggerCounter, (num) => {
    if (num > lastUpdateTriggeredCounter) {
      doUpdate();
      lastUpdateTriggeredCounter = num;
    }
  });
  function update(immediate) {
    if (immediate)
      doUpdate();
    else {
      updateTriggerCounter.value++;
    }
  }
  watch(selectorRef, () => {
    targetRef.value && doUpdate();
  });
  return {
    elems,
    update
  };
}
function useRadiosRegistration({
  radioElements,
  model,
  updateRadioElements
}) {
  const radios = shallowReactive(/* @__PURE__ */ new Set());
  const isNothingChecked = eagerComputed(() => {
    for (const entry of radios) {
      if (entry.isChecked.value)
        return false;
    }
    return true;
  });
  const focusedRadio = computed(() => {
    for (const entry of radios) {
      if (entry.isFocused.value) {
        return entry;
      }
    }
    return null;
  });
  const isNothingFocused = eagerComputed(() => !focusedRadio.value);
  function indexOfFocusedRadio() {
    return focusedRadio.value?.index?.value ?? -1;
  }
  const sequence = computed(() => {
    const items = new Array(radios.size).fill(null);
    for (const entry of radios) {
      items[entry.index.value] = entry;
    }
    return items;
  });
  function findNextFocusableRadioInSequence(forward = true) {
    const delta = forward ? 1 : -1;
    const items = sequence.value;
    const count = items.length;
    let steps = 0;
    let idx = indexOfFocusedRadio();
    if (idx < 0)
      return null;
    while (steps++ < count) {
      idx += delta;
      idx = idx >= count ? 0 : idx < 0 ? count - 1 : idx;
      if (!items[idx].isDisabled.value)
        return items[idx];
    }
    return null;
  }
  function moveFocus(forward = true) {
    const next = findNextFocusableRadioInSequence(forward);
    if (next) {
      model.value = next.valueRef.value;
      next.elRef.value.focus();
    }
  }
  function checkFocused() {
    const radio = focusedRadio.value;
    if (radio) {
      model.value = radio.valueRef.value;
    }
  }
  function registerRadio({
    elRef,
    valueRef,
    disabledRef: isDisabled
  }) {
    const { focused: isFocused } = useFocus(elRef);
    const index = eagerComputed(() => elRef.value ? radioElements.value.indexOf(elRef.value) : -1);
    const isItTheFirstRadioInTheGroup = eagerComputed(() => index.value === 0);
    const isChecked = eagerComputed(() => model.value === valueRef.value);
    const isTabbable = eagerComputed(
      () => !isDisabled.value && (isFocused.value || isNothingFocused.value && isChecked.value || isNothingChecked.value && isItTheFirstRadioInTheGroup.value)
    );
    const tabindex = computed(() => isTabbable.value ? 0 : -1);
    function check() {
      model.value = valueRef.value;
    }
    const registeredEntry = {
      elRef,
      valueRef,
      index,
      isChecked,
      isFocused,
      isDisabled
    };
    watch(elRef, (x) => x && updateRadioElements(), { flush: "sync" });
    onMounted(() => {
      radios.add(registeredEntry);
    });
    onUnmounted(() => {
      radios.delete(registeredEntry);
      updateRadioElements();
    });
    return readonly({
      check,
      isChecked,
      tabindex
    });
  }
  return { registerRadio, moveFocus, checkFocused };
}

const _hoisted_1$w = ["aria-labelledby", "aria-describedby"];
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "SRadioGroup",
  props: {
    modelValue: { default: null },
    radioSelector: { default: "[role=radio]" },
    labelledBy: { default: "" },
    describedBy: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit, { passive: true });
    const { elems: radioElements, update: updateRadioElements } = useRadiosSelector(
      templateRef("root"),
      computed(() => props.radioSelector)
    );
    const { registerRadio, moveFocus, checkFocused } = useRadiosRegistration({
      radioElements,
      model,
      updateRadioElements
    });
    provide(RADIO_GROUP_API_KEY, readonly({ registerRadio }));
    function handleKeydown(e) {
      switch (e.code) {
        case "ArrowDown":
        case "ArrowRight":
          moveFocus();
          break;
        case "ArrowUp":
        case "ArrowLeft":
          moveFocus(false);
          break;
        case "Space":
          checkFocused();
          break;
        default:
          return;
      }
      e.preventDefault();
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref: "root",
        role: "radiogroup",
        "aria-labelledby": _ctx.labelledBy,
        "aria-describedby": _ctx.describedBy,
        onKeydown: handleKeydown
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 40, _hoisted_1$w);
    };
  }
});

const SCheckboxAtom$1 = '';

const _hoisted_1$v = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$k = /*#__PURE__*/createElementVNode("path", {
  d: "M18.71 7.21a1 1 0 0 0-1.42 0l-7.45 7.46l-3.13-3.14A1 1 0 1 0 5.29 13l3.84 3.84a1 1 0 0 0 1.42 0l8.16-8.16a1 1 0 0 0 0-1.47z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$e = [
  _hoisted_2$k
];

function render$1(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$v, _hoisted_3$e))
}

const IconCheck = { name: 'uil-check', render: render$1 };
/* vite-plugin-components disabled */

const _hoisted_1$u = {
  width: "1.2em",
  height: "1.2em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
};
const _hoisted_2$j = /*#__PURE__*/createElementVNode("path", {
  d: "M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3$d = [
  _hoisted_2$j
];

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$u, _hoisted_3$d))
}

const IconMinus = { name: 'uil-minus', render };
/* vite-plugin-components disabled */

const IconEmpty = () => h("svg", { width: "1.2em", height: "1.2em" }, h("path"));
const SCheckboxAtom = (props, { attrs }) => {
  return h(
    "div",
    mergeProps(
      {
        class: [
          "s-checkbox-atom",
          {
            "s-checkbox-atom_disabled": props.disabled ?? false,
            "s-checkbox-atom_hover": props.hover ?? false
          }
        ],
        "data-size": props.size,
        "data-checked": props.checked ?? false
      },
      attrs
    ),
    [props.checked ? props.checked === "mixed" ? h(IconMinus) : h(IconCheck) : IconEmpty()]
  );
};
SCheckboxAtom.displayName = "SCheckboxAtom";
SCheckboxAtom.props = {
  size: {
    type: String,
    required: true
  },
  checked: {
    type: [Boolean, String]
  },
  hover: Boolean,
  disabled: Boolean
};

const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "SCheckboxSolo",
  props: {
    modelValue: { type: Boolean, default: false },
    type: { default: "default" },
    size: { default: "md" },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const propFilter = usePropTypeFilter(props);
    const definitelyType = propFilter("type", RADIO_TYPE_VALUES, "default");
    const definitelySize = propFilter("size", RADIO_SIZE_VALUES, "md");
    const model = useVModel(props, "modelValue", emit, { passive: true });
    function toggleModel() {
      model.value = !model.value;
    }
    const uniqueLabelId = uniqueElementId();
    const uniqueDescriptionId = uniqueElementId();
    const hover = ref(false);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(SRadioBody), {
        role: "checkbox",
        "aria-checked": unref(model),
        "aria-disabled": _ctx.disabled,
        size: unref(definitelySize),
        type: unref(definitelyType),
        "label-id": unref(uniqueLabelId),
        "description-id": unref(uniqueDescriptionId),
        tabindex: _ctx.disabled ? -1 : 0,
        class: "s-checkbox-solo",
        onClick: toggleModel,
        onKeypress: withKeys(toggleModel, ["space"]),
        onMouseenter: _cache[0] || (_cache[0] = ($event) => hover.value = true),
        onMouseleave: _cache[1] || (_cache[1] = ($event) => hover.value = false)
      }, {
        atom: withCtx(() => [
          createVNode(unref(SCheckboxAtom), {
            checked: unref(model),
            size: unref(definitelySize),
            disabled: _ctx.disabled,
            hover: unref(hover)
          }, null, 8, ["checked", "size", "disabled", "hover"])
        ]),
        label: withCtx(() => [
          renderSlot(_ctx.$slots, "default")
        ]),
        description: withCtx(() => [
          renderSlot(_ctx.$slots, "description")
        ]),
        _: 3
      }, 8, ["aria-checked", "aria-disabled", "size", "type", "label-id", "description-id", "tabindex", "onKeypress"]);
    };
  }
});

const _hoisted_1$t = { class: "s-select-option__content truncate" };
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "SSelectOption",
  props: {
    type: {},
    selected: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props, { emit }) {
    const api = useSelectApi();
    const RADIO_CHECKBOX_SIZE = {
      [SelectSize.Xl]: "xl",
      [SelectSize.Lg]: "lg",
      [SelectSize.Md]: "lg",
      [SelectSize.Sm]: "md"
    };
    const CHECK_ICON_SIZE = {
      [SelectSize.Xl]: 24,
      [SelectSize.Lg]: 16,
      [SelectSize.Md]: 16,
      [SelectSize.Sm]: 16
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "s-select-option",
          `s-select-option_size_${unref(api).size}`,
          {
            "s-select-option_selected": _ctx.selected
          }
        ]),
        onClick: _cache[0] || (_cache[0] = ($event) => emit("toggle"))
      }, [
        _ctx.type === unref(SelectOptionType).Checkbox ? (openBlock(), createBlock(unref(SCheckboxAtom), {
          key: 0,
          class: "flex-shrink-0",
          checked: _ctx.selected,
          size: RADIO_CHECKBOX_SIZE[unref(api).size]
        }, null, 8, ["checked", "size"])) : createCommentVNode("", true),
        _ctx.type === unref(SelectOptionType).Radio ? (openBlock(), createBlock(unref(SRadioAtom), {
          key: 1,
          class: "flex-shrink-0",
          checked: _ctx.selected,
          size: RADIO_CHECKBOX_SIZE[unref(api).size]
        }, null, 8, ["checked", "size"])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_1$t, [
          renderSlot(_ctx.$slots, "default")
        ]),
        _ctx.type === unref(SelectOptionType).Default ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
          _ctx.selected ? (openBlock(), createBlock(unref(IconCheckMark), {
            key: 0,
            class: "flex-shrink-0",
            width: CHECK_ICON_SIZE[unref(api).size],
            height: CHECK_ICON_SIZE[unref(api).size]
          }, null, 8, ["width", "height"])) : createCommentVNode("", true)
        ], 64)) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const SSelectOption_vue_vue_type_style_index_0_lang = '';

function escapeStringRegexp(string) {
	if (typeof string !== 'string') {
		throw new TypeError('Expected a string');
	}

	// Escape characters with special meaning either inside or outside character sets.
	// Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
	return string
		.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
		.replace(/-/g, '\\x2d');
}

const _hoisted_1$s = {
  key: 0,
  class: "s-select-dropdown__search flex items-center"
};
const _hoisted_2$i = ["value"];
const _hoisted_3$c = {
  key: 1,
  class: "s-select-dropdown__loading flex items-center justify-center"
};
const _hoisted_4$5 = {
  key: 0,
  class: "s-select-dropdown__header flex items-center justify-between"
};
const _hoisted_5$4 = ["onClick"];
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "SSelectDropdown",
  props: {
    itemType: {},
    search: { type: Boolean },
    maxShownOptions: {}
  },
  setup(__props) {
    const props = __props;
    const api = useSelectApi();
    const fontClass = computed(() => api.size === SelectSize.Xl ? "sora-tpg-p3" : "sora-tpg-p4");
    const optionGroups = computed(() => {
      const options = api.options;
      if (isSelectOptions(options)) {
        return [{ items: options }];
      }
      return options;
    });
    const isSearching = eagerComputed(() => api.searchQuery);
    const escapedQuery = computed(() => new RegExp(escapeStringRegexp(api.searchQuery), "i"));
    const shownOptionGroups = computed(() => {
      if (!api.searchQuery || api.remoteSearch) {
        return optionGroups.value;
      }
      return optionGroups.value.map((x) => ({ ...x, items: x.items.filter((x2) => escapedQuery.value.test(x2.label)) }));
    });
    const isNothingToShow = eagerComputed(() => shownOptionGroups.value.every((x) => !x.items.length));
    function isActionButtonShown(selectAllBtn) {
      return api.multiple && selectAllBtn;
    }
    function isHeaderShown(optionGroup) {
      return !isSearching.value && (isActionButtonShown(!!optionGroup.selectAllBtn) || optionGroup.header);
    }
    function handleSearchInput(event) {
      if (event.target instanceof HTMLInputElement) {
        api.updateSearchQuery(event.target.value);
      }
    }
    const searchInputRef = ref(null);
    function handleMouseDown(event) {
      if (event.target === searchInputRef.value) {
        return;
      }
      event.preventDefault();
    }
    const HEADER_FONT = {
      [SelectSize.Xl]: "sora-tpg-ch2",
      [SelectSize.Lg]: "sora-tpg-ch3",
      [SelectSize.Md]: "sora-tpg-ch3",
      [SelectSize.Sm]: "sora-tpg-ch3"
    };
    const MAIN_FONT = {
      [SelectSize.Xl]: "sora-tpg-p3",
      [SelectSize.Lg]: "sora-tpg-p4",
      [SelectSize.Md]: "sora-tpg-p4",
      [SelectSize.Sm]: "sora-tpg-p4"
    };
    const SEARCH_ICON_SIZE = {
      [SelectSize.Xl]: 24,
      [SelectSize.Lg]: 16,
      [SelectSize.Md]: 16,
      [SelectSize.Sm]: 12
    };
    const OPTION_SIZE = {
      [SelectSize.Xl]: 56,
      [SelectSize.Lg]: 40,
      [SelectSize.Md]: 32,
      [SelectSize.Sm]: 24
    };
    const dropdownHeight = computed(() => {
      if (!props.maxShownOptions)
        return;
      return OPTION_SIZE[api.size] * Math.min(props.maxShownOptions, api.options.length) + "px";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["s-select-dropdown", `s-select-dropdown_size_${unref(api).size}`]),
        style: normalizeStyle({ "height": unref(dropdownHeight) ?? "auto" }),
        onMousedown: handleMouseDown
      }, [
        _ctx.search ? (openBlock(), createElementBlock("div", _hoisted_1$s, [
          createVNode(unref(IconBasicSearch24), {
            class: "s-select-dropdown__search-icon flex-shrink-0 mr-8px",
            width: SEARCH_ICON_SIZE[unref(api).size],
            height: SEARCH_ICON_SIZE[unref(api).size]
          }, null, 8, ["width", "height"]),
          createElementVNode("input", {
            ref_key: "searchInputRef",
            ref: searchInputRef,
            class: normalizeClass(["s-select-dropdown__search-input flex-grow bg-transparent", MAIN_FONT[unref(api).size]]),
            value: unref(api).searchQuery,
            placeholder: "Search",
            onInput: handleSearchInput
          }, null, 42, _hoisted_2$i)
        ])) : createCommentVNode("", true),
        unref(api).loading ? (openBlock(), createElementBlock("div", _hoisted_3$c, [
          createVNode(SSpinner)
        ])) : unref(isNothingToShow) ? (openBlock(), createElementBlock("div", {
          key: 2,
          class: normalizeClass(["flex items-center justify-center m-16px", MAIN_FONT[unref(api).size]])
        }, [
          renderSlot(_ctx.$slots, "empty", {}, () => [
            createTextVNode(" No data ")
          ])
        ], 2)) : (openBlock(true), createElementBlock(Fragment, { key: 3 }, renderList(unref(shownOptionGroups), (optionGroup, i) => {
          return openBlock(), createElementBlock(Fragment, { key: i }, [
            isHeaderShown(optionGroup) ? (openBlock(), createElementBlock("div", _hoisted_4$5, [
              optionGroup.header ? (openBlock(), createElementBlock("div", {
                key: 0,
                class: normalizeClass(HEADER_FONT[unref(api).size])
              }, toDisplayString(optionGroup.header), 3)) : createCommentVNode("", true),
              isActionButtonShown(!!optionGroup.selectAllBtn) ? (openBlock(), createElementBlock("button", {
                key: 1,
                class: normalizeClass(["s-select-dropdown__action cursor-pointer ml-auto", MAIN_FONT[unref(api).size]]),
                tabindex: "-1",
                onClick: ($event) => unref(api).toggleGroupSelection(optionGroup)
              }, toDisplayString(unref(api).isGroupSelected(optionGroup) ? "Deselect all" : "Select all"), 11, _hoisted_5$4)) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(optionGroup.items, (opt, j) => {
              return openBlock(), createBlock(_sfc_main$v, {
                key: j,
                class: normalizeClass(unref(fontClass)),
                type: _ctx.itemType,
                multiple: unref(api).multiple,
                selected: unref(api).isValueSelected(opt.value),
                onToggle: ($event) => unref(api).toggleSelection(opt.value)
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(opt.label), 1)
                ]),
                _: 2
              }, 1032, ["class", "type", "multiple", "selected", "onToggle"]);
            }), 128))
          ], 64);
        }), 128))
      ], 38);
    };
  }
});

const SSelectDropdown_vue_vue_type_style_index_0_lang = '';

const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "SSelect",
  props: {
    modelValue: {},
    options: {},
    optionType: {},
    disabled: { type: Boolean },
    multiple: { type: Boolean },
    label: {},
    size: {},
    noAutoClose: { type: Boolean },
    loading: { type: Boolean },
    triggerSearch: { type: Boolean },
    dropdownSearch: { type: Boolean },
    remoteSearch: { type: Boolean },
    maxShownOptions: {}
  },
  setup(__props) {
    const props = __props;
    const defaultOptionType = computed(() => props.multiple ? SelectOptionType.Checkbox : SelectOptionType.Radio);
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$C, mergeProps({ ..._ctx.$attrs, ..._ctx.$props }, { "same-width-popper": "" }), {
        control: withCtx(({ search }) => [
          createVNode(_sfc_main$z, { search }, {
            label: withCtx((binding) => [
              renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(binding)), () => [
                createTextVNode(toDisplayString(_ctx.label), 1)
              ])
            ]),
            _: 2
          }, 1032, ["search"])
        ]),
        dropdown: withCtx(({ search }) => [
          createVNode(_sfc_main$u, {
            search,
            "item-type": _ctx.optionType ?? unref(defaultOptionType),
            "max-shown-options": +(_ctx.maxShownOptions ?? 0)
          }, {
            empty: withCtx(() => [
              renderSlot(_ctx.$slots, "empty")
            ]),
            _: 2
          }, 1032, ["search", "item-type", "max-shown-options"])
        ]),
        _: 3
      }, 16);
    };
  }
});

const _hoisted_1$r = {
  key: 0,
  class: "s-select-btn__label"
};
const _hoisted_2$h = {
  key: 1,
  class: "s-select-btn__selection"
};
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "SSelectButton",
  props: {
    type: { default: SelectButtonType.Default }
  },
  setup(__props) {
    const api = useSelectApi();
    function toggle() {
      api.menuToggle();
    }
    const formattedSelectedValue = computed(() => {
      const opts = api.selectedOptions;
      if (opts.length) {
        if (opts.length === 1) {
          return opts[0].label;
        }
        return `${opts.length} selected`;
      }
      return null;
    });
    function typography() {
      switch (api.size) {
        case SelectSize.Xl:
          return "sora-tpg-p1";
        case SelectSize.Lg:
          return "sora-tpg-p3";
        default:
          return "sora-tpg-p4";
      }
    }
    const slots = useSlots();
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "s-select-btn",
          `s-select-btn_${_ctx.type}`,
          `s-select-btn_size_${unref(api).size}`,
          typography(),
          {
            "s-select-btn_empty": !unref(api).isSomethingSelected,
            "s-select-btn_disabled": unref(api).disabled
          }
        ]),
        onClick: toggle
      }, [
        !!unref(slots).label || unref(api).label ? (openBlock(), createElementBlock("span", _hoisted_1$r, [
          renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(unref(api))), () => [
            createTextVNode(toDisplayString(unref(api).label), 1)
          ], true),
          unref(api).isSomethingSelected ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode(":")
          ], 64)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        unref(api).isSomethingSelected ? (openBlock(), createElementBlock("span", _hoisted_2$h, toDisplayString(unref(formattedSelectedValue)), 1)) : createCommentVNode("", true),
        createVNode(unref(component), {
          rotate: unref(api).isMenuOpened
        }, null, 8, ["rotate"])
      ], 2);
    };
  }
});

const SSelectButton_vue_vue_type_style_index_0_scoped_7ede1f43_lang = '';

const SSelectButton = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["__scopeId", "data-v-7ede1f43"]]);

const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "SDropdown",
  props: {
    modelValue: {},
    options: {},
    optionType: {},
    disabled: { type: Boolean },
    multiple: { type: Boolean },
    label: {},
    size: {},
    inline: { type: Boolean },
    noAutoClose: { type: Boolean },
    loading: { type: Boolean },
    dropdownSearch: { type: Boolean },
    remoteSearch: { type: Boolean },
    maxShownOptions: {}
  },
  setup(__props) {
    const props = __props;
    const buttonType = computed(() => props.inline ? SelectButtonType.Inline : SelectButtonType.Default);
    const slots = useSlots();
    function isThereLabelSlot() {
      return !!slots.label;
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$C, mergeProps({ ..._ctx.$attrs, ..._ctx.$props }, { "same-width-popper": _ctx.loading }), {
        control: withCtx(() => [
          createVNode(SSelectButton, { type: unref(buttonType) }, createSlots({ _: 2 }, [
            isThereLabelSlot() || _ctx.label ? {
              name: "label",
              fn: withCtx((binding) => [
                renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(binding)), () => [
                  createTextVNode(toDisplayString(_ctx.label), 1)
                ])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["type"])
        ]),
        dropdown: withCtx(({ search }) => [
          createVNode(_sfc_main$u, {
            search,
            "item-type": _ctx.optionType ?? unref(SelectOptionType).Default,
            "max-shown-options": +(_ctx.maxShownOptions ?? 0)
          }, {
            empty: withCtx(() => [
              renderSlot(_ctx.$slots, "empty")
            ]),
            _: 2
          }, 1032, ["search", "item-type", "max-shown-options"])
        ]),
        _: 3
      }, 16, ["same-width-popper"]);
    };
  }
});

const _hoisted_1$q = { class: "s-switch" };
const _hoisted_2$g = ["id", "disabled"];
const _hoisted_3$b = ["for"];
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "SSwitch",
  props: {
    modelValue: { type: Boolean },
    id: {},
    label: { default: "" },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$q, [
        withDirectives(createElementVNode("input", {
          id: _ctx.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(model) ? model.value = $event : null),
          type: "checkbox",
          disabled: _ctx.disabled,
          class: "s-switch__button"
        }, null, 8, _hoisted_2$g), [
          [vModelCheckbox, unref(model)]
        ]),
        createElementVNode("label", {
          for: _ctx.id,
          class: "s-switch__label sora-tpg-p3"
        }, toDisplayString(_ctx.label), 9, _hoisted_3$b)
      ]);
    };
  }
});

const SSwitch_vue_vue_type_style_index_0_scoped_60733d05_lang = '';

const SSwitch = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["__scopeId", "data-v-60733d05"]]);

const DATE_PICKER_API_KEY = Symbol("datePicker");
function useDatePickerApi() {
  return forceInject(DATE_PICKER_API_KEY);
}

const _hoisted_1$p = { class: "s-date-picker-time-panel sora-tpg-p4" };
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelTime",
  props: {
    value: { default: "00:00" },
    options: {}
  },
  emits: ["update:time"],
  setup(__props, { emit }) {
    useDatePickerApi();
    const updateTime = (e) => {
      emit("update:time", e.target.textContent);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$p, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, (time, idx) => {
          return openBlock(), createElementBlock("p", {
            key: idx,
            class: normalizeClass(["cursor-pointer", time === _ctx.value ? "active" : ""]),
            onClick: updateTime,
            onKeydown: updateTime
          }, toDisplayString(time), 35);
        }), 128))
      ]);
    };
  }
});

const SDatePickerPanelTime_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$o = { class: "s-date-picker-options-panel sora-tpg-p3" };
const _hoisted_2$f = ["onClick", "onKeydown"];
const _hoisted_3$a = { class: "s-date-picker-options-panel__checkmark" };
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelOptions",
  props: {
    menuState: {},
    options: {}
  },
  emits: ["click:option"],
  setup(__props, { emit }) {
    const state = useDatePickerApi();
    const onMenuClick = (data) => {
      emit("click:option", data);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$o, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options[unref(state).type], (item, idx) => {
          return openBlock(), createElementBlock("p", {
            key: idx,
            class: normalizeClass(["s-date-picker-options-panel__item", _ctx.menuState === item.label ? "active" : ""]),
            onClick: ($event) => onMenuClick(item),
            onKeydown: ($event) => onMenuClick(item)
          }, [
            createTextVNode(toDisplayString(item.label) + " ", 1),
            withDirectives(createElementVNode("span", _hoisted_3$a, [
              createVNode(unref(IconBasicCheckMark24))
            ], 512), [
              [vShow, _ctx.menuState === item.label]
            ])
          ], 42, _hoisted_2$f);
        }), 128))
      ]);
    };
  }
});

const SDatePickerPanelOptions_vue_vue_type_style_index_0_lang = '';

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a minute
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */

function startOfMinute(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
const formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
const localize$1 = localize;

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
const match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
const defaultLocale = locale;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const formatters$3 = formatters$2;

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

const formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
const parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */

function isSameMinute(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft);
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight);
  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */

function startOfToday() {
  return startOfDay(Date.now());
}

/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

const CUSTOM_OPTION_VALUE = Symbol("customOptionValue");
const CUSTOM_OPTION = {
  label: "Custom",
  value: CUSTOM_OPTION_VALUE
};
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const daysNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const TIME_POINTS = (() => {
  const res = [];
  for (let i = 0; i < 24; i++) {
    const hour = i < 10 ? `0${i}` : i;
    res.push(`${hour}:00`);
    res.push(`${hour}:30`);
  }
  return res;
})();
const DEFAULT_SHORTCUTS = /* @__PURE__ */ (() => {
  const START_OF_TODAY = startOfToday();
  const START_OF_YESTERDAY = startOfYesterday();
  const START_OF_TOMORROW = startOfTomorrow();
  const START_OF_WEEK = startOfWeek(START_OF_TODAY, { weekStartsOn: 1 });
  const END_OF_WEEK = endOfWeek(START_OF_TODAY, { weekStartsOn: 1 });
  const START_OF_LAST_WEEK = subWeeks(START_OF_WEEK, 1);
  const END_OF_LAST_WEEK = subWeeks(END_OF_WEEK, 1);
  const START_OF_NEXT_WEEK = addWeeks(START_OF_WEEK, 1);
  const END_OF_NEXT_WEEK = addWeeks(END_OF_WEEK, 1);
  const START_OF_MONTH = startOfMonth(START_OF_TODAY);
  const END_OF_MONTH = endOfMonth(START_OF_TODAY);
  const START_OF_LAST_MONTH = subMonths(START_OF_MONTH, 1);
  const END_OF_LAST_MONTH = subMonths(END_OF_MONTH, 1);
  const START_OF_NEXT_MONTH = addMonths(START_OF_MONTH, 1);
  const END_OF_NEXT_MONTH = addMonths(END_OF_MONTH, 1);
  const START_OF_YEAR = startOfYear(START_OF_TODAY);
  const END_OF_YEAR = endOfYear(START_OF_TODAY);
  return {
    day: [
      {
        label: "Any time",
        value: null
      },
      {
        label: "Today",
        value: START_OF_TODAY
      },
      {
        label: "Yesterday",
        value: START_OF_YESTERDAY
      },
      {
        label: "Tomorrow",
        value: START_OF_TOMORROW
      },
      {
        label: "Next week",
        value: START_OF_NEXT_WEEK
      },
      {
        label: "Next month",
        value: START_OF_NEXT_MONTH
      }
    ],
    range: [
      {
        label: "All time",
        value: null
      },
      {
        label: "This week",
        value: [START_OF_WEEK, END_OF_WEEK]
      },
      {
        label: "Last week",
        value: [START_OF_LAST_WEEK, END_OF_LAST_WEEK]
      },
      {
        label: "Next week",
        value: [START_OF_NEXT_WEEK, END_OF_NEXT_WEEK]
      },
      {
        label: "This month",
        value: [START_OF_MONTH, END_OF_MONTH]
      },
      {
        label: "Last month",
        value: [START_OF_LAST_MONTH, END_OF_LAST_MONTH]
      },
      {
        label: "Next month",
        value: [START_OF_NEXT_MONTH, END_OF_NEXT_MONTH]
      },
      {
        label: "This year",
        value: [START_OF_YEAR, END_OF_YEAR]
      }
    ]
  };
})();

const _hoisted_1$n = { class: "s-date-picker-month-table" };
const _hoisted_2$e = { class: "flex justify-between items-center sora-tpg-p2 s-date-picker-month-table__year-range-panel" };
const _hoisted_3$9 = ["month"];
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerTableMonths",
  props: {
    showState: {}
  },
  emits: ["update:showed-year", "pick"],
  setup(__props, { emit }) {
    const props = __props;
    const currentMonth = computed(() => {
      return props.showState.month;
    });
    const currentYear = computed(() => {
      return props.showState.year;
    });
    const changeYear = (delta) => {
      deltaYear.value += delta;
    };
    const deltaYear = ref(0);
    const getCellStyle = (cell) => {
      const style = {
        current: false,
        today: false
      };
      const today = /* @__PURE__ */ new Date();
      const month = cell.text;
      style.current = currentMonth.value === month && deltaYear.value === 0;
      style.today = today.getMonth() === month && today.getFullYear() === currentYear.value + deltaYear.value;
      return style;
    };
    const handleMonthTableClick = (event) => {
      let target = event.target;
      const month = Number(target.getAttribute("month"));
      emit("pick", month);
      emit("update:showed-year", currentYear.value + deltaYear.value);
    };
    const gridCells = computed(() => {
      return months.map((monthName, idx) => {
        const cell = { type: "normal", title: monthName, text: idx };
        return cell;
      });
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$n, [
        createElementVNode("div", _hoisted_2$e, [
          createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event) => changeYear(-1))
          }, [
            createVNode(unref(IconArrowsChevronLeft24))
          ]),
          createElementVNode("p", null, toDisplayString(unref(currentYear) + unref(deltaYear)), 1),
          createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event) => changeYear(1))
          }, [
            createVNode(unref(IconArrowsChevronRight24))
          ])
        ]),
        createElementVNode("div", {
          class: "s-date-picker-month-table__month-table sora-tpg-p4",
          onClick: handleMonthTableClick,
          onKeydown: handleMonthTableClick
        }, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(gridCells), (cell, idx) => {
            return openBlock(), createElementBlock("div", {
              key: idx,
              class: normalizeClass(getCellStyle(cell))
            }, [
              createElementVNode("div", null, [
                createElementVNode("a", {
                  class: "cell",
                  month: cell.text
                }, toDisplayString(`${unref(months)[cell.text]}`), 9, _hoisted_3$9)
              ])
            ], 2);
          }), 128))
        ], 32)
      ]);
    };
  }
});

const SDatePickerTableMonths_vue_vue_type_style_index_0_scoped_045b75b6_lang = '';

const MonthTable = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["__scopeId", "data-v-045b75b6"]]);

const _hoisted_1$m = { class: "s-date-picker-year-table" };
const _hoisted_2$d = { class: "sora-tpg-p2 s-date-picker-year-table__range-panel" };
const _hoisted_3$8 = { class: "cell" };
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerTableYears",
  props: {
    value: {}
  },
  emits: ["pick"],
  setup(__props, { emit }) {
    const props = __props;
    const deltaDecade = ref(0);
    const changeDecade = (delta) => {
      deltaDecade.value += delta;
    };
    const startYear = computed(() => {
      return (Math.floor(props.value / 10) + deltaDecade.value) * 10;
    });
    const getCellStyle = (year) => {
      const style = {
        current: false,
        today: false
      };
      const today = /* @__PURE__ */ new Date();
      style.current = year === props.value;
      style.today = today.getFullYear() === year;
      return style;
    };
    const handleYearTableClick = (event) => {
      const target = event.target;
      if (target.tagName === "A") {
        const year = target.textContent || target.innerText;
        emit("pick", Number(year));
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$m, [
        createElementVNode("div", _hoisted_2$d, [
          createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event) => changeDecade(-1))
          }, [
            createVNode(unref(IconArrowsChevronLeft24))
          ]),
          createElementVNode("p", null, toDisplayString(`${unref(startYear)} - ${unref(startYear) + 9}`), 1),
          createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event) => changeDecade(1))
          }, [
            createVNode(unref(IconArrowsChevronRight24))
          ])
        ]),
        createElementVNode("div", {
          class: "s-date-picker-year-table__year-table sora-tpg-p3",
          onClick: handleYearTableClick,
          onKeydown: handleYearTableClick
        }, [
          (openBlock(), createElementBlock(Fragment, null, renderList(10, (year) => {
            return createElementVNode("div", {
              key: year,
              class: normalizeClass(["available", getCellStyle(unref(startYear) + year)])
            }, [
              createElementVNode("a", _hoisted_3$8, toDisplayString(unref(startYear) + year), 1)
            ], 2);
          }), 64))
        ], 32)
      ]);
    };
  }
});

const SDatePickerTableYears_vue_vue_type_style_index_0_scoped_45ab4107_lang = '';

const YearTable = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["__scopeId", "data-v-45ab4107"]]);

const _hoisted_1$l = { class: "flex justify-center items-center header" };
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelMonths",
  props: {
    showState: {},
    hideArrows: { type: Boolean, default: false }
  },
  emits: ["update:showed-state", "change-view"],
  setup(__props, { emit }) {
    const props = __props;
    const showMonth = computed(() => props.showState.month);
    const showYear = computed(() => props.showState.year);
    const changeMonth = (delta) => {
      emit("update:showed-state", delta);
      return;
    };
    const changeView = (viewName) => {
      emit("change-view", viewName);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["s-date-picker-month-panel sora-tpg-p1 flex items-center", _ctx.hideArrows ? "justify-center" : "justify-between"])
      }, [
        !_ctx.hideArrows ? (openBlock(), createElementBlock("button", {
          key: 0,
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event) => changeMonth(-1))
        }, [
          createVNode(unref(IconArrowsChevronLeft24))
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_1$l, [
          createElementVNode("span", {
            role: "button",
            class: "header__label",
            tabIndex: "0",
            onClick: _cache[1] || (_cache[1] = ($event) => changeView("months")),
            onKeydown: _cache[2] || (_cache[2] = ($event) => changeView("months"))
          }, toDisplayString(unref(months)[unref(showMonth)]), 33),
          createElementVNode("span", {
            role: "button",
            class: "header__label",
            tabIndex: "0",
            onClick: _cache[3] || (_cache[3] = ($event) => changeView("years")),
            onKeydown: _cache[4] || (_cache[4] = ($event) => changeView("years"))
          }, toDisplayString(unref(showYear)), 33)
        ]),
        !_ctx.hideArrows ? (openBlock(), createElementBlock("button", {
          key: 1,
          type: "button",
          onClick: _cache[5] || (_cache[5] = ($event) => changeMonth(1))
        }, [
          createVNode(unref(IconArrowsChevronRight24))
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

const SDatePickerPanelMonths_vue_vue_type_style_index_0_lang = '';

const getStartDateInCalendar = (year, month) => {
  const result = new Date(year, month, 1);
  const day = result.getDay();
  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};
const prevDate = (date, amount = 1) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};
const nextDate = (date, amount = 1) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};
function setTimeByString(date, time) {
  const [hours, minutes] = time.split(":").map((item) => Number(item));
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes, 0);
}

const _hoisted_1$k = ["index"];
const _hoisted_2$c = { class: "date-table__cell-text" };
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerTableDate",
  props: {
    firstDayOfWeek: { default: 1 },
    showState: {},
    stateStore: {},
    hoveredDate: {}
  },
  emits: ["pick", "update:showed-state", "update:hovered-date"],
  setup(__props, { emit }) {
    const props = __props;
    const getDateTimestamp = (time) => {
      return startOfDay(time).getTime();
    };
    const getFirstDayOfMonth = (date) => {
      const temp = new Date(date.getTime());
      temp.setDate(1);
      return temp.getDay();
    };
    const state = useDatePickerApi();
    const offsetDay = computed(() => {
      const week = props.firstDayOfWeek;
      return week > 3 ? 7 - week : -week;
    });
    const weeks = computed(() => {
      const week = props.firstDayOfWeek;
      return daysNames.concat(daysNames).slice(week, week + 7);
    });
    const year = computed(() => {
      return props.showState.year;
    });
    const month = computed(() => {
      return props.showState.month;
    });
    const startDateInCalendar = computed(() => {
      return getStartDateInCalendar(year.value, month.value);
    });
    const timeDecoder = (num) => {
      return num.toString().length < 2 ? `0${num}` : num;
    };
    const getDateTime = (date) => {
      const hours = timeDecoder(date.getHours());
      const minutes = timeDecoder(date.getMinutes());
      return `${hours}:${minutes}`;
    };
    const dateTableCells = computed(() => {
      const cellsArray = [];
      const date = new Date(year.value, month.value, 1);
      let day = getFirstDayOfMonth(date);
      day = day === 0 ? 7 : day;
      const dateCountOfMonth = getDaysInMonth(date);
      const dateCountOfLastMonth = getDaysInMonth(subMonths(date, 1));
      const offset = offsetDay.value;
      let count = 1;
      const now = getDateTimestamp(/* @__PURE__ */ new Date());
      const WEEKS_IN_CALENDAR = 6;
      const DAYS_IN_CALENDAR = 7 * WEEKS_IN_CALENDAR;
      for (let i = 0; i < DAYS_IN_CALENDAR; i++) {
        const cell = {
          type: "normal",
          inRange: false,
          start: false,
          end: false,
          time: null,
          day: 0,
          month: 0,
          text: 0,
          disabled: false
        };
        const index = i;
        const time = nextDate(startDateInCalendar.value, index - offset).getTime();
        cell.time = null;
        if (state.type === "range") {
          const rangeState = props.stateStore.rangeState;
          if (rangeState.selecting) {
            const hoveredDate = startOfDay(props.hoveredDate);
            const existingDate = rangeState.startDate;
            const arr = [existingDate, hoveredDate].sort((a, b) => a.getTime() - b.getTime());
            cell.inRange = time >= getDateTimestamp(arr[0]) && time <= getDateTimestamp(arr[1]);
          } else {
            if (rangeState.startDate && rangeState.endDate) {
              cell.inRange = time >= getDateTimestamp(rangeState.startDate) && time <= getDateTimestamp(rangeState.endDate);
            }
          }
          if (rangeState.startDate && isSameDay(time, rangeState.startDate)) {
            cell.start = true;
            cell.time = getDateTime(rangeState.startDate);
          }
          if (rangeState.endDate && isSameDay(time, rangeState.endDate)) {
            cell.end = true;
            cell.time = getDateTime(rangeState.endDate);
          }
        }
        if (state.type === "day" && props.stateStore.dayState) {
          const selectedDate = props.stateStore.dayState;
          cell.start = isSameDay(time, selectedDate);
          if (cell.start) {
            cell.time = getDateTime(selectedDate);
          }
        }
        if (state.type === "pick") {
          const selectedDates = props.stateStore.pickState;
          cell.start = selectedDates.some((item) => isSameDay(item, time));
          if (cell.start) {
            const timeOfDay = selectedDates.find((item) => getDateTimestamp(item) === getDateTimestamp(time));
            if (timeOfDay) {
              cell.time = getDateTime(timeOfDay);
            }
          }
        }
        const isToday = time === now;
        if (isToday) {
          cell.type = "today";
        }
        if (i >= 0 && i <= 13) {
          const numberOfDaysFromPreviousMonth = day + offset < 0 ? 7 + day + offset : day + offset;
          if (index >= numberOfDaysFromPreviousMonth) {
            cell.text = count++;
            cell.month = month.value;
          } else {
            cell.text = dateCountOfLastMonth - (numberOfDaysFromPreviousMonth - index % 7) + 1 + Math.floor(index / 7);
            cell.month = month.value === 0 ? 11 : month.value - 1;
            cell.type = "prev-month";
          }
        } else {
          if (count <= dateCountOfMonth) {
            cell.text = count++;
            cell.month = month.value;
          } else {
            cell.text = count++ - dateCountOfMonth;
            cell.type = "next-month";
            cell.month = month.value === 11 ? 0 : month.value + 1;
          }
        }
        cell.disabled = !state.dateFilter(new Date(year.value, cell.month, cell.text));
        cellsArray.push(cell);
      }
      return cellsArray;
    });
    const getCellClasses = (cell) => {
      const selectionMode = state.type;
      const classes = [];
      if (cell.disabled) {
        classes.push("disabled");
      }
      const isCellInCurrentMonth = cell.type === "normal" || cell.type === "today";
      if (isCellInCurrentMonth) {
        classes.push("available");
        if (cell.type === "today") {
          classes.push("today");
        }
      } else {
        classes.push(cell.type);
      }
      if (selectionMode === "day" && props.stateStore.dayState && isCellInCurrentMonth && cell.start) {
        classes.push("current");
      }
      if (selectionMode === "pick" && isCellInCurrentMonth && cell.start) {
        classes.push("start-date");
      }
      if (cell.inRange && isCellInCurrentMonth) {
        classes.push("in-range");
        if (cell.start) {
          classes.push("start-date");
        }
        if (cell.end) {
          classes.push("end-date");
        }
      }
      return classes.join(" ");
    };
    const handleMouseMove = (event) => {
      if (!props.stateStore.rangeState.selecting)
        return;
      let target = event.target;
      if (target.tagName === "SPAN") {
        target = target.parentNode;
      }
      if (target.tagName !== "DIV")
        return;
      const idx = target.getAttribute("index");
      if (!idx)
        return;
      const cell = dateTableCells.value[idx];
      const newDate = new Date(year.value, cell.month, cell.text);
      if (isSameDay(newDate, props.hoveredDate))
        return;
      emit("update:hovered-date", newDate);
    };
    const handleClick = (ev) => {
      let target = ev.target;
      if (target.tagName === "SPAN") {
        target = target.parentNode;
      }
      if (target.tagName !== "DIV")
        return;
      const idx = target.getAttribute("index");
      if (!idx)
        return;
      const cell = dateTableCells.value[idx];
      if (cell.disabled) {
        return;
      }
      const newDate = new Date(year.value, cell.month, cell.text);
      if (state.type === "range") {
        if (!props.stateStore.rangeState.selecting) {
          const rangeStateSelecting = {
            startDate: newDate,
            endDate: null,
            selecting: true,
            selectedField: "startDate"
          };
          emit("pick", rangeStateSelecting);
        } else {
          const dat = props.stateStore.rangeState.startDate;
          if (dat && newDate >= dat) {
            const rangeStateSelected = {
              startDate: dat,
              endDate: newDate,
              selecting: false,
              selectedField: "endDate"
            };
            emit("pick", rangeStateSelected);
          } else {
            const rangeStateSelected = {
              startDate: newDate,
              endDate: dat,
              selecting: false,
              selectedField: "startDate"
            };
            emit("pick", rangeStateSelected);
          }
        }
      } else if (state.type === "day") {
        emit("pick", newDate);
      } else if (state.type === "pick") {
        const currentArr = props.stateStore.pickState;
        const dateSelected = currentArr.find((date) => {
          return isSameDay(date, newDate);
        });
        let newArr;
        if (dateSelected) {
          newArr = currentArr.filter((date) => !isSameDay(date, newDate));
        } else {
          newArr = [...currentArr, newDate];
        }
        emit("pick", newArr);
      }
      if (cell.type === "prev-month") {
        emit("update:showed-state", -1);
      }
      if (cell.type === "next-month") {
        emit("update:showed-state", 1);
      }
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "s-date-picker-date-table date-table sora-tpg-p4",
        onClick: handleClick,
        onMouseover: handleMouseMove,
        onFocus: handleMouseMove,
        onKeydown: handleClick
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(weeks), (day, key) => {
          return openBlock(), createElementBlock("div", {
            key,
            class: "date-table__title"
          }, toDisplayString(day), 1);
        }), 128)),
        (openBlock(true), createElementBlock(Fragment, null, renderList(unref(dateTableCells), (cell, idx) => {
          return openBlock(), createElementBlock("div", {
            key: idx,
            class: normalizeClass(["date-table__cell relative", getCellClasses(cell)]),
            index: idx
          }, [
            createElementVNode("span", _hoisted_2$c, toDisplayString(cell.text), 1),
            unref(state).time ? withDirectives((openBlock(), createElementBlock("span", {
              key: 0,
              class: "absolute date-time"
            }, toDisplayString(cell.time), 513)), [
              [vShow, cell.time]
            ]) : createCommentVNode("", true)
          ], 10, _hoisted_1$k);
        }), 128))
      ], 32);
    };
  }
});

const SDatePickerTableDate_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$j = { class: "flex flex-col justify-start items-center" };
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelDate",
  props: {
    showState: {},
    hideArrows: { type: Boolean, default: false },
    stateStore: {},
    hoveredDate: {}
  },
  emits: ["update:showed-state", "change-view", "pick", "update:hovered-date"],
  setup(__props, { emit }) {
    const updateShowedState = (deltaMonth) => {
      emit("update:showed-state", deltaMonth);
    };
    const changeView = (viewName) => {
      emit("change-view", viewName);
    };
    const onDatePick = (data) => {
      emit("pick", data);
    };
    const updateHoveredDate = (date) => {
      emit("update:hovered-date", date);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$j, [
        createVNode(_sfc_main$l, {
          class: "w-full",
          "show-state": _ctx.showState,
          "hide-arrows": _ctx.hideArrows,
          "hovered-date": _ctx.hoveredDate,
          "onUpdate:showedState": updateShowedState,
          onChangeView: changeView
        }, null, 8, ["show-state", "hide-arrows", "hovered-date"]),
        createVNode(_sfc_main$k, {
          "show-state": _ctx.showState,
          "state-store": _ctx.stateStore,
          "hovered-date": _ctx.hoveredDate,
          onPick: onDatePick,
          "onUpdate:showedState": updateShowedState,
          "onUpdate:hoveredDate": updateHoveredDate
        }, null, 8, ["show-state", "state-store", "hovered-date"])
      ]);
    };
  }
});

const _hoisted_1$i = { class: "s-date-picker-calendars-panel" };
const _hoisted_2$b = {
  key: 0,
  class: "ml-4"
};
const _hoisted_3$7 = {
  key: 1,
  class: "h-full w-full flex items-start justify-center"
};
const _hoisted_4$4 = { key: 2 };
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelCalendars",
  props: {
    currentView: {},
    showState: {},
    stateStore: {},
    modelValue: {}
  },
  emits: ["update:showed-state", "change-view", "pick"],
  setup(__props, { emit }) {
    const props = __props;
    const state = useDatePickerApi();
    const hoveredDate = ref(/* @__PURE__ */ new Date());
    const isRange = computed(() => {
      return state.type === "range";
    });
    const nextMonthShowState = computed(() => {
      const month = props.showState.month > 10 ? 0 : props.showState.month + 1;
      const year = month === 0 ? props.showState.year + 1 : props.showState.year;
      return {
        month,
        year
      };
    });
    const changeView = (viewName) => {
      emit("change-view", viewName);
    };
    const onDatePick = (data) => {
      emit("pick", data);
    };
    const updateShowedState = (deltaMonth) => {
      let newMonth = props.showState.month + deltaMonth;
      if (newMonth > 11) {
        emit("update:showed-state", 0, props.showState.year + 1);
      } else if (newMonth < 0) {
        emit("update:showed-state", 11, props.showState.year - 1);
      } else {
        emit("update:showed-state", newMonth);
      }
      return;
    };
    const updateShowedMonth = (month) => {
      emit("update:showed-state", month);
    };
    const updateShowedYear = (year) => {
      emit("update:showed-state", void 0, year);
    };
    const updateHoveredDate = (date) => {
      hoveredDate.value = date;
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$i, [
        createElementVNode("div", null, [
          withDirectives(createVNode(_sfc_main$j, {
            "show-state": _ctx.showState,
            "state-store": _ctx.stateStore,
            "hovered-date": unref(hoveredDate),
            onChangeView: changeView,
            "onUpdate:showedState": updateShowedState,
            onPick: onDatePick,
            "onUpdate:hoveredDate": updateHoveredDate
          }, null, 8, ["show-state", "state-store", "hovered-date"]), [
            [vShow, _ctx.currentView === "dates"]
          ])
        ]),
        unref(isRange) ? (openBlock(), createElementBlock("div", _hoisted_2$b, [
          withDirectives(createVNode(_sfc_main$j, {
            "show-state": unref(nextMonthShowState),
            "state-store": _ctx.stateStore,
            "hovered-date": unref(hoveredDate),
            onChangeView: changeView,
            "onUpdate:showedState": updateShowedState,
            onPick: onDatePick,
            "onUpdate:hoveredDate": updateHoveredDate
          }, null, 8, ["show-state", "state-store", "hovered-date"]), [
            [vShow, _ctx.currentView === "dates"]
          ])
        ])) : createCommentVNode("", true),
        _ctx.currentView === "months" ? (openBlock(), createElementBlock("div", _hoisted_3$7, [
          createVNode(MonthTable, {
            "show-state": _ctx.showState,
            onPick: updateShowedMonth,
            "onUpdate:showedYear": updateShowedYear
          }, null, 8, ["show-state"])
        ])) : createCommentVNode("", true),
        _ctx.currentView === "years" ? (openBlock(), createElementBlock("div", _hoisted_4$4, [
          createVNode(YearTable, {
            value: _ctx.showState.year,
            onPick: updateShowedYear
          }, null, 8, ["value"])
        ])) : createCommentVNode("", true)
      ]);
    };
  }
});

const SDatePickerPanelCalendars_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$h = { class: "s-date-picker-custom-panel flex items-center relative px-16px" };
const _hoisted_2$a = {
  key: 0,
  class: "flex justify-center items-center"
};
const _hoisted_3$6 = ["maxlength", "value"];
const _hoisted_4$3 = /* @__PURE__ */ createElementVNode("div", { class: "mx-2" }, " - ", -1);
const _hoisted_5$3 = ["maxlength", "value"];
const _hoisted_6$2 = ["maxlength", "value"];
const _hoisted_7$1 = ["maxlength", "value"];
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "SDatePickerPanelCustom",
  props: {
    stateStore: {},
    formatDate: {},
    formatPattern: {},
    showInputs: { type: Boolean, default: false }
  },
  emits: ["update:custom-input", "click:done"],
  setup(__props, { emit }) {
    const props = __props;
    const state = useDatePickerApi();
    const fromFormat = (dateString) => {
      let date = parse(dateString, props.formatPattern, /* @__PURE__ */ new Date());
      if (!isValid(date))
        return null;
      return date;
    };
    const pickState = computed(() => {
      return props.stateStore.pickState;
    });
    const customInputValue = (field) => {
      return props.formatDate(props.stateStore.rangeState[field]);
    };
    const updateCustomInput = (event, field) => {
      const newVal = event.target.value;
      const date = fromFormat(newVal);
      emit("update:custom-input", date, field);
    };
    const updateCustomInputDay = (event) => {
      const newVal = event.target.value;
      const date = fromFormat(newVal);
      emit("update:custom-input", date);
    };
    const updateCustomInputPick = (event) => {
      const newVal = event.target.value;
      const date = fromFormat(newVal);
      emit("update:custom-input", date);
    };
    const customInputValuePick = computed(() => {
      return props.formatDate(props.stateStore.pickState[props.stateStore.pickState.length - 1]);
    });
    const customInputValueStartDate = computed(() => {
      return customInputValue("startDate");
    });
    const customInputValueEndDate = computed(() => {
      return customInputValue("endDate");
    });
    const customInputValueDay = computed(() => {
      return props.formatDate(props.stateStore.dayState);
    });
    const customInputCssClass = computed(() => {
      return `s-date-picker-custom-panel__input${state.time ? "_time" : ""}`;
    });
    function handleInput(event) {
      if (!(event instanceof InputEvent) || !(event.target instanceof HTMLInputElement))
        return;
      if (event.inputType === "deleteContentBackward") {
        return;
      }
      const res = state.time ? dateTimeMask(event.target.value) : dateMask(event.target.value);
      if (res) {
        event.target.value = res;
      }
    }
    function dateMask(date) {
      if (date.match(/^\d{2}$/) !== null) {
        return date + "/";
      }
      if (date.match(/^\d{2}\/\d{2}$/) !== null) {
        return date + "/";
      }
    }
    function dateTimeMask(date) {
      const res = dateMask(date);
      if (res) {
        return res;
      }
      if (date.match(/^\d{2}\/\d{2}\/\d{4}$/) !== null) {
        return date + ", ";
      }
      if (date.match(/^\d{2}\/\d{2}\/\d{4}, \d{2}$/) !== null) {
        return date + ":";
      }
      if (date.match(/^\d{2}\/\d{2}\/\d{4}, \d{2}:\d{2}$/) !== null) {
        return date;
      }
    }
    const customInputLength = computed(() => {
      return state.time ? 17 : 10;
    });
    const onDoneClick = () => {
      emit("click:done");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$h, [
        _ctx.showInputs ? (openBlock(), createElementBlock("div", _hoisted_2$a, [
          unref(state).type === "range" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createElementVNode("input", {
              maxlength: unref(customInputLength),
              class: normalizeClass(["s-date-picker-custom-panel__input", unref(customInputCssClass)]),
              value: unref(customInputValueStartDate),
              onInput: handleInput,
              onChange: _cache[0] || (_cache[0] = ($event) => updateCustomInput($event, "startDate"))
            }, null, 42, _hoisted_3$6),
            _hoisted_4$3,
            createElementVNode("input", {
              maxlength: unref(customInputLength),
              class: normalizeClass(["s-date-picker-custom-panel__input", unref(customInputCssClass)]),
              value: unref(customInputValueEndDate),
              onInput: handleInput,
              onChange: _cache[1] || (_cache[1] = ($event) => updateCustomInput($event, "endDate"))
            }, null, 42, _hoisted_5$3)
          ], 64)) : createCommentVNode("", true),
          unref(state).type === "day" ? (openBlock(), createElementBlock("input", {
            key: 1,
            maxlength: unref(customInputLength),
            class: normalizeClass(["s-date-picker-custom-panel__input", unref(customInputCssClass)]),
            value: unref(customInputValueDay),
            onInput: handleInput,
            onChange: _cache[2] || (_cache[2] = ($event) => updateCustomInputDay($event))
          }, null, 42, _hoisted_6$2)) : createCommentVNode("", true),
          unref(state).type === "pick" && unref(pickState).length > 0 ? (openBlock(), createElementBlock("input", {
            key: 2,
            maxlength: unref(customInputLength),
            class: normalizeClass(["s-date-picker-custom-panel__input", unref(customInputCssClass)]),
            value: unref(customInputValuePick),
            onInput: handleInput,
            onChange: _cache[3] || (_cache[3] = ($event) => updateCustomInputPick($event))
          }, null, 42, _hoisted_7$1)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        createElementVNode("button", {
          class: "s-date-picker-custom-panel__save-button ml-auto",
          onClick: onDoneClick
        }, " Done ")
      ]);
    };
  }
});

const SDatePickerPanelCustom_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$g = { class: "s-date-picker" };
const _sfc_main$g = /* @__PURE__ */ defineComponent({
  __name: "SDatePicker",
  props: {
    modelValue: {},
    type: { default: "day" },
    time: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    shortcuts: { type: [Object, Boolean], default: () => DEFAULT_SHORTCUTS },
    dateFilter: { type: Function, default: () => true },
    min: { default: null },
    max: { default: null }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const innerModelValue = shallowRef(props.modelValue);
    watch(
      () => props.modelValue,
      (value) => {
        innerModelValue.value = value;
      },
      { flush: "sync" }
    );
    function isEqualToMinutes(a, b) {
      return isSameDay(a, b) && isSameHour(a, b) && isSameMinute(a, b);
    }
    const minDate = eagerComputed(() => {
      return props.min && {
        date: startOfDay(new Date(props.min)),
        datetime: new Date(props.min)
      };
    });
    const maxDate = eagerComputed(() => {
      return props.max && {
        date: startOfDay(new Date(props.max)),
        datetime: new Date(props.max)
      };
    });
    const dateFilter = (d, precision = "date") => {
      const min = minDate.value?.[precision];
      const max = maxDate.value?.[precision];
      const isEqual = precision === "date" ? isSameDay : isEqualToMinutes;
      return props.dateFilter(d) && (!min || isAfter(d, min) || isEqual(d, min)) && (!max || isBefore(d, max) || isEqual(d, max));
    };
    const datePickerConfig = reactive({
      type: props.type,
      time: props.time,
      disabled: props.disabled,
      dateFilter
    });
    provide(DATE_PICKER_API_KEY, datePickerConfig);
    const today = /* @__PURE__ */ new Date();
    const rangeState = ref({
      selecting: false,
      startDate: null,
      endDate: null,
      selectedField: null
    });
    const dayState = ref(null);
    const pickState = ref([]);
    const stateStore = computed(() => {
      return {
        dayState: dayState.value,
        pickState: pickState.value,
        rangeState: rangeState.value
      };
    });
    const updateModelValue = () => {
      if (props.type === "day") {
        innerModelValue.value = dayState.value;
        save();
      } else if (props.type === "pick") {
        innerModelValue.value = pickState.value;
        save();
      } else {
        if (!rangeState.value.startDate && !rangeState.value.endDate && !rangeState.value.selecting) {
          innerModelValue.value = null;
          save();
          return;
        }
        innerModelValue.value = [rangeState.value.startDate, rangeState.value.endDate];
        if (rangeState.value.endDate) {
          save();
        }
      }
    };
    const onDatePick = (data) => {
      if (props.type === "day") {
        dayState.value = data;
      } else if (props.type === "pick") {
        pickState.value = data;
      } else {
        rangeState.value = data;
      }
      updateTime(timeOptions.value[0]);
      updateModelValue();
    };
    function updateShowedMonths() {
      if (!lastPickedDate.value)
        return;
      updateShowedState(lastPickedDate.value.getMonth(), lastPickedDate.value.getFullYear());
    }
    const showState = ref({
      month: 0,
      year: 0
    });
    showState.value.month = today.getMonth();
    showState.value.year = today.getFullYear();
    const updateShowedState = (month, year) => {
      showState.value.year = year ?? showState.value.year;
      showState.value.month = month ?? showState.value.month;
      changeView("dates");
    };
    const showStateView = computed(() => {
      return ["years", "months"].includes(currentView.value);
    });
    const onMenuClick = (data) => {
      selectedMenuOption.value = data;
      if (data.value === CUSTOM_OPTION_VALUE) {
        return;
      }
      let processedData;
      switch (props.type) {
        case "range": {
          let dateRange = {
            startDate: null,
            endDate: null,
            selecting: false,
            selectedField: null
          };
          if (data.value && Array.isArray(data.value) && data.value[0] instanceof Date && data.value[1] instanceof Date) {
            dateRange = { startDate: data.value[0], endDate: data.value[1], selecting: false, selectedField: "endDate" };
          }
          processedData = dateRange;
          break;
        }
        case "pick":
          processedData = data.value ?? [];
          break;
        case "day":
          processedData = data.value;
          break;
      }
      onDatePick(processedData);
      updateShowedMonths();
    };
    const finalShortcuts = computed(() => {
      if (!props.shortcuts)
        return { day: [], range: [], pick: [] };
      return {
        day: [...props.shortcuts.day ?? [], CUSTOM_OPTION],
        range: [...props.shortcuts.range ?? [], CUSTOM_OPTION],
        pick: [...props.shortcuts.pick ?? [], CUSTOM_OPTION]
      };
    });
    const isEqualDateArrays = (a, b) => {
      for (const i in a) {
        if (!isSameDay(a[i], b[i])) {
          return false;
        }
      }
      return true;
    };
    const isSameValue = (a, b) => {
      return a === null && b === null || a === void 0 && b === void 0 || a instanceof Date && b instanceof Date && isSameDay(a, b) || Array.isArray(a) && Array.isArray(b) && isEqualDateArrays(a, b);
    };
    const selectedMenuOption = shallowRef(CUSTOM_OPTION);
    const appropriateMenuOption = computed(() => {
      for (const shortcut of finalShortcuts.value[props.type]) {
        if (shortcut.value === CUSTOM_OPTION_VALUE)
          continue;
        if (isSameValue(innerModelValue.value, shortcut.value)) {
          return shortcut;
        }
      }
      return CUSTOM_OPTION;
    });
    watch(
      innerModelValue,
      () => {
        selectedMenuOption.value = appropriateMenuOption.value;
      },
      { immediate: true }
    );
    const isPickingAreaVisible = computed(() => innerModelValue.value || selectedMenuOption.value === CUSTOM_OPTION);
    const gridType = computed(() => {
      const time = props.time ? "time" : "";
      const range = props.type === "range" ? "-range" : "";
      const pick = props.type === "pick" ? "-pick" : "";
      return `s-date-picker__panels_date${time}${range || pick || ""}`;
    });
    const currentView = ref("dates");
    const changeView = (viewName) => {
      currentView.value = viewName;
    };
    const headTitle = computed(() => {
      if (appropriateMenuOption.value.value !== CUSTOM_OPTION_VALUE) {
        return appropriateMenuOption.value.label;
      }
      try {
        switch (props.type) {
          case "day":
            return formatDate(innerModelValue.value);
          case "range": {
            const modelValue = innerModelValue.value;
            return modelValue.map((item) => formatDate(item)).join(" - ");
          }
          case "pick": {
            const modelValue = innerModelValue.value;
            return modelValue.map((item) => formatDate(item)).join(", ");
          }
        }
        return "";
      } catch {
        return "";
      }
    });
    const arrowState = computed(() => {
      return showPopper.value ? "reverse" : "";
    });
    const lastPickedDate = computed(() => {
      switch (props.type) {
        case "pick":
          return pickState.value[pickState.value.length - 1] ?? null;
        case "day":
          return dayState.value;
        case "range":
          return rangeState.value.selectedField && rangeState.value[rangeState.value.selectedField];
      }
      return null;
    });
    const timeOptions = computed(() => {
      if (!lastPickedDate.value)
        return TIME_POINTS;
      const result = [];
      for (let time of TIME_POINTS) {
        if (dateFilter(setTimeByString(lastPickedDate.value, time), "datetime")) {
          result.push(time);
        }
      }
      return result;
    });
    const updateTime = (time) => {
      if (!props.time || !lastPickedDate.value)
        return;
      switch (props.type) {
        case "pick":
          pickState.value[pickState.value.length - 1] = setTimeByString(lastPickedDate.value, time);
          break;
        case "day":
          dayState.value = setTimeByString(lastPickedDate.value, time);
          break;
        case "range":
          if (!rangeState.value.selectedField)
            return;
          rangeState.value[rangeState.value.selectedField] = setTimeByString(lastPickedDate.value, time);
          break;
      }
      updateModelValue();
    };
    const currentValueTime = computed(() => {
      let date = lastPickedDate.value;
      if (!date || !dateFilter(date, "datetime"))
        return timeOptions.value[0] ?? `00:00`;
      const hours = timeDecoder(date.getHours());
      const minutes = timeDecoder(date.getMinutes());
      return `${hours}:${minutes}`;
    });
    const timeDecoder = (num) => {
      return num.toString().length < 2 ? `0${num}` : num;
    };
    const updateCustomInput = (data, field) => {
      switch (props.type) {
        case "pick":
          if (data) {
            if (pickState.value.length > 0)
              pickState.value[pickState.value.length - 1] = data;
            else
              pickState.value.push(data);
          }
          break;
        case "day":
          dayState.value = data;
          break;
        case "range":
          if (data)
            rangeState.value[field] = data;
          rangeState.value.selecting = false;
          break;
      }
      updateModelValue();
      updateShowedMonths();
    };
    const formatPattern = computed(() => {
      return props.time ? "dd/MM/yyyy, HH:mm" : "dd/MM/yyyy";
    });
    const formatDate = (date) => {
      if (!date)
        return "";
      return format(date, formatPattern.value);
    };
    const [showPopper, togglePopper] = useToggle(false);
    whenever(
      and(() => props.disabled, showPopper),
      () => togglePopper(false),
      { immediate: true }
    );
    const updateShow = () => {
      if (!props.disabled)
        togglePopper(true);
    };
    const save = () => {
      emit("update:modelValue", innerModelValue.value);
    };
    const saveAndClose = () => {
      save();
      togglePopper(false);
    };
    const showCustomInputs = computed(() => {
      return selectedMenuOption.value.value === CUSTOM_OPTION_VALUE && !showStateView.value;
    });
    watch(
      innerModelValue,
      (newValue) => {
        if (props.type === "day") {
          dayState.value = newValue;
        } else if (props.type === "pick") {
          pickState.value = newValue ?? [];
        } else {
          if (Array.isArray(newValue) && newValue.length === 2) {
            [rangeState.value.startDate, rangeState.value.endDate] = newValue;
          }
        }
        updateShowedMonths();
      },
      { immediate: true }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$g, [
        createVNode(unref(SPopover), {
          show: unref(showPopper),
          "onUpdate:show": _cache[0] || (_cache[0] = ($event) => isRef(showPopper) ? showPopper.value = $event : null),
          placement: "bottom-start",
          trigger: "manual",
          distance: "4",
          onClickOutside: _cache[1] || (_cache[1] = ($event) => unref(togglePopper)(false))
        }, {
          trigger: withCtx(() => [
            createElementVNode("div", null, [
              renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({
                disabled: _ctx.disabled,
                updateShow,
                "isPopperShown": unref(showPopper),
                "label": headTitle.value
              })), () => [
                createElementVNode("div", {
                  class: normalizeClass(["s-date-picker__header p-2 sora-tpg-ch2 relative pr-6", _ctx.disabled ? "cursor-default" : "cursor-pointer"]),
                  onKeydown: updateShow,
                  onClick: updateShow
                }, [
                  createTextVNode(toDisplayString(headTitle.value || "Date") + " ", 1),
                  createElementVNode("div", {
                    class: normalizeClass(["arrow", arrowState.value])
                  }, [
                    createVNode(unref(IconArrowsChevronBottom24))
                  ], 2)
                ], 34)
              ])
            ])
          ]),
          popper: withCtx(() => [
            createVNode(unref(SPopoverWrappedTransition), {
              name: "s-select-dropdown-transition",
              eager: ""
            }, {
              default: withCtx(() => [
                createElementVNode("div", {
                  class: normalizeClass(["s-date-picker__panels sora-tpg-p4", [`${gridType.value}`, { "narrow": showStateView.value }]])
                }, [
                  _ctx.shortcuts && _ctx.type !== "pick" ? (openBlock(), createBlock(_sfc_main$o, {
                    key: 0,
                    type: _ctx.type,
                    "menu-state": selectedMenuOption.value.label,
                    options: finalShortcuts.value,
                    "onClick:option": onMenuClick
                  }, null, 8, ["type", "menu-state", "options"])) : createCommentVNode("", true),
                  isPickingAreaVisible.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createVNode(_sfc_main$i, {
                      "current-view": unref(currentView),
                      "show-state": unref(showState),
                      "model-value": innerModelValue.value,
                      "state-store": stateStore.value,
                      "onUpdate:showedState": updateShowedState,
                      onChangeView: changeView,
                      onPick: onDatePick
                    }, null, 8, ["current-view", "show-state", "model-value", "state-store"]),
                    _ctx.time && !showStateView.value ? (openBlock(), createBlock(_sfc_main$p, {
                      key: 0,
                      value: currentValueTime.value,
                      options: timeOptions.value,
                      "onUpdate:time": updateTime
                    }, null, 8, ["value", "options"])) : createCommentVNode("", true),
                    createVNode(_sfc_main$h, {
                      "show-inputs": showCustomInputs.value,
                      "state-store": stateStore.value,
                      "format-date": formatDate,
                      "format-pattern": formatPattern.value,
                      "onUpdate:customInput": updateCustomInput,
                      "onClick:done": saveAndClose
                    }, null, 8, ["show-inputs", "state-store", "format-pattern"])
                  ], 64)) : createCommentVNode("", true)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 3
        }, 8, ["show"])
      ]);
    };
  }
});

const SDatePicker_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$f = { class: "s-progress-bar" };
const _hoisted_2$9 = /* @__PURE__ */ createElementVNode("div", { class: "s-progress-bar__active-bar" }, null, -1);
const _hoisted_3$5 = [
  _hoisted_2$9
];
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "SProgressBar",
  props: {
    percent: { default: 0 },
    lineHeight: { default: 2 }
  },
  setup(__props) {
    const props = __props;
    useCssVars((_ctx) => ({
      "2520f5a6": unref(activeBarWidth),
      "035fc540": unref(progressBarHeight),
      "108b03aa": unref(borderRadius)
    }));
    const activeBarWidth = computed(() => {
      return props.percent < 0 ? 0 : props.percent > 100 ? `100%` : `${props.percent}%`;
    });
    const borderRadius = computed(() => {
      return `${Number(props.lineHeight) / 2}px`;
    });
    const progressBarHeight = computed(() => {
      return `${props.lineHeight}px`;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$f, _hoisted_3$5);
    };
  }
});

const SProgressBar_vue_vue_type_style_index_0_lang = '';

const TABS_PANEL_BACKGROUND_TYPES = ["primary", "secondary", "none"];
const TABS_PANEL_API_KEY = Symbol("tabsPanel");
function useTabsPanelApi() {
  return forceInject(TABS_PANEL_API_KEY);
}

const _hoisted_1$e = {
  role: "tablist",
  class: "tabs-panel flex items-center justify-start"
};
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "STabsPanel",
  props: {
    modelValue: { default: "" },
    background: { default: "primary" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const selectTab = (tab) => {
      emit("update:modelValue", tab);
    };
    const active = computed(() => props.modelValue);
    const tabState = reactive({
      active,
      selectTab,
      background: props.background
    });
    provide(TABS_PANEL_API_KEY, tabState);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$e, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ]);
    };
  }
});

const STabsPanel_vue_vue_type_style_index_0_scoped_c2c69483_lang = '';

const STabsPanel = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["__scopeId", "data-v-c2c69483"]]);

const _hoisted_1$d = ["disabled"];
const _hoisted_2$8 = { class: "s-tab__label-container flex justify-center items-center" };
const _hoisted_3$4 = { class: "s-tab__label" };
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "STab",
  props: {
    disabled: { type: Boolean, default: false },
    name: {}
  },
  setup(__props) {
    const props = __props;
    const state = useTabsPanelApi();
    const { active } = toRefs(state);
    const { selectTab, background } = state;
    const tabIsActive = computed(() => props.name === active.value);
    const activateTab = () => {
      selectTab(props.name);
    };
    watch(
      () => props.disabled,
      (newVal) => {
        if (newVal && tabIsActive.value) {
          selectTab("");
        }
      }
    );
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", {
        role: "tab",
        class: normalizeClass(["s-tab flex justify-center items-center sora-tpg-p2", [{ "s-tab_active": unref(tabIsActive) }, `s-tab_background_${unref(background)}`]]),
        disabled: _ctx.disabled,
        onClick: activateTab
      }, [
        createElementVNode("div", _hoisted_2$8, [
          createElementVNode("div", _hoisted_3$4, [
            renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 10, _hoisted_1$d);
    };
  }
});

const STab_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$c = { class: "flex items-center justify-start" };
const _hoisted_2$7 = {
  key: 2,
  class: "title"
};
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "SBadge",
  props: {
    type: { default: "active" },
    colorBackground: { type: Boolean, default: false },
    withBorder: { type: Boolean, default: false },
    onlyMarker: { type: Boolean, default: false },
    tabular: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const showSpinner = computed(() => {
      return props.type === "pending";
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["sora-tpg-ch3 py-5px", [
          "s-badge",
          { "s-badge_border": _ctx.withBorder, "px-10px": !_ctx.tabular },
          _ctx.colorBackground ? `s-badge_color_${_ctx.type} text-white` : " primary-text-color"
        ]])
      }, [
        createElementVNode("div", _hoisted_1$c, [
          !unref(showSpinner) ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: normalizeClass(["marker", !_ctx.colorBackground ? `s-badge_color_${_ctx.type}` : "bg-white"])
          }, null, 2)) : (openBlock(), createBlock(unref(SSpinner), {
            key: 1,
            class: "spinner"
          })),
          !_ctx.onlyMarker ? (openBlock(), createElementBlock("span", _hoisted_2$7, [
            renderSlot(_ctx.$slots, "default")
          ])) : createCommentVNode("", true)
        ])
      ], 2);
    };
  }
});

const SBadge_vue_vue_type_style_index_0_lang = '';

const BadgeTypes = ["active", "error", "warning", "info", "debug", "pending"];

const NAVIGATION_MENU_API_KEY = Symbol("NavigationMenuAPI");
const NAVIGATION_SUBMENU_API_KEY = Symbol("NavigationSubmenuAPI");
const useNavigationMenuApi = () => forceInject(NAVIGATION_MENU_API_KEY);
const useNavigationSubmenuApi = () => inject(NAVIGATION_SUBMENU_API_KEY, void 0);

const _hoisted_1$b = { class: "s-navigation-menu-item-body__prepend flex-shrink-0 flex items-center justify-end h-16px w-16px mr-8px" };
const _hoisted_2$6 = { class: "ml-auto pl-8px" };
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "SNavigationMenuItemBody",
  props: {
    tag: { default: "div" },
    submenuItem: { type: Boolean, default: false },
    active: { type: Boolean, default: false },
    highlighted: { type: Boolean },
    minified: { type: Boolean, default: false }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(_ctx.tag), {
        class: normalizeClass(["s-navigation-menu-item-body flex items-center cursor-pointer pl-24px pr-16px", {
          "s-navigation-menu-item-body_submenu-item": _ctx.submenuItem,
          "s-navigation-menu-item-body_active": _ctx.active,
          "s-navigation-menu-item-body_highlighted": _ctx.highlighted,
          "py-8px": _ctx.submenuItem,
          "py-14px": !_ctx.submenuItem
        }])
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1$b, [
            !_ctx.submenuItem ? renderSlot(_ctx.$slots, "icon", {
              key: 0,
              class: normalizeClass("s-navigation-menu-item-body__icon")
            }) : createCommentVNode("", true)
          ]),
          createElementVNode("div", {
            class: normalizeClass(["s-navigation-menu-item-body__content truncate", {
              "invisible": _ctx.minified
            }])
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2),
          withDirectives(createElementVNode("div", _hoisted_2$6, [
            renderSlot(_ctx.$slots, "append", {
              class: normalizeClass("s-navigation-menu-item-body__append")
            })
          ], 512), [
            [vShow, !_ctx.minified]
          ])
        ]),
        _: 3
      }, 8, ["class"]);
    };
  }
});

const SNavigationMenuItemBody_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$a = { role: "none" };
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "SNavigationMenuItem",
  props: {
    value: {}
  },
  setup(__props) {
    const props = __props;
    const menuApi = useNavigationMenuApi();
    const isSelected = computed(() => menuApi.active === props.value);
    const isMenuCollapsed = computed(() => menuApi.collapsed);
    function handleClick() {
      menuApi.select(props.value);
    }
    let isInSubmenu = false;
    const submenuApi = useNavigationSubmenuApi();
    if (submenuApi) {
      const value = computed(() => props.value);
      isInSubmenu = true;
      submenuApi.register(value);
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", _hoisted_1$a, [
        createVNode(_sfc_main$b, {
          role: "treeitem",
          "aria-selected": isSelected.value,
          active: isSelected.value,
          "submenu-item": unref(isInSubmenu),
          minified: isMenuCollapsed.value,
          onClick: handleClick
        }, {
          icon: withCtx((iconProps) => [
            renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps(iconProps)))
          ]),
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["aria-selected", "active", "submenu-item", "minified"])
      ]);
    };
  }
});

const _hoisted_1$9 = { class: "s-navigation-menu__header" };
const _hoisted_2$5 = {
  class: "flex-grow",
  role: "tree"
};
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "SNavigationMenu",
  props: {
    modelValue: { default: "" },
    collapsed: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit }) {
    const props = __props;
    const model = useVModel(props, "modelValue", emit, { passive: true });
    const collapsed = computed(() => props.collapsed);
    const api = readonly({
      active: model,
      select,
      collapsed
    });
    function select(value) {
      model.value = value;
    }
    provide(NAVIGATION_MENU_API_KEY, api);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("nav", {
        class: normalizeClass(["s-navigation-menu flex flex-col", {
          "s-navigation-menu_collapsed": unref(collapsed)
        }])
      }, [
        createElementVNode("div", _hoisted_1$9, [
          renderSlot(_ctx.$slots, "header")
        ]),
        createElementVNode("ul", _hoisted_2$5, [
          renderSlot(_ctx.$slots, "default")
        ]),
        renderSlot(_ctx.$slots, "footer")
      ], 2);
    };
  }
});

const SNavigationMenu_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$8 = ["aria-expanded", "aria-selected"];
const _hoisted_2$4 = { class: "s-navigation-submenu__items" };
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "SNavigationSubmenu",
  setup(__props) {
    const includedItems = shallowReactive(/* @__PURE__ */ new Set([]));
    const api = readonly({
      register
    });
    provide(NAVIGATION_SUBMENU_API_KEY, api);
    function register(index) {
      includedItems.add(index);
      onScopeDispose(() => includedItems.delete(index));
    }
    const [opened, toggle] = useToggle(false);
    function handleTriggerClick() {
      if (!isMenuCollapsed.value) {
        toggle();
      }
    }
    const menuApi = useNavigationMenuApi();
    let isMenuCollapsed = computed(() => menuApi.collapsed);
    let hasActiveItem = computed(() => {
      for (const item of includedItems) {
        if (item.value === menuApi.active) {
          return true;
        }
      }
      return false;
    });
    whenever(and(not(isMenuCollapsed), hasActiveItem), () => toggle(true), { immediate: true });
    whenever(isMenuCollapsed, () => toggle(false), { immediate: true });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", {
        role: "treeitem",
        "aria-expanded": unref(opened),
        "aria-selected": unref(opened),
        class: normalizeClass(["s-navigation-submenu", { "s-navigation-submenu_opened": unref(opened) }])
      }, [
        createVNode(_sfc_main$b, {
          active: unref(hasActiveItem),
          highlighted: unref(opened),
          minified: unref(isMenuCollapsed),
          onClick: handleTriggerClick
        }, {
          icon: withCtx((iconProps) => [
            renderSlot(_ctx.$slots, "icon", normalizeProps(guardReactiveProps(iconProps)))
          ]),
          append: withCtx((appendProps) => [
            createVNode(unref(IconChevronBottom16), mergeProps(appendProps, {
              class: "s-navigation-submenu__chevron",
              "aria-hidden": "true",
              width: "10",
              heigh: "10"
            }), null, 16)
          ]),
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "title")
          ]),
          _: 3
        }, 8, ["active", "highlighted", "minified"]),
        createVNode(unref(_sfc_main$P), null, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", null, [
              createElementVNode("ul", _hoisted_2$4, [
                renderSlot(_ctx.$slots, "default")
              ])
            ], 512), [
              [vShow, unref(opened)]
            ])
          ]),
          _: 3
        })
      ], 10, _hoisted_1$8);
    };
  }
});

const SNavigationSubmenu_vue_vue_type_style_index_0_lang = '';

const TABLE_COLUMN_TYPE_VALUES = ["default", "selection", "expand", "details"];
const TABLE_COLUMN_ALIGN_VALUES = ["left", "center", "right"];
const TABLE_DEFAULT_ADAPT_BREAKPOINT = 920;
const TABLE_CARDS_GRID_DEFAULT_BREAKPOINTS = [{ test: (width) => width >= 640, value: 2 }];

function useColumnSort(data) {
  const sortState = shallowReactive({
    column: null,
    order: null
  });
  let sortedData = shallowRef(data.value);
  function startSortWithNewColumn(column) {
    sortState.column = column;
    sortState.order = null;
  }
  function getNextOrder(column, order) {
    const index = column.sortOrders.indexOf(order);
    return column.sortOrders[(index + 1) % column.sortOrders.length];
  }
  function getKey(column, { value, index }) {
    if (!column.sortBy) {
      return [get(value, column.prop)];
    }
    let sortByArray = Array.isArray(column.sortBy) ? column.sortBy : [column.sortBy];
    return sortByArray.map((by) => {
      if (typeof by === "string") {
        return get(value, by);
      }
      return by(value, index);
    });
  }
  function compareByKey(a, b) {
    for (let i = 0; i < a.key.length; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  }
  function sortData(order, column) {
    if (column.sortable === "custom") {
      return;
    }
    if (order === null) {
      sortedData.value = data.value;
      return;
    }
    const orderModifier = order === "ascending" ? 1 : -1;
    const sortMethod = column.sortMethod;
    if (sortMethod) {
      sortedData.value = [...data.value].sort((a, b) => orderModifier * sortMethod(a, b));
      return;
    }
    sortedData.value = data.value.map((value, index) => ({ value, key: getKey(column, { value, index }) })).sort((a, b) => orderModifier * compareByKey(a, b)).map((x) => x.value);
  }
  function handleSortChange(column) {
    if (!column.sortable) {
      return;
    }
    if (sortState.column !== column) {
      startSortWithNewColumn(column);
    }
    sortState.order = getNextOrder(column, sortState.order);
    sortData(sortState.order, column);
  }
  function sortExplicitly(column, newOrder) {
    if (sortState.column !== column) {
      startSortWithNewColumn(column);
    }
    sortState.order = newOrder;
    sortData(newOrder, column);
  }
  function applyCurrentSort() {
    if (!sortState.column || sortState.column.sortable === "custom") {
      sortedData.value = data.value;
      return;
    }
    sortData(sortState.order, sortState.column);
  }
  function clearSort() {
    startSortWithNewColumn(null);
    sortedData.value = data.value;
  }
  return {
    sortedData,
    sortState,
    sortExplicitly,
    applyCurrentSort,
    handleSortChange,
    clearSort,
    getNextOrder
  };
}

function useFlexColumns(columns, tableWidth, fit) {
  const columnsWidths = computed(() => {
    const baseColumnsWidths = columns.map((col) => col.width ?? col.minWidth);
    if (fit.value) {
      const baseColumnsWidthsSum = baseColumnsWidths.reduce((sum, width) => sum + width, 0);
      const freeSpace = tableWidth.value - baseColumnsWidthsSum;
      const columnsMinWidthsSum = columns.reduce((sum, col) => sum + (col.width ? 0 : col.minWidth), 0);
      if (freeSpace > 0) {
        return columns.map((col) => {
          if (col.width)
            return col.width;
          return col.minWidth + col.minWidth * freeSpace / columnsMinWidthsSum;
        });
      }
    }
    return baseColumnsWidths;
  });
  const columnsWidthsSum = computed(() => columnsWidths.value.reduce((sum, width) => sum + width, 0));
  return {
    columnsWidths,
    columnsWidthsSum
  };
}

function useRowSelect(data, options) {
  const selectedRows = shallowReactive(/* @__PURE__ */ new Set());
  const isAllSelected = computed(() => selectedRows.size === data.value.length);
  const isSomeSelected = computed(() => selectedRows.size > 0);
  function toggleAllSelection(selectable) {
    const selectableRows = selectable ? data.value.filter((row, index) => selectable(row, index)) : data.value;
    if (selectedRows.size === selectableRows.length) {
      selectedRows.clear();
      return;
    }
    if (selectedRows.size === 0) {
      for (let row of selectableRows) {
        selectedRows.add(row);
      }
      return;
    }
    if (options.selectOnIndeterminate) {
      for (let row of selectableRows) {
        selectedRows.add(row);
      }
    } else {
      selectedRows.clear();
    }
  }
  function toggleRowSelection(row, value) {
    if (value !== void 0 && !value || value === void 0 && selectedRows.has(row)) {
      selectedRows.delete(row);
      return;
    }
    selectedRows.add(row);
  }
  return {
    selectedRows,
    isAllSelected,
    isSomeSelected,
    toggleAllSelection,
    toggleRowSelection
  };
}

function useColumnExpand() {
  const expandedRows = shallowReactive(/* @__PURE__ */ new Set());
  function toggleRowExpanded(row, value) {
    if (value !== void 0 && !value || value === void 0 && expandedRows.has(row)) {
      expandedRows.delete(row);
      return;
    }
    expandedRows.add(row);
  }
  return {
    expandedRows,
    toggleRowExpanded
  };
}

function isDefaultColumn(column) {
  return column.type === "default";
}
function isSelectionColumn(column) {
  return column.type === "selection";
}
function isExpandColumn(column) {
  return column.type === "expand";
}
function isDetailsColumn(column) {
  return column.type === "details";
}
function isRecord(obj) {
  return obj !== null && typeof obj === "object";
}
function getDefaultCellValue(row, column, index) {
  return column.formatter ? column.formatter(row, column, get(row, column.prop), index) : get(row, column.prop);
}
function getCellTooltipContent(row, column) {
  if (!column.showOverflowTooltip || !isDefaultColumn(column)) {
    return "";
  }
  return String(get(row, column.prop));
}

const TABLE_API_KEY = Symbol("TableAPI");
const useTableApi = () => forceInject(TABLE_API_KEY);

function useTableHeights({
  propHeight,
  propMaxHeight,
  headerHeight,
  tableHeight
}) {
  function parseHeight(height) {
    if (typeof height === "number") {
      return height;
    }
    if (/^\d+(?:px)?$/.test(height)) {
      return parseInt(height, 10);
    }
    return height;
  }
  const tableHeightStyles = computed(() => {
    const parsedHeight = parseHeight(propHeight.value);
    const parsedMaxHeight = parseHeight(propMaxHeight.value);
    return {
      height: typeof parsedHeight === "number" ? parsedHeight + "px" : parsedHeight,
      "max-height": typeof parsedMaxHeight === "number" ? parsedMaxHeight + "px" : parsedMaxHeight
    };
  });
  const bodyHeightStyles = ref({});
  watch(
    [headerHeight, tableHeight],
    () => {
      if (propHeight.value) {
        const bodyHeight = tableHeight.value - headerHeight.value;
        bodyHeightStyles.value = {
          height: bodyHeight ? bodyHeight + "px" : ""
        };
        return;
      }
      if (propMaxHeight.value) {
        const maxHeight = parseHeight(propMaxHeight.value);
        if (typeof maxHeight === "number") {
          return {
            "max-height": maxHeight - headerHeight.value + "px"
          };
        }
      }
    },
    { immediate: true }
  );
  return {
    tableHeightStyles,
    bodyHeightStyles
  };
}

const _hoisted_1$7 = ["title"];
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "STableCellDefault",
  props: {
    tooltip: { default: "" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "s-table-cell-default h-full flex flex-col justify-center px-16px",
        title: _ctx.tooltip
      }, [
        createElementVNode("div", {
          class: normalizeClass(["s-table-cell-default__content", { "s-table-cell-default__content_has-tooltip": _ctx.tooltip }])
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 8, _hoisted_1$7);
    };
  }
});

const STableCellDefault_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$6 = { class: "s-table-cell-selection h-full flex flex-col justify-center px-16px" };
const _sfc_main$6 = /* @__PURE__ */ defineComponent({
  __name: "STableCellSelection",
  props: {
    disabled: { type: Boolean, default: false },
    checked: { type: [Boolean, String], default: false }
  },
  emits: ["select"],
  setup(__props, { emit }) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1$6, [
        createVNode(unref(SCheckboxAtom), {
          class: normalizeClass({ "cursor-pointer": !_ctx.disabled }),
          size: "xl",
          tabindex: _ctx.disabled ? -1 : 0,
          checked: _ctx.checked,
          disabled: _ctx.disabled,
          onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.disabled || emit("select"), ["stop"])),
          onKeypress: _cache[1] || (_cache[1] = withKeys(($event) => _ctx.disabled || emit("select"), ["space"]))
        }, null, 8, ["class", "tabindex", "checked", "disabled"])
      ]);
    };
  }
});

const _hoisted_1$5 = { class: "s-table-cell-expand h-full flex flex-col justify-center cursor-pointer px-16px" };
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "STableCellExpand",
  props: {
    active: { type: Boolean, default: false }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", _hoisted_1$5, [
        createVNode(unref(IconArrowsChevronDownRounded24), {
          class: normalizeClass(["s-table-cell-expand__icon", { "s-table-cell-expand__icon_active": _ctx.active }])
        }, null, 8, ["class"])
      ]);
    };
  }
});

const STableCellExpand_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$4 = { class: "s-table-cell-details w-full h-full flex flex-col justify-center cursor-pointer" };
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "STableCellDetails",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("button", _hoisted_1$4, [
        createVNode(unref(IconArrowsChevronRightXs24), { class: "s-table-cell-details__icon self-center" })
      ]);
    };
  }
});

const STableCellDetails_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$3 = ["tabindex", "onKeypress"];
const _hoisted_2$3 = { class: "p-8px grid grid-cols-[min-content_1fr] items-baseline" };
const _hoisted_3$3 = ["onClick", "onContextmenu"];
const _hoisted_4$2 = ["title", "onMouseenter", "onMouseleave", "onClick", "onDblclick", "onContextmenu"];
const _hoisted_5$2 = {
  key: 0,
  class: "s-table-card__expanded-block p-16px"
};
const _sfc_main$3 = /* @__PURE__ */ defineComponent({
  __name: "STableCard",
  props: {
    row: {},
    columns: { default: () => [] },
    activeExpandColumn: { default: null },
    expanded: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false }
  },
  emits: ["select", "expand", "click:details", "mouse-event:label", "mouse-event:value"],
  setup(__props, { emit }) {
    const props = __props;
    const visibleColumns = computed(() => props.columns.filter((x) => !isSelectionColumn(x)));
    function select() {
      if (!props.selectable) {
        return;
      }
      emit("select");
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["s-table-card", {
          "cursor-pointer": _ctx.selectable,
          "s-table-card_selected": _ctx.selected
        }]),
        tabindex: _ctx.selectable ? 0 : -1,
        onClick: select,
        onKeypress: withKeys(withModifiers(select, ["prevent"]), ["space", "enter"])
      }, [
        createElementVNode("div", _hoisted_2$3, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(visibleColumns), (column, columnIndex) => {
            return openBlock(), createElementBlock(Fragment, {
              key: column.id
            }, [
              createElementVNode("div", {
                class: "s-table-card__label flex flex-col justify-center h-40px pl-32px pr-8px sora-tpg-ch3 whitespace-nowrap",
                onClick: ($event) => emit("mouse-event:label", { column, "event": $event }),
                onContextmenu: ($event) => emit("mouse-event:label", { column, "event": $event })
              }, [
                unref(isDefaultColumn)(column) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  column.headerSlot ? (openBlock(), createBlock(resolveDynamicComponent(column.headerSlot), normalizeProps(mergeProps({ key: 0 }, { column, columnIndex })), null, 16)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(column.label), 1)
                  ], 64))
                ], 64)) : createCommentVNode("", true)
              ], 40, _hoisted_3$3),
              createElementVNode("div", {
                class: "flex flex-col justify-center items-start px-16px h-40px sora-tpg-p3 min-w-0",
                title: unref(getCellTooltipContent)(_ctx.row.data, column),
                onMouseenter: ($event) => emit("mouse-event:value", { "row": _ctx.row.data, column, "event": $event }),
                onMouseleave: ($event) => emit("mouse-event:value", { "row": _ctx.row.data, column, "event": $event }),
                onClick: ($event) => emit("mouse-event:value", { "row": _ctx.row.data, column, "event": $event }),
                onDblclick: ($event) => emit("mouse-event:value", { "row": _ctx.row.data, column, "event": $event }),
                onContextmenu: ($event) => emit("mouse-event:value", { "row": _ctx.row.data, column, "event": $event })
              }, [
                unref(isDefaultColumn)(column) ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: normalizeClass({ "truncate w-full": unref(getCellTooltipContent)(_ctx.row.data, column) })
                }, [
                  column.cellSlot ? (openBlock(), createBlock(resolveDynamicComponent(column.cellSlot), normalizeProps(mergeProps({ key: 0 }, { "row": _ctx.row.data, column, "rowIndex": _ctx.row.index })), null, 16)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(unref(getDefaultCellValue)(_ctx.row.data, column, _ctx.row.index)), 1)
                  ], 64))
                ], 2)) : unref(isExpandColumn)(column) ? (openBlock(), createBlock(_sfc_main$K, {
                  key: 1,
                  type: "outline",
                  size: "sm",
                  "icon-position": "right",
                  onClick: _cache[0] || (_cache[0] = withModifiers(($event) => emit("expand"), ["stop"])),
                  onKeypress: _cache[1] || (_cache[1] = withKeys(withModifiers(() => {
                  }, ["stop"]), ["space"]))
                }, {
                  icon: withCtx(() => [
                    createVNode(unref(IconArrowsChevronDownRounded24), {
                      class: normalizeClass(["s-table-card__expand-icon", { "s-table-card__expand-icon_active": _ctx.expanded }])
                    }, null, 8, ["class"])
                  ]),
                  default: withCtx(() => [
                    createTextVNode(" Expand ")
                  ]),
                  _: 1
                })) : unref(isDetailsColumn)(column) ? (openBlock(), createBlock(_sfc_main$K, {
                  key: 2,
                  type: "outline",
                  size: "sm",
                  "icon-position": "right",
                  onClick: _cache[2] || (_cache[2] = withModifiers(($event) => emit("click:details"), ["stop"])),
                  onKeypress: _cache[3] || (_cache[3] = withKeys(withModifiers(() => {
                  }, ["stop"]), ["space"]))
                }, {
                  icon: withCtx(() => [
                    createVNode(unref(IconArrowRight16))
                  ]),
                  default: withCtx(() => [
                    createTextVNode(" Page details ")
                  ]),
                  _: 1
                })) : createCommentVNode("", true)
              ], 40, _hoisted_4$2)
            ], 64);
          }), 128))
        ]),
        _ctx.activeExpandColumn && _ctx.expanded ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
          _ctx.activeExpandColumn.cellSlot ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.activeExpandColumn.cellSlot), normalizeProps(mergeProps({ key: 0 }, { "row": _ctx.row.data, "column": _ctx.activeExpandColumn, "rowIndex": _ctx.row.index })), null, 16)) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ], 42, _hoisted_1$3);
    };
  }
});

const STableCard_vue_vue_type_style_index_0_lang = '';

const _hoisted_1$2 = ["onClick", "onContextmenu"];
const _hoisted_2$2 = {
  key: 0,
  class: "s-table__cards-grid"
};
const _hoisted_3$2 = ["onMouseenter", "onMouseleave", "onClick", "onDblclick", "onContextmenu"];
const _hoisted_4$1 = {
  key: 0,
  class: "s-table__expanded-block"
};
const _hoisted_5$1 = ["colspan"];
const _hoisted_6$1 = {
  key: 2,
  class: "s-table__empty-block"
};
const _hoisted_7 = { class: "s-table__empty-text flex justify-center items-center min-h-60px sora-tpg-p3" };
const _hoisted_8 = {
  key: 3,
  class: "s-table__append-wrapper"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  __name: "STable",
  props: {
    data: { default: () => [] },
    defaultSort: { default: null },
    height: { default: "" },
    maxHeight: { default: "" },
    fit: { type: Boolean, default: true },
    showHeader: { type: Boolean, default: true },
    highlightCurrentRow: { type: Boolean, default: false },
    currentRowKey: { default: "" },
    rowClassName: { type: [String, Function], default: "" },
    rowStyle: { type: [Object, Function], default: () => ({}) },
    cellClassName: { type: [String, Function], default: "" },
    cellStyle: { type: [Object, Function], default: () => ({}) },
    headerRowClassName: { type: [String, Function], default: "" },
    headerRowStyle: { type: [Object, Function], default: () => ({}) },
    headerCellClassName: { type: [String, Function], default: "" },
    headerCellStyle: { type: [Object, Function], default: () => ({}) },
    rowKey: { type: [String, Function, null], default: null },
    emptyText: { default: "" },
    defaultExpandAll: { type: Boolean, default: false },
    expandRowKeys: { default: () => [] },
    selectOnIndeterminate: { type: Boolean, default: true },
    adaptBreakpoint: { default: TABLE_DEFAULT_ADAPT_BREAKPOINT },
    cardGridBreakpoints: { default: () => TABLE_CARDS_GRID_DEFAULT_BREAKPOINTS }
  },
  emits: ["mouse-enter:cell", "mouse-leave:cell", "click:cell", "dblclick:cell", "click:header", "contextmenu:header", "click:row", "dblclick:row", "contextmenu:row", "change:sort", "change:selection", "select-all", "select", "change:expand", "change:current", "click:row-details"],
  setup(__props, { expose: __expose, emit }) {
    const props = __props;
    useCssVars((_ctx) => ({
      "49a64073": unref(cardsGridColumnNumber)
    }));
    const columns = shallowReactive([]);
    const { data, selectOnIndeterminate, fit, showHeader, height, maxHeight, expandRowKeys, currentRowKey } = toRefs(props);
    const rowKeys = shallowReactive(/* @__PURE__ */ new Map());
    const keyRows = shallowReactive(/* @__PURE__ */ new Map());
    const activeExpandColumn = computed(() => findLast(columns, isExpandColumn));
    const activeSelectionColumn = computed(() => findLast(columns, isSelectionColumn));
    const tableWrapper = ref(null);
    const tableSizes = reactive({
      height: 0,
      width: 0
    });
    watchOnce(
      tableWrapper,
      () => {
        if (!tableWrapper.value || !(tableWrapper.value instanceof HTMLElement)) {
          return;
        }
        const { width, height: height2 } = tableWrapper.value.getBoundingClientRect();
        tableSizes.width = width;
        tableSizes.height = height2;
      },
      { immediate: true }
    );
    useResizeObserver(tableWrapper, (entries) => {
      setTimeout(() => {
        tableSizes.width = entries[0].contentRect.width;
        tableSizes.height = entries[0].contentRect.height;
      });
    });
    const isAdapted = eagerComputed(() => {
      return tableSizes.width <= props.adaptBreakpoint;
    });
    const cardsGridColumnNumber = eagerComputed(() => {
      return props.cardGridBreakpoints.find((x) => x.test(tableSizes.width))?.value ?? 1;
    });
    const headerWrapper = ref(null);
    const headerHeight = ref(0);
    useResizeObserver(headerWrapper, (entries) => {
      setTimeout(() => {
        headerHeight.value = entries[0].contentRect.height;
      });
    });
    whenever(not(showHeader), () => {
      headerHeight.value = 0;
    });
    const { columnsWidths, columnsWidthsSum } = useFlexColumns(columns, toRef(tableSizes, "width"), fit);
    const { tableHeightStyles, bodyHeightStyles } = useTableHeights({
      propHeight: height,
      propMaxHeight: maxHeight,
      headerHeight,
      tableHeight: toRef(tableSizes, "height")
    });
    const { expandedRows, toggleRowExpanded } = useColumnExpand();
    const { sortState, sortedData, sortExplicitly, handleSortChange, getNextOrder, applyCurrentSort, clearSort } = useColumnSort(data);
    const { selectedRows, isAllSelected, isSomeSelected, toggleAllSelection, toggleRowSelection } = useRowSelect(
      sortedData,
      reactive({ selectOnIndeterminate })
    );
    const currentRow = shallowRef(null);
    function isCurrentRow(row) {
      return currentRow.value === toRaw(row);
    }
    function setCurrentRow(row) {
      currentRow.value = toRaw(row);
    }
    watch([keyRows, currentRowKey], () => {
      setCurrentRow(keyRows.get(currentRowKey.value) ?? null);
    });
    const isSortedOnce = ref(false);
    if (props.defaultSort) {
      watchOnce(toRef(sortState, "column"), () => {
        isSortedOnce.value = true;
      });
    }
    if (props.defaultExpandAll) {
      data.value.forEach((row) => toggleRowExpanded(row));
    }
    watch([data, columns], () => {
      if (props.defaultSort && !isSortedOnce.value) {
        sort(props.defaultSort);
        return;
      }
      applyCurrentSort();
    });
    watch(
      data,
      () => {
        rowKeys.clear();
        keyRows.clear();
        if (props.rowKey) {
          data.value.forEach((row) => {
            const key = getRowKey(row);
            rowKeys.set(row, key);
            keyRows.set(key, row);
          });
        }
      },
      { immediate: true }
    );
    watch([keyRows, expandRowKeys], () => {
      expandedRows.clear();
      expandRowKeys.value.forEach((key) => {
        const row = keyRows.get(key);
        if (row) {
          toggleRowExpanded(row, true);
        }
      });
    });
    let storedSelectedRowsKeys = [];
    watch(keyRows, () => {
      selectedRows.clear();
      if (activeSelectionColumn.value?.reserveSelection) {
        const newStoredSelectedRowsKeys = [];
        storedSelectedRowsKeys.forEach((key) => {
          const row = keyRows.get(key);
          if (row) {
            toggleRowSelection(row);
            newStoredSelectedRowsKeys.push(key);
          }
        });
        storedSelectedRowsKeys = newStoredSelectedRowsKeys;
      }
    });
    function manualToggleAllSelection() {
      if (activeSelectionColumn.value) {
        toggleAllSelection(activeSelectionColumn.value.selectable);
        storedSelectedRowsKeys = [...selectedRows].map((row) => rowKeys.get(row));
      }
    }
    function manualToggleRowSelection(row, value) {
      toggleRowSelection(row, value);
      storedSelectedRowsKeys = [...selectedRows].map((row2) => rowKeys.get(row2));
    }
    function manualClearSelection() {
      selectedRows.clear();
      storedSelectedRowsKeys = [];
    }
    function register(column) {
      const index = columns.push(column);
      onScopeDispose(() => {
        columns.splice(index, 1);
      });
    }
    const api = readonly({ register });
    provide(TABLE_API_KEY, api);
    function getColumnByProp(prop) {
      return columns.filter(isDefaultColumn).find((column) => column.prop === prop);
    }
    function sort({ prop, order }) {
      const column = getColumnByProp(prop);
      if (column) {
        sortExplicitly(column, order);
      }
    }
    __expose({
      /**
       * used in multiple selection Table, clear user selection
       * */
      clearSelection: manualClearSelection,
      /**
       * used in multiple selection Table, toggle if a certain row is selected.
       * With the second parameter, you can directly set if this row is selected
       * */
      toggleRowSelection: manualToggleRowSelection,
      /**
       * used in multiple selection Table, toggle the selected state of all rows
       * */
      toggleAllSelection: manualToggleAllSelection,
      /**
       * used in expandable Table or tree Table, toggle if a certain row is expanded.
       * With the second parameter, you can directly set if this row is expanded or collapsed
       * */
      toggleRowExpansion: toggleRowExpanded,
      /**
       * sort Table manually. Property prop is used to set sort column, property order is used to set sort order
       * */
      sort,
      /**
       * clear sorting, restore data to the original order
       * */
      clearSort,
      /**
       * used in single selection Table, set a certain row selected.
       * If called without any parameter, it will clear selection.
       * */
      setCurrentRow
    });
    function getRowKey(row) {
      if (typeof props.rowKey === "string") {
        if (props.rowKey.includes(".")) {
          return row[props.rowKey];
        }
        let keys = props.rowKey.split(".");
        let current = row;
        for (let key of keys) {
          if (isRecord(current) && key in current) {
            current = current[key];
          }
        }
        return current;
      }
      if (typeof props.rowKey === "function") {
        return props.rowKey(row);
      }
    }
    function getStyleOrClass(prop, args) {
      if (typeof prop === "function") {
        return prop(args);
      }
      return prop || void 0;
    }
    function isRowSelectable(row, index) {
      return !!(activeSelectionColumn?.value && (!activeSelectionColumn.value.selectable || activeSelectionColumn.value.selectable(row, index)));
    }
    function getTemplateRowKey(row, rowIndex) {
      const res = props.rowKey ? rowKeys.get(row) : rowIndex;
      if (typeof res === "string" || typeof res === "number" || typeof res === "symbol") {
        return res;
      }
      return JSON.stringify(res);
    }
    function getSortIconStateClasses(column) {
      let order = null;
      if (column === sortState.column) {
        order = sortState.order;
      }
      if (order !== null) {
        return ["s-table__sort-icon_active", order === "ascending" ? "s-table__sort-icon_asc" : "s-table__sort-icon_desc"];
      }
      return [getNextOrder(column, order) === "ascending" ? "s-table__sort-icon_asc" : "s-table__sort-icon_desc"];
    }
    function handleSortClick(column) {
      handleSortChange(column);
      emit("change:sort", { column, prop: column.prop, order: sortState.order });
    }
    function handleAllSelect() {
      manualToggleAllSelection();
      const selectedArray = [...selectedRows];
      emit("select-all", selectedArray);
      emit("change:selection", selectedArray);
    }
    function handleRowSelect(row) {
      manualToggleRowSelection(row);
      const selectedArray = [...selectedRows];
      emit("select", selectedArray, row);
      emit("change:selection", selectedArray);
    }
    function handleRowExpand(row) {
      toggleRowExpanded(row);
      emit("change:expand", row, [...expandedRows]);
    }
    function handleRowDetails(row) {
      emit("click:row-details", row);
    }
    function handleCellMouseEvent(ctx) {
      if (!ctx.event.target) {
        return;
      }
      const rawRow = toRaw(ctx.row);
      switch (ctx.event.type) {
        case "mouseleave": {
          emit("mouse-leave:cell", rawRow, ctx.column, ctx.event.target, ctx.event);
          break;
        }
        case "mouseenter": {
          emit("mouse-enter:cell", rawRow, ctx.column, ctx.event.target, ctx.event);
          break;
        }
        case "click": {
          if (!isAdapted.value && isExpandColumn(ctx.column)) {
            handleRowExpand(rawRow);
            break;
          }
          if (!isAdapted.value && isDetailsColumn(ctx.column)) {
            handleRowDetails(rawRow);
            break;
          }
          const oldCurrentRow = currentRow;
          setCurrentRow(rawRow);
          emit("click:cell", rawRow, ctx.column, ctx.event.target, ctx.event);
          emit("click:row", rawRow, ctx.column, ctx.event);
          emit("change:current", currentRow.value, oldCurrentRow.value);
          break;
        }
        case "dblclick": {
          emit("dblclick:cell", rawRow, ctx.column, ctx.event.target, ctx.event);
          emit("dblclick:row", rawRow, ctx.column, ctx.event);
          break;
        }
        case "contextmenu": {
          emit("contextmenu:row", rawRow, ctx.column, ctx.event);
          break;
        }
      }
    }
    function handleHeaderMouseEvent(ctx) {
      if (!ctx.event.target) {
        return;
      }
      switch (ctx.event.type) {
        case "click": {
          if (!isAdapted.value && isDefaultColumn(ctx.column) && ctx.column.sortable) {
            handleSortClick(ctx.column);
          }
          emit("click:header", ctx.column, ctx.event);
          break;
        }
        case "contextmenu": {
          emit("contextmenu:header", ctx.column, ctx.event);
          break;
        }
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "tableWrapper",
        ref: tableWrapper,
        class: "s-table",
        style: normalizeStyle(unref(tableHeightStyles))
      }, [
        !unref(isAdapted) && unref(showHeader) ? (openBlock(), createElementBlock("div", {
          key: 0,
          ref_key: "headerWrapper",
          ref: headerWrapper,
          class: "s-table__header-wrapper"
        }, [
          createElementVNode("table", {
            class: "s-table__header w-full",
            style: normalizeStyle(`width: ${unref(columnsWidthsSum)}px`)
          }, [
            createElementVNode("thead", null, [
              createElementVNode("tr", {
                class: normalizeClass(["s-table__tr", getStyleOrClass(_ctx.headerRowClassName)]),
                style: normalizeStyle(getStyleOrClass(_ctx.headerRowStyle))
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(columns), (column, columnIndex) => {
                  return openBlock(), createElementBlock("th", {
                    key: column.id,
                    class: normalizeClass(["s-table__th px-0 sora-tpg-ch3", [
                      `s-table__th_align_${column.headerAlign}`,
                      column.className,
                      column.labelClassName,
                      column.id,
                      {
                        "s-table__th_sortable": column.sortable,
                        "cursor-pointer": column.sortable
                      },
                      getStyleOrClass(_ctx.headerCellClassName, { column, columnIndex })
                    ]]),
                    style: normalizeStyle({
                      "width": `${unref(columnsWidths)[columnIndex]}px`,
                      ...getStyleOrClass(_ctx.headerCellStyle, { column, columnIndex })
                    }),
                    onClick: ($event) => handleHeaderMouseEvent({ column, "event": $event }),
                    onContextmenu: ($event) => handleHeaderMouseEvent({ column, "event": $event })
                  }, [
                    unref(isDefaultColumn)(column) ? (openBlock(), createBlock(resolveDynamicComponent(column.sortable ? "button" : "div"), {
                      key: 0,
                      class: "s-table__header-cell inline-flex items-center sora-tpg-ch3 px-16px"
                    }, {
                      default: withCtx(() => [
                        column.headerSlot ? (openBlock(), createBlock(resolveDynamicComponent(column.headerSlot), normalizeProps(mergeProps({ key: 0 }, { column, columnIndex })), null, 16)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                          createTextVNode(toDisplayString(column.label), 1)
                        ], 64)),
                        column.sortable ? (openBlock(), createBlock(unref(IconArrowTop16), {
                          key: 2,
                          class: normalizeClass(["s-table__sort-icon flex-shrink-0 inline ml-10px", getSortIconStateClasses(column)])
                        }, null, 8, ["class"])) : createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)) : createCommentVNode("", true),
                    unref(isSelectionColumn)(column) ? (openBlock(), createBlock(_sfc_main$6, {
                      key: 1,
                      disabled: !unref(data).length,
                      checked: unref(isSomeSelected) ? unref(isAllSelected) ? true : "mixed" : false,
                      onSelect: _cache[0] || (_cache[0] = ($event) => handleAllSelect())
                    }, null, 8, ["disabled", "checked"])) : createCommentVNode("", true)
                  ], 46, _hoisted_1$2);
                }), 128))
              ], 6)
            ])
          ], 4)
        ], 512)) : createCommentVNode("", true),
        createElementVNode("div", {
          class: "s-table__body-wrapper",
          style: normalizeStyle(unref(bodyHeightStyles))
        }, [
          unref(isAdapted) ? (openBlock(), createElementBlock("div", _hoisted_2$2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sortedData), (row, rowIndex) => {
              return openBlock(), createBlock(_sfc_main$3, {
                key: getTemplateRowKey(row, rowIndex),
                class: normalizeClass(["s-table__card", {
                  "s-table__card_first-row": rowIndex < unref(cardsGridColumnNumber),
                  "s-table__card_last-column": !((rowIndex + 1) % unref(cardsGridColumnNumber))
                }]),
                row: { "data": row, "index": rowIndex },
                columns: unref(columns),
                "active-expand-column": unref(activeExpandColumn),
                "active-selection-column": unref(activeSelectionColumn),
                expanded: unref(expandedRows).has(row),
                selectable: isRowSelectable(row, rowIndex),
                selected: unref(selectedRows).has(row),
                "onMouseEvent:label": handleHeaderMouseEvent,
                "onMouseEvent:value": handleCellMouseEvent,
                onSelect: ($event) => handleRowSelect(row),
                onExpand: ($event) => handleRowExpand(row),
                "onClick:details": ($event) => handleRowDetails(row)
              }, null, 8, ["class", "row", "columns", "active-expand-column", "active-selection-column", "expanded", "selectable", "selected", "onSelect", "onExpand", "onClick:details"]);
            }), 128))
          ])) : (openBlock(), createElementBlock("table", {
            key: 1,
            class: "s-table__body w-full",
            style: normalizeStyle({ "width": `${unref(columnsWidthsSum)}px` })
          }, [
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(sortedData), (row, rowIndex) => {
                return openBlock(), createElementBlock(Fragment, {
                  key: getTemplateRowKey(row, rowIndex)
                }, [
                  createElementVNode("tr", {
                    class: normalizeClass(["s-table__tr", [
                      getStyleOrClass(_ctx.rowClassName, { row, rowIndex }),
                      { "s-table__tr_current": _ctx.highlightCurrentRow && isCurrentRow(row) }
                    ]]),
                    style: normalizeStyle(getStyleOrClass(_ctx.rowStyle, { row, rowIndex }))
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(unref(columns), (column, columnIndex) => {
                      return openBlock(), createElementBlock("td", {
                        key: column.id,
                        class: normalizeClass(["s-table__td p-0 sora-tpg-p3", [
                          `s-table__td_align_${column.align}`,
                          column.id,
                          column.className,
                          getStyleOrClass(_ctx.cellClassName, { row, rowIndex, column, columnIndex })
                        ]]),
                        style: normalizeStyle({
                          "width": rowIndex === 0 ? `${unref(columnsWidths)[columnIndex]}px` : "",
                          ...getStyleOrClass(_ctx.cellStyle, { row, rowIndex, column, columnIndex })
                        }),
                        onMouseenter: ($event) => handleCellMouseEvent({ row, column, "event": $event }),
                        onMouseleave: ($event) => handleCellMouseEvent({ row, column, "event": $event }),
                        onClick: ($event) => handleCellMouseEvent({ row, column, "event": $event }),
                        onDblclick: ($event) => handleCellMouseEvent({ row, column, "event": $event }),
                        onContextmenu: ($event) => handleCellMouseEvent({ row, column, "event": $event })
                      }, [
                        unref(isDefaultColumn)(column) ? (openBlock(), createBlock(_sfc_main$7, {
                          key: 0,
                          tooltip: unref(getCellTooltipContent)(row, column)
                        }, {
                          default: withCtx(() => [
                            column.cellSlot ? (openBlock(), createBlock(resolveDynamicComponent(column.cellSlot), normalizeProps(mergeProps({ key: 0 }, { row, column, rowIndex })), null, 16)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                              createTextVNode(toDisplayString(unref(getDefaultCellValue)(row, column, rowIndex)), 1)
                            ], 64))
                          ]),
                          _: 2
                        }, 1032, ["tooltip"])) : unref(isSelectionColumn)(column) ? (openBlock(), createBlock(_sfc_main$6, {
                          key: 1,
                          disabled: !isRowSelectable(row, rowIndex),
                          checked: unref(selectedRows).has(row),
                          onSelect: ($event) => handleRowSelect(row)
                        }, null, 8, ["disabled", "checked", "onSelect"])) : unref(isExpandColumn)(column) ? (openBlock(), createBlock(_sfc_main$5, {
                          key: 2,
                          active: unref(expandedRows).has(row)
                        }, null, 8, ["active"])) : unref(isDetailsColumn)(column) ? (openBlock(), createBlock(_sfc_main$4, { key: 3 })) : createCommentVNode("", true)
                      ], 46, _hoisted_3$2);
                    }), 128))
                  ], 6),
                  unref(activeExpandColumn) && unref(expandedRows).has(row) ? (openBlock(), createElementBlock("tr", _hoisted_4$1, [
                    createElementVNode("td", {
                      class: "s-table__expanded-cell py-16px px-32px",
                      colspan: unref(columns).length
                    }, [
                      unref(activeExpandColumn).cellSlot ? (openBlock(), createBlock(resolveDynamicComponent(unref(activeExpandColumn).cellSlot), normalizeProps(mergeProps({ key: 0 }, { row, "column": unref(activeExpandColumn), rowIndex })), null, 16)) : createCommentVNode("", true)
                    ], 8, _hoisted_5$1)
                  ])) : createCommentVNode("", true)
                ], 64);
              }), 128))
            ])
          ], 4)),
          !unref(data).length ? (openBlock(), createElementBlock("div", _hoisted_6$1, [
            renderSlot(_ctx.$slots, "empty", {}, () => [
              createElementVNode("div", _hoisted_7, [
                renderSlot(_ctx.$slots, "empty-text", {}, () => [
                  createTextVNode(toDisplayString(_ctx.emptyText || "No Data"), 1)
                ])
              ])
            ])
          ])) : createCommentVNode("", true),
          _ctx.$slots.append ? (openBlock(), createElementBlock("div", _hoisted_8, [
            renderSlot(_ctx.$slots, "append")
          ])) : createCommentVNode("", true)
        ], 4),
        renderSlot(_ctx.$slots, "default")
      ], 4);
    };
  }
});

const STable_vue_vue_type_style_index_0_lang = '';

const STableColumn = /* @__PURE__ */ defineComponent({
  name: "STableColumn",
  props: {
    /**
     * Column type
     */
    type: {
      type: String,
      default: "default"
    },
    /**
     * Column label (in header)
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Prop name from a data row
     */
    prop: {
      type: String,
      default: ""
    },
    /**
     * Column width
     */
    width: {
      type: String,
      default: ""
    },
    /**
     * Column minimum width. Columns with `width` prop has a fixed width, while columns with `min-width`
     * prop has a width that is distributed in proportion
     */
    minWidth: {
      type: String,
      default: "80"
    },
    /**
     * Whether column can be sorted. Remote sorting can be done by setting
     * this attribute to `custom` and listening to the `sort-change` event of the table component
     */
    sortable: {
      type: [Boolean, String],
      default: false
    },
    /**
     * Sorting method, works when `sortable` prop is set to `true`.
     * Should return a number, just like `Array.sort` expects
     */
    sortMethod: {
      type: Function,
      default: null
    },
    /**
     * Specify which property to sort by. Works when `sortable` prop is set to `true` and `sort-method` isn't set.
     * If set to an Array, the column will sequentially sort by the next property if the previous one is equal
     */
    sortBy: {
      type: [String, Function, Array],
      default: ""
    },
    /**
     * The order of the sorting strategies used when sorting the data, works when sortable is true.
     * Accepts an array, as the user clicks on the header, the column is sorted in order of the elements in the array
     */
    sortOrders: {
      type: Array,
      default: () => ["ascending", "descending", null]
    },
    /**
     * Function that formats cell content
     */
    formatter: {
      type: Function,
      default: null
    },
    /**
     * Whether to hide extra content and show them in a tooltip when hovering on the cell
     */
    showOverflowTooltip: {
      type: Boolean,
      default: false
    },
    /**
     * Content alignment
     */
    align: {
      type: String,
      default: "left"
    },
    /**
     * Header alignment. Fallbacks to `align` prop value by default.
     */
    headerAlign: {
      type: String,
      default: null
    },
    /**
     * Class name of cells in the column
     */
    className: {
      type: String,
      default: ""
    },
    /**
     * Class name of the label of this column
     */
    labelClassName: {
      type: String,
      default: ""
    },
    /**
     * Function that determines if a certain row can be selected, works when type is 'selection'
     */
    selectable: {
      type: Function,
      default: null
    },
    /**
     * Whether to reserve selection after data refreshing, works when type is 'selection'.
     * Note that row-key is required for this to work
     */
    reserveSelection: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const tableApi = useTableApi();
    const slots = useSlots();
    const filterProp = usePropTypeFilter(props);
    const definitelyType = filterProp("type", TABLE_COLUMN_TYPE_VALUES, "default");
    const definitelyAlign = filterProp("align", TABLE_COLUMN_ALIGN_VALUES, "left");
    const definitelyHeaderAlign = filterProp("headerAlign", [null, ...TABLE_COLUMN_ALIGN_VALUES], null);
    const widthsPresets = {
      selection: {
        width: 52,
        minWidth: 52
      },
      expand: {
        width: 52,
        minWidth: 52
      },
      details: {
        width: 40,
        minWidth: 40
      }
    };
    const widthProps = computed(() => {
      if (definitelyType.value !== "default") {
        return widthsPresets[definitelyType.value];
      }
      return {
        width: parseInt(props.width, 10) || null,
        minWidth: parseInt(props.minWidth, 10) || 80
      };
    });
    const sortProps = computed(() => {
      return {
        sortable: props.sortable === "custom" ? "custom" : Boolean(props.sortable),
        sortMethod: props.sortMethod,
        sortBy: props.sortBy,
        sortOrders: props.sortOrders
      };
    });
    const api = shallowReactive({
      id: uniqueElementId()
    });
    watchEffect(() => {
      api.type = definitelyType.value;
      api.cellSlot = slots.default;
      api.headerSlot = slots.header;
      api.prop = props.prop;
      api.label = props.label;
      api.showOverflowTooltip = props.showOverflowTooltip;
      api.align = definitelyAlign.value;
      api.headerAlign = definitelyHeaderAlign.value || definitelyAlign.value;
      api.className = props.className;
      api.labelClassName = props.labelClassName;
      api.formatter = props.formatter;
      api.selectable = props.selectable;
      api.reserveSelection = props.reserveSelection;
      api.width = widthProps.value.width;
      api.minWidth = widthProps.value.minWidth;
      api.sortable = sortProps.value.sortable;
      api.sortMethod = sortProps.value.sortMethod;
      api.sortBy = sortProps.value.sortBy;
      api.sortOrders = sortProps.value.sortOrders;
    });
    tableApi.register(api);
    return () => null;
  }
});

const _hoisted_1$1 = { class: "s-pagination__sizes whitespace-nowrap mr-24px flex items-center" };
const _hoisted_2$1 = { class: "s-pagination__sizes-label sora-tpg-p4 mr-8px" };
const _hoisted_3$1 = { class: "s-pagination__count whitespace-nowrap sora-tpg-p4 flex items-center" };
const _hoisted_4 = { class: "s-pagination__pages flex items-center" };
const _hoisted_5 = ["onClick", "onMouseenter", "onMouseleave", "onFocus", "onBlur"];
const _hoisted_6 = {
  key: 0,
  class: "s-pagination__arrows flex items-center ml-16px"
};
const PAGINATION_MAX_PAGES_SELECTABLE = 7;
const PAGINATION_BREAKPOINT_WIDTH = 480;
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "SPagination",
  props: {
    total: { default: 0 },
    pageSize: { default: null },
    currentPage: { default: 1 },
    pageSizes: { default: () => [10, 50, 100] },
    sizesLabel: { default: "Rows per page" }
  },
  emits: ["click:prev", "click:next", "update:currentPage", "update:pageSize"],
  setup(__props, { emit }) {
    const props = __props;
    const PAGINATION_JUMP_SIZE = PAGINATION_MAX_PAGES_SELECTABLE - 2;
    const current = useVModel(props, "currentPage", emit, { passive: true });
    const size = useVModel(props, "pageSize", emit, { passive: true });
    const numericSize = computed({
      get: () => {
        return size.value ?? (props.pageSizes[0] || 10);
      },
      set: (value) => {
        size.value = value;
      }
    });
    const sizeOptions = computed(() => props.pageSizes.map((size2) => ({ label: String(size2), value: size2 })));
    const pagesNum = eagerComputed(() => Math.max(1, Math.ceil(props.total / numericSize.value)));
    const isCurrentFirst = eagerComputed(() => current.value === 1);
    const isCurrentLast = eagerComputed(() => current.value === pagesNum.value);
    const isAbleJumpPrev = eagerComputed(() => current.value >= PAGINATION_JUMP_SIZE);
    const isAbleJumpNext = eagerComputed(() => current.value <= pagesNum.value - PAGINATION_JUMP_SIZE + 1);
    const shouldShowControls = eagerComputed(() => pagesNum.value > PAGINATION_MAX_PAGES_SELECTABLE);
    const firstItemNum = eagerComputed(() => (current.value - 1) * numericSize.value + 1);
    const lastItemNum = eagerComputed(() => Math.min(props.total, current.value * numericSize.value));
    const isJumpPrevButtonHovered = ref(false);
    whenever(not(isAbleJumpPrev), () => {
      isJumpPrevButtonHovered.value = false;
    });
    const isJumpNextButtonHovered = ref(false);
    whenever(not(isAbleJumpNext), () => {
      isJumpNextButtonHovered.value = false;
    });
    const pagination = ref(null);
    const paginationContainerWidth = ref(0);
    useResizeObserver(pagination, (entries) => {
      setTimeout(() => {
        paginationContainerWidth.value = entries[0].contentRect.width;
      });
    });
    const paginationLeftPanel = ref(null);
    const paginationLeftPanelWidth = ref(0);
    useResizeObserver(paginationLeftPanel, (entries) => {
      setTimeout(() => {
        paginationLeftPanelWidth.value = entries[0].contentRect.width;
      });
    });
    const paginationRightPanel = ref(null);
    const paginationRightPanelWidth = ref(0);
    useResizeObserver(paginationRightPanel, (entries) => {
      setTimeout(() => {
        paginationRightPanelWidth.value = entries[0].contentRect.width;
      });
    });
    const shouldWrap = computed(() => {
      return paginationContainerWidth.value < paginationLeftPanelWidth.value + paginationRightPanelWidth.value || paginationContainerWidth.value <= PAGINATION_BREAKPOINT_WIDTH;
    });
    watch(pagesNum, () => {
      if (pagesNum.value < current.value) {
        current.value = pagesNum.value;
      }
    });
    function toggleJumpButtonHover(page, value) {
      if (page === "jumpNext") {
        isJumpNextButtonHovered.value = value;
      }
      if (page === "jumpPrev") {
        isJumpPrevButtonHovered.value = value;
      }
    }
    const pageButtons = computed(() => {
      const res = [];
      for (let i = 1; i <= pagesNum.value; i++) {
        if (shouldShowControls.value && i === pagesNum.value && isAbleJumpNext.value) {
          res.push("jumpNext");
        }
        if (isPageVisible(i)) {
          res.push(i);
        }
        if (shouldShowControls.value && i === 1 && isAbleJumpPrev.value) {
          res.push("jumpPrev");
        }
      }
      return res;
    });
    function isPageVisible(page) {
      return !shouldShowControls.value || current.value === page || page === 1 || page === pagesNum.value || !isAbleJumpNext.value && page >= pagesNum.value - PAGINATION_JUMP_SIZE || !isAbleJumpPrev.value && page <= PAGINATION_JUMP_SIZE + 1 || isAbleJumpNext.value && isAbleJumpPrev.value && Math.abs(current.value - page) < PAGINATION_JUMP_SIZE / 2;
    }
    function handleJumpClick(value) {
      if (value === "jumpNext") {
        if (isAbleJumpNext.value) {
          current.value = Math.min(pagesNum.value, current.value + PAGINATION_JUMP_SIZE);
        }
        return;
      }
      if (value === "jumpPrev") {
        if (isAbleJumpPrev.value) {
          current.value = Math.max(0, current.value - PAGINATION_JUMP_SIZE);
        }
        return;
      }
      current.value = value;
    }
    function handleNextClick() {
      if (isCurrentLast.value) {
        return;
      }
      const newPage = current.value + 1;
      emit("click:next", newPage);
      current.value = newPage;
    }
    function handlePrevClick() {
      if (isCurrentFirst.value) {
        return;
      }
      const newPage = current.value - 1;
      emit("click:prev", newPage);
      current.value = newPage;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        ref_key: "pagination",
        ref: pagination,
        class: "s-pagination flex flex-wrap justify-between flex-row-reverse"
      }, [
        createElementVNode("div", {
          class: normalizeClass(["order-last flex", {
            "basis-full justify-center mt-16px": unref(shouldWrap)
          }])
        }, [
          createElementVNode("div", {
            ref_key: "paginationLeftPanel",
            ref: paginationLeftPanel,
            class: "flex"
          }, [
            createElementVNode("div", _hoisted_1$1, [
              createElementVNode("div", _hoisted_2$1, toDisplayString(_ctx.sizesLabel), 1),
              createVNode(unref(_sfc_main$r), {
                modelValue: unref(numericSize),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => isRef(numericSize) ? numericSize.value = $event : null),
                size: "sm",
                options: unref(sizeOptions)
              }, null, 8, ["modelValue", "options"])
            ]),
            createElementVNode("div", _hoisted_3$1, [
              renderSlot(_ctx.$slots, "progress", normalizeProps(guardReactiveProps({ firstItemNum: unref(firstItemNum), lastItemNum: unref(lastItemNum), total: _ctx.total })), () => [
                createTextVNode(toDisplayString(unref(firstItemNum)) + "—" + toDisplayString(unref(lastItemNum)) + " of " + toDisplayString(_ctx.total), 1)
              ])
            ])
          ], 512)
        ], 2),
        createElementVNode("div", {
          class: normalizeClass(["order-first flex", {
            "basis-full justify-center": unref(shouldWrap)
          }])
        }, [
          createElementVNode("div", {
            ref_key: "paginationRightPanel",
            ref: paginationRightPanel,
            class: "flex"
          }, [
            createElementVNode("div", _hoisted_4, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(pageButtons), (pageButton) => {
                return openBlock(), createElementBlock("button", {
                  key: pageButton,
                  class: normalizeClass(["s-pagination__button flex justify-center min-w-24px sora-tpg-h7", {
                    "s-pagination__button_active": unref(current) === pageButton,
                    "ml-4px": Number(pageButton) > 1
                  }]),
                  onClick: ($event) => handleJumpClick(pageButton),
                  onMouseenter: ($event) => toggleJumpButtonHover(pageButton, true),
                  onMouseleave: ($event) => toggleJumpButtonHover(pageButton, false),
                  onFocus: ($event) => toggleJumpButtonHover(pageButton, true),
                  onBlur: ($event) => toggleJumpButtonHover(pageButton, false)
                }, [
                  pageButton === "jumpPrev" ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    unref(isJumpPrevButtonHovered) ? (openBlock(), createBlock(unref(IconChevronsLeft16), {
                      key: 0,
                      class: "s-pagination__button-icon"
                    })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(" … ")
                    ], 64))
                  ], 64)) : pageButton === "jumpNext" ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    unref(isJumpNextButtonHovered) ? (openBlock(), createBlock(unref(IconChevronsRight16), {
                      key: 0,
                      class: "s-pagination__button-icon"
                    })) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                      createTextVNode(" … ")
                    ], 64))
                  ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                    createTextVNode(toDisplayString(pageButton), 1)
                  ], 64))
                ], 42, _hoisted_5);
              }), 128))
            ]),
            unref(shouldShowControls) ? (openBlock(), createElementBlock("div", _hoisted_6, [
              createElementVNode("button", {
                class: normalizeClass(["s-pagination__button w-24px h-24px mr-8px", {
                  "s-pagination__button_disabled": unref(isCurrentFirst)
                }]),
                onClick: handlePrevClick
              }, [
                createVNode(unref(IconArrowsChevronLeftXs24), { class: "s-pagination__button-icon" })
              ], 2),
              createElementVNode("button", {
                class: normalizeClass(["s-pagination__button w-24px h-24px", {
                  "s-pagination__button_disabled": unref(isCurrentLast)
                }]),
                onClick: handleNextClick
              }, [
                createVNode(unref(IconArrowsChevronRightXs24), { class: "s-pagination__button-icon" })
              ], 2)
            ])) : createCommentVNode("", true)
          ], 512)
        ], 2)
      ], 512);
    };
  }
});

const SPagination_vue_vue_type_style_index_0_lang = '';

const _hoisted_1 = { class: "s-tooltip__body sora-tpg-p4 px-16px py-12px" };
const _hoisted_2 = {
  key: 0,
  class: "sora-tpg-p1 mb-4px"
};
const _hoisted_3 = {
  key: 1,
  class: "mt-8px py-4px"
};
const __default__ = {
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...__default__,
  __name: "STooltip",
  props: {
    wrapperTag: { default: "div" },
    content: { default: "" },
    header: { default: "" },
    placement: { default: "bottom" },
    primaryButtonText: { default: "" },
    secondaryButtonText: { default: "" }
  },
  emits: ["click:primary-button", "click:secondary-button"],
  setup(__props, { emit }) {
    function handlePrimaryButtonClick() {
      emit("click:primary-button");
    }
    function handleSecondaryButtonClick() {
      emit("click:secondary-button");
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(SPopover), {
        distance: "4",
        placement: _ctx.placement
      }, {
        trigger: withCtx(() => [
          (openBlock(), createBlock(resolveDynamicComponent(_ctx.wrapperTag), normalizeProps(guardReactiveProps(_ctx.$attrs)), {
            default: withCtx(() => [
              renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 16))
        ]),
        popper: withCtx(() => [
          createVNode(unref(SPopoverWrappedTransition), { name: "tooltip-default-transition" }, {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1, [
                _ctx.$slots.header || _ctx.header ? (openBlock(), createElementBlock("div", _hoisted_2, [
                  renderSlot(_ctx.$slots, "header", {}, () => [
                    createTextVNode(toDisplayString(_ctx.header), 1)
                  ])
                ])) : createCommentVNode("", true),
                createElementVNode("div", null, [
                  renderSlot(_ctx.$slots, "content", {}, () => [
                    createTextVNode(toDisplayString(_ctx.content), 1)
                  ])
                ]),
                _ctx.primaryButtonText || _ctx.secondaryButtonText ? (openBlock(), createElementBlock("div", _hoisted_3, [
                  _ctx.primaryButtonText ? (openBlock(), createBlock(unref(_sfc_main$K), {
                    key: 0,
                    class: "s-tooltip__button first:mr-8px",
                    type: "outline",
                    size: "sm",
                    onClick: handlePrimaryButtonClick
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.primaryButtonText), 1)
                    ]),
                    _: 1
                  })) : createCommentVNode("", true),
                  _ctx.secondaryButtonText ? (openBlock(), createBlock(unref(_sfc_main$K), {
                    key: 1,
                    class: "s-tooltip__button",
                    type: "outline",
                    size: "sm",
                    onClick: handleSecondaryButtonClick
                  }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(_ctx.secondaryButtonText), 1)
                    ]),
                    _: 1
                  })) : createCommentVNode("", true)
                ])) : createCommentVNode("", true)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 8, ["placement"]);
    };
  }
});

const STooltip_vue_vue_type_style_index_0_lang = '';

const COMPONENTS = {
  SButton: _sfc_main$K,
  // SJsonInput,
  SModal: _sfc_main$I,
  SModalCard: _sfc_main$H,
  SSelect: _sfc_main$t,
  SDropdown: _sfc_main$r,
  SSelectBase: _sfc_main$C,
  SSelectButton,
  SSelectChevron: component,
  SSelectInput: _sfc_main$z,
  SSelectOption: _sfc_main$v,
  SToastsDisplay: _sfc_main$E,
  SToastsProvider,
  SNotificationBody: _sfc_main$F,
  SNotificationsProvider: component$1,
  SUseNotification,
  SAlert: _sfc_main$M,
  SSpinner,
  SPopover,
  SPopoverWrappedTransition,
  SSwitch,
  STextField: _sfc_main$A,
  SProgressBar: _sfc_main$f,
  STab: _sfc_main$d,
  STabsPanel,
  STable: _sfc_main$2,
  STableColumn,
  SBadge: _sfc_main$c,
  SAccordion: _sfc_main$N,
  SAccordionItem: _sfc_main$O,
  SLink: _sfc_main$J,
  SRadio: _sfc_main$y,
  SRadioAtom,
  SRadioGroup: _sfc_main$x,
  SCollapseTransition: _sfc_main$P,
  SCheckboxAtom,
  SCheckboxSolo: _sfc_main$w,
  SBodyScrollLockProvider,
  SNavigationMenu: _sfc_main$9,
  SNavigationMenuItem: _sfc_main$a,
  SNavigationSubmenu: _sfc_main$8,
  SPagination: _sfc_main$1,
  STooltip: _sfc_main,
  SDatePicker: _sfc_main$g
};

const windi = '';

function plugin() {
  return (app) => {
    for (const comp of Object.values(COMPONENTS)) {
      const name = getComponentName(comp);
      app.component(name, comp);
    }
  };
}

export { ACCORDION_API_KEY, BODY_SCROLL_LOCK_API_KEY, BUTTON_ICON_POSITION_VALUES, BUTTON_SIZE_VALUES, BUTTON_TYPE_VALUES, BadgeTypes, RADIO_SIZE_VALUES as CHECKBOX_SIZE_VALUES, RADIO_TYPE_VALUES as CHECKBOX_TYPE_VALUES, FONT_SIZE, LINK_ICON_POSITION_VALUES, LINK_UNDERLINE_TYPE_VALUES, MODAL_API_KEY, NAVIGATION_MENU_API_KEY, NAVIGATION_SUBMENU_API_KEY, NOTIFICATIONS_API_KEY, POPOVER_API_KEY, RADIO_GROUP_API_KEY, RADIO_SIZE_VALUES, RADIO_TYPE_VALUES, _sfc_main$N as SAccordion, _sfc_main$O as SAccordionItem, _sfc_main$M as SAlert, _sfc_main$c as SBadge, SBodyScrollLockProvider, _sfc_main$K as SButton, SCheckboxAtom, _sfc_main$w as SCheckboxSolo, _sfc_main$P as SCollapseTransition, _sfc_main$g as SDatePicker, _sfc_main$r as SDropdown, SELECT_API_KEY, _sfc_main$J as SLink, _sfc_main$I as SModal, _sfc_main$H as SModalCard, _sfc_main$9 as SNavigationMenu, _sfc_main$a as SNavigationMenuItem, _sfc_main$8 as SNavigationSubmenu, _sfc_main$F as SNotificationBody, component$1 as SNotificationsProvider, SPINNER_SIZE, SPINNER_WIDTH, _sfc_main$1 as SPagination, SPopover, SPopoverWrappedTransition, _sfc_main$f as SProgressBar, _sfc_main$y as SRadio, SRadioAtom, _sfc_main$x as SRadioGroup, _sfc_main$t as SSelect, _sfc_main$C as SSelectBase, SSelectButton, component as SSelectChevron, _sfc_main$z as SSelectInput, _sfc_main$v as SSelectOption, SSpinner, SSwitch, _sfc_main$d as STab, _sfc_main$2 as STable, STableColumn, STabsPanel, _sfc_main$A as STextField, _sfc_main$E as SToastsDisplay, SToastsProvider, _sfc_main as STooltip, SUseNotification, SelectButtonType, SelectOptionType, SelectSize, Status, TABLE_API_KEY, TABLE_CARDS_GRID_DEFAULT_BREAKPOINTS, TABLE_COLUMN_ALIGN_VALUES, TABLE_COLUMN_TYPE_VALUES, TABLE_DEFAULT_ADAPT_BREAKPOINT, TABS_PANEL_API_KEY, TABS_PANEL_BACKGROUND_TYPES, TOASTS_API_KEY, defineToastsApi, plugin, useAccordionApi, useBodyScrollLockIfPossible, useModalApi, useNavigationMenuApi, useNavigationSubmenuApi, useNotifications, usePopoverApi, useRadioGroupApi, useSelectApi, useTableApi, useTabsPanelApi };
//# sourceMappingURL=lib.mjs.map
